export const translations = {
  ro: {
    nav: {
      home: 'Acasă',
      features: 'Soluții',
      blog: 'Blog',
      about: 'Despre',
      contact: 'Contact',
      demo: 'Demo Gratuit',
      costCenters: 'Centre Cost',
      hrPontaj: 'HR & Pontaj',
      logistics: 'Logistică',
      procurement: 'Achiziții',
      equipment: 'Echipamente',
      documents: 'Documente'
    },
    home: {
      hero: {
        badge: 'Platformă de Management - Dezvoltată de Constructori pentru Constructori',
        title: 'Control total asupra fiecărui centru de cost',
        subtitle: 'Vizibilitate completă în timp real asupra cheltuielilor pe proiecte, șantiere și echipe. Raportare automată și control granular al bugetelor.',
        challenges: 'Provocările actuale:',
        challenge1: 'Lipsa vizibilității în timp real asupra costurilor',
        challenge2: 'Raportare manuală consumatoare de timp',
        challenge3: 'Dificultăți în controlul bugetelor pe proiecte',
        ctaCalculator: 'Calculează Pierderi',
        ctaDemo: 'Prezentare Gratuită',
        features: 'Setup profesional • Implementare completă • Suport dedicat',
        trustedBy: 'Soluția preferată de liderii din construcții și servicii',
        live: 'Live'
      },
      stats: {
        title: 'Rezultate măsurabile',
        costReduction: 'Reducere costuri',
        teamEfficiency: 'Eficiență echipă',
        stockOptimization: 'Optimizare stocuri'
      },
      digital: {
        title: 'Prezentul e pe șantier, viitorul e digital',
        subtitle: 'De la teren la birou, automat',
        description: 'Fiecare acțiune din teren se transformă instant în date structurate, rapoarte și decizii inteligente',
        timeTracking: {
          title: 'Pontaje automate cu recunoaștere facială',
          description: 'Angajații se pontează direct din telefon cu cod unic și poză. Datele apar instant în sistem - zero hârtii, zero erori.',
          badge: 'Sincronizare instantă'
        },
        gpsTracking: {
          title: 'Tracking GPS și consum combustibil live',
          description: 'Monitorizare completă flotă cu GPS integrat. Alimentările de la Rompetrol & OMV apar automat legate de vehicul și șantier.',
          badge: 'Integrare directă Rompetrol & OMV'
        },
        procurement: {
          title: 'Achiziții sincronizate cu devizele',
          description: 'Fiecare comandă de materiale se leagă automat de proiect și centru de cost. Stocurile se actualizează instant la livrare.',
          badge: 'Raportare automată'
        },
        documents: {
          title: 'Contracte și documente inteligente',
          description: 'AI extrage automat date din PDF-uri, generează contracte și trimite notificări pentru termene. Zero procesare manuală.',
          badge: 'Powered by AI'
        },
        result: {
          title: 'Rezultat: control complet, zero efort manual',
          description: 'Tu te concentrezi pe decizii strategice. Platforma se ocupă de colectare, procesare și raportare.'
        },
        features: {
          costCenters: 'Centre de cost',
          costCentersDesc: 'Monitorizare nelimitată pe proiecte, șantiere și departamente',
          instantReporting: 'Raportare instantă',
          instantReportingDesc: 'Date în timp real disponibile imediat pentru decizie',
          fullControl: 'Control complet',
          fullControlDesc: 'Vizibilitate totală asupra fiecărui element de cost'
        }
      },
      mobileApp: {
        title: 'Aplicație Mobilă pentru Teren',
        subtitle: 'Totul la îndemână, direct din șantier',
        description: 'Aplicația mobilă ControlMax transformă smartphone-ul în centrul de comandă al șantierului. Gestionare completă, fără hârtii, fără birou.',
        features: {
          timeTracking: {
            title: 'Pontaj Oameni & Utilaje',
            description: 'Pontaj simplu cu recunoaștere facială. Înregistrare prezență pentru angajați și ore lucrate pentru utilaje - totul cu un tap.'
          },
          equipment: {
            title: 'Gestionare Echipamente',
            description: 'Scanare QR pentru inventar rapid. Atribuire echipamente pe angajați și urmărire locație în timp real.'
          },
          stock: {
            title: 'Stoc cu o Fotografie',
            description: 'AI recunoaște materialele din poză. Adaugă sau scoate din stoc instant - fără formulare, fără introducere manuală.'
          },
          dailyProgram: {
            title: 'Program Zilei',
            description: 'Lista de task-uri pentru fiecare echipă. Actualizări în timp real și sincronizare automată cu biroul.'
          },
          reports: {
            title: 'Rapoarte Instant',
            description: 'Generare raport de șantier cu câteva tap-uri. Poze, consumuri, probleme - totul centralizat și trimis automat.'
          },
          routeSheets: {
            title: 'Foi de Parcurs Automate',
            description: 'GPS tracking automat pentru vehicule. Foi de parcurs generate automat cu trasee reale și consumuri.'
          }
        },
        cta: 'Testează aplicația',
        ctaSubtitle: 'Download gratuit • Fără card necesar'
      },
      easyToUse: {
        title: 'Simplu. Intuitiv. Ușor de folosit.',
        subtitle: 'Fără curbe de învățare. Fără complicații. Echipa ta își va da seama cum funcționează în 5 minute.',
        features: {
          noTraining: {
            title: 'Zero pregătire necesară',
            description: 'Interfață intuitivă, gândită pentru oameni din teren. Înveți din mers.'
          },
          instantStart: {
            title: 'Start instant',
            description: 'Te conectezi și începi să lucrezi imediat. Configurare sub 10 minute.'
          },
          everywhere: {
            title: 'Funcționează oriunde',
            description: 'Desktop, tablet, telefon. Online sau offline. Sincronizare automată.'
          }
        }
      },
      dashboard: {
        title: 'Date live din teren',
        subtitle: 'Control pe centre de cost în timp real',
        description: 'Fiecare pontaj, consum de combustibil și achiziție actualizat automat din teren. Date precise, decizii rapide.',
        heading: 'Dashboard Centre de Cost',
        subheading: 'Date actualizate automat din teren',
        live: 'Live',
        projects: {
          bucharest: 'Șantier București Nord',
          cluj: 'Proiect Cluj',
          timisoara: 'Șantier Timișoara'
        },
        costs: {
          materials: 'Materiale:',
          labor: 'Forță muncă:',
          equipment: 'Utilaje:'
        },
        updated: {
          now2min: 'Actualizat acum 2 min',
          now5min: 'Actualizat acum 5 min',
          now1min: 'Actualizat acum 1 min'
        },
        liveTitle: 'Date live din teren',
        autoUpdate: 'Actualizare automată la fiecare acțiune',
        features: {
          timeTracking: 'Pontaje și prezențe sincronizate instant din telefoanele echipelor',
          fuel: 'Alimentari integrate automat din Rompetrol & OMV',
          gps: 'Tracking GPS utilaje cu consum în timp real',
          procurement: 'Achiziții materiale automat legate de centre de cost'
        },
        cta: 'Solicită prezentare live',
        ctaSubtitle: 'Vezi platforma în acțiune cu datele tale reale'
      },
      features: {
        title: 'Funcționalități Complete',
        subtitle: 'Tot Ce Ai Nevoie Într-Un Singur Loc',
        description: 'Platformă completă cu toate instrumentele pentru control total',
        hr: {
          title: 'HR & Pontaj',
          description: 'Gestionare automată timp de lucru, prezență și concedii. Rapoarte instant pentru fiecare angajat.'
        },
        logistics: {
          title: 'Logistică & Flote',
          description: 'Tracking GPS în timp real. Optimizare rute și reducere costuri cu până la 25%.'
        },
        procurement: {
          title: 'Achiziții & Stocuri',
          description: 'Control complet aprovizionare. Automatizare comenzi și predicție necesități.'
        },
        equipment: {
          title: 'Inventar Echipamente',
          description: 'Evidență completă utilaje. Planificare mentenanță predictivă cu AI.'
        },
        documents: {
          title: 'Management Documente',
          description: 'Digitalizare completă. Generare automată rapoarte cu semnătură electronică.'
        },
        analytics: {
          title: 'Analytics AI',
          description: 'Dashboard-uri interactive. Analiză predictivă și recomandări AI în timp real.'
        },
        fuel: {
          title: 'Stații Carburant',
          description: 'Integrare directă pompe. Monitorizare consum și detectare anomalii automat.'
        },
        costCenters: {
          title: 'Centre de Cost',
          description: 'Alocare automată pe proiecte. Bugetare inteligentă și alerte predictive.'
        },
        security: {
          title: 'Securitate Enterprise',
          description: 'Protecție nivel bancar. Conformitate GDPR și backup în timp real.'
        }
      },
      benefits: {
        title: 'Rezultate măsurabile',
        subtitle: 'Date reale de la companii care utilizează platforma ControlMax',
        costReduction: {
          percentage: '23%',
          title: 'Reducere costuri operaționale',
          description: 'Media pe primul an de utilizare'
        },
        efficiency: {
          percentage: '30%',
          title: 'Creștere eficiență echipă',
          description: 'Optimizare procesări și raportări'
        },
        stock: {
          percentage: '41%',
          title: 'Optimizare gestiune stocuri',
          description: 'Reducere costuri de inventar'
        },
        roi: {
          title: 'ROI în 90 de Zile',
          description: 'Investiția ta se recuperează în mai puțin de 3 luni prin reducerea costurilor operaționale și creșterea productivității.'
        },
        automation: {
          title: 'Automatizare 100% Procese',
          description: 'Zero task-uri repetitive. Echipa ta se concentrează pe ce contează cu adevărat.'
        },
        ai: {
          title: 'Predicții AI în Timp Real',
          description: 'Inteligență artificială îți anticipează problemele și sugerează soluții înainte să devină critice.'
        },
        scale: {
          title: 'Scalare Nelimitată',
          description: 'De la 10 la 10,000 utilizatori. Platforma crește automat cu businessul tău.'
        },
        support: {
          title: 'Suport Premium 24/7',
          description: 'Echipă dedicată disponibilă non-stop. Răspuns rapid la orice întrebare.'
        },
        integrations: {
          title: 'Integrări API Unlimited',
          description: 'Conectare instant cu orice sistem. API deschis și documentație completă.'
        }
      },
      testimonials: {
        title: 'Ce Spun Clienții Noștri',
        subtitle: 'Antreprenori care au făcut tranziția la digital',
        testimonial1: {
          text: 'Implementarea ControlMax a transformat complet modul în care gestionăm proiectele. Vizibilitatea în timp real ne permite să luăm decizii informate rapid.',
          author: 'Director General',
          role: 'M.I.S Group'
        },
        testimonial2: {
          text: 'Reducerea costurilor operaționale a fost semnificativă în primele 6 luni. Raportarea automată ne economisește zeci de ore lunar.',
          author: 'Director General',
          role: 'Unitip Global'
        },
        testimonial3: {
          text: 'Platforma este intuitivă și ușor de adoptat de către echipă. Suportul tehnic este excelent și răspunde prompt la orice întrebare.',
          author: 'Andrei Vasile',
          role: 'Director Operațiuni, MegaServ'
        }
      },
      howItWorks: {
        title: 'Implementare Rapidă',
        subtitle: 'Start În 3 Pași Simpli',
        description: 'Implementare adaptată nevoilor companiei tale',
        step1: {
          number: '01',
          title: 'Implementare Personalizată',
          description: 'Discutăm nevoile fiecărei companii și construim soluția potrivită. Import date din orice sistem și configurare AI personalizată pentru businessul tău.'
        },
        step2: {
          number: '02',
          title: 'Onboarding Premium',
          description: 'Specialist dedicat instruiește echipa ta. Video tutorials interactive și suport live pentru fiecare utilizator.'
        },
        step3: {
          number: '03',
          title: 'Launch & Scale',
          description: 'Go live cu sistem complet funcțional. Monitorizare 24/7 și optimizare continuă cu AI pentru rezultate maxime.'
        }
      },
      cta: {
        title: 'Pregătit să vezi diferența?',
        subtitle: 'Rezervă o prezentare live și descoperi cum ControlMax poate revoluționa modul în care gestionezi businessul',
        button: 'Programează Demo',
        buttonAlt: 'Discută cu un Specialist',
        guarantee: 'Prezentare personalizată 30 min • Fără costuri • Fără obligații'
      },
      faq: {
        title: 'Întrebări Frecvente despre Platformă de Management pentru Construcții',
        subtitle: 'Răspunsuri la cele mai comune întrebări despre implementarea unui sistem de management pentru construcții și servicii',
        contact: 'Mai ai întrebări despre cum ControlMax poate ajuta firma ta de construcții?',
        contactButton: 'Contactează-ne pentru detalii',
        questions: [
          {
            question: 'Ce este o platformă de management pentru construcții și cum ajută firma mea?',
            answer: 'O platformă de management pentru construcții este un sistem software integrat care centralizează toate procesele operaționale: management proiecte, pontaj HR, tracking GPS flota, logistică, achizitii, centre de cost și documente. ControlMax automatizează fluxurile de lucru, oferă raportare în timp real și elimină munca manuală repetitivă, reducând costurile operaționale cu până la 23% și crescând eficiența echipei cu 30%.'
          },
          {
            question: 'Cum functionează sistemul de centre de cost pentru șantiere?',
            answer: 'Centrele de cost în ControlMax permit urmărirea exactă a tuturor cheltuielilor și veniturilor pentru fiecare proiect sau șantier separat. Fiecare pontaj, factura, aviz de materiale sau cost cu combustibil se alocă automat centrului de cost corespunzător. Ai vizibilitate completă în timp real asupra profitabilității fiecărui șantier, poți compara performanța între proiecte și iei decizii rapide bazate pe date concrete, nu estimări.'
          },
          {
            question: 'Cum ajută tracking-ul GPS la reducerea costurilor cu flota?',
            answer: 'Sistemul GPS ControlMax monitorizează în timp real toate vehiculele și utilajele de construcții. Detectează automat rutele neoptimale, consumurile excesive de combustibil, opriri neprogramate și utilizarea neautorizată. Prin integrare cu Rompetrol, OMV și alte stații, verifici automat fiecare alimentare și elimini frauda. Firmele reduc costuri cu combustibilul cu 15-25% în primele 3 luni și optimizează utilizarea flotei prin alocare inteligentă pe șantiere.'
          },
          {
            question: 'Ce înseamnă pontaj HR automatizat și de ce e mai bun decât Excel?',
            answer: 'Pontajul HR automatizat înlocuiește foile Excel și evidența manuală cu un sistem digital accesibil de pe telefon sau tabletă. Angajații pontează prin recunoaștere facială sau GPS, datele se sincronizează instant în cloud, iar raportarea către salarizare se face automat. Elimină erorile umane, fraudele de pontaj (când colegi pontează unul pentru altul), și economisește 10-15 ore/lună de muncă administrativă. Integrarea cu centre de cost alocă automat costul forței de muncă pe fiecare șantier.'
          },
          {
            question: 'Cât durează implementarea și când vedem rezultate?',
            answer: 'Implementarea ControlMax durează între 2-4 săptămâni, în funcție de mărimea companiei și complexitatea proceselor. În primele 7 zile, sistemul de pontaj și tracking GPS sunt deja funcționale. Rezultatele apar rapid: reducere erori administrative în primele 2 săptămâni, vizibilitate completă costuri în luna 1, ROI complet (recuperare investiție) în 90 de zile prin reducerea costurilor operaționale. Clientii raportează economii medii de 23% în primul an.'
          },
          {
            question: 'Este potrivit pentru firme mici sau doar pentru companii mari?',
            answer: 'ControlMax este scalabil și se adaptează perfect atât firmelor mici (5-20 angajați, 1-3 șantiere) cât și companiilor mari (100+ angajați, 10+ șantiere). Firmele mici beneficiază de automatizare și organizare fără să angajeze personal administrativ suplimentar. Companiile mari câștigă control centralizat și raportare consolidată pe toate diviziile. Prețul se ajustează în funcție de numărul utilizatori și module folosite, astfel încât investiția să fie proporțională cu dimensiunea businessului.'
          },
          {
            question: 'Ce diferențiază ControlMax de alte soluții pentru construcții?',
            answer: 'ControlMax este singurul sistem construit specific pentru piața românească de construcții și servicii, cu integrări native pentru Rompetrol, OMV, legislație locală RO și limba română. Spre deosebire de soluții generice sau adaptări după sisteme internationale, ControlMax înțelege specificul șantierelor românești: pontaj cu card sau facial, tracking combustibil cu integrare pumpe locale, raportare conform cerințelor ITM și fiscale RO. Plus, suport tehnic în română disponibil rapid, nu call center extern.'
          },
          {
            question: 'Cum se integrează cu sistemele existente (contabilitate, salarizare)?',
            answer: 'ControlMax se integrează prin API cu majoritatea sistemelor de contabilitate și salarizare folosite în România (Saga, SAP, WizOne, Clarvision, etc). Datele de pontaj, facturi, avize se exportă automat în formatul necesar pentru sistemul tău existent. Nu trebuie să înlocuiești tot - ControlMax vine peste procesele operaționale (tracking, pontaj, logistică, șantier) și alimentează automat sistemele financiare back-office. Implementarea include configurarea tuturor integrărilor necesare.'
          },
          {
            question: 'Este sigur să țin toate datele companiei într-un sistem cloud?',
            answer: 'Da, securitatea este prioritate. ControlMax folosește criptare nivel bancar (AES-256) pentru toate datele, hosting în datacentere certificate în UE (GDPR compliant), backup automat zilnic și recuperare disaster recovery în maximum 4 ore. Datele tale sunt mai sigure în cloud decât pe un laptop sau server local nesecurizat. Ai control total asupra acceselor: ce utilizator vede ce date, istoric complet modificări, și drept de export oricând. Conformitate 100% GDPR și legislație românească protecție date.'
          },
          {
            question: 'Oferă ControlMax aplicație mobilă pentru șantier și teren?',
            answer: 'Da, ControlMax oferă aplicații mobile native pentru iOS și Android optimizate pentru lucru în teren pe șantiere. Funcționează și offline (sincronizare când reapare internetul), permit pontaj angajati, fotografiere avize livrare cu OCR (recunoaștere automată text), raportare incidente, tracking GPS, și acces la documente proiecte. Interfața este simplă, adaptată pentru ecrane mici și mănuși de lucru, astfel încât și șefii de șantier mai puțin tehnici să o folosească ușor.'
          }
        ]
      }
    },
    contact: {
      title: 'Contact',
      subtitle: 'Suntem aici să vă ajutăm. Contactați-ne pentru orice întrebare sau pentru a programa o demonstrație.',
      phone: {
        title: 'Telefon',
        number: '0787 683 304',
        schedule: 'Luni - Vineri: 09:00 - 18:00'
      },
      email: {
        title: 'Email',
        address: 'contact@controlmax.ro',
        response: 'Răspundem în maximum 24 de ore'
      },
      form: {
        title: 'Trimite-ne un mesaj',
        name: 'Nume complet',
        namePlaceholder: 'Ion Popescu',
        email: 'Email',
        emailPlaceholder: 'ion@companie.ro',
        company: 'Companie',
        companyPlaceholder: 'Nume companie',
        phone: 'Telefon',
        phonePlaceholder: '+40 7XX XXX XXX',
        message: 'Mesaj',
        messagePlaceholder: 'Spune-ne cum te putem ajuta...',
        submit: 'Trimite mesaj',
        submitting: 'Se trimite...'
      },
      success: {
        title: 'Mulțumim pentru mesaj!',
        message: 'Mesajul tău a fost trimis cu succes. Te vom contacta în curând.'
      },
      error: {
        message: 'A apărut o eroare. Te rugăm să încerci din nou.'
      },
      demo: {
        title: 'Vrei o demonstrație live?',
        description: 'Programează o sesiune de 30 de minute cu un specialist ControlMax și vezi platforma în acțiune cu datele tale reale.',
        cta: 'Prezentare Gratuită →'
      }
    },
    despre: {
      badge: 'Despre ControlMax',
      hero: {
        title1: 'Construit Din Experiență',
        title2: 'Pentru Constructori',
        subtitle: 'ControlMax nu este doar software. Este soluția creată din provocările reale ale șantierului, împreună cu ingineri și antreprenori care știu ce înseamnă să construiești.'
      },
      story: {
        icon: 'Lightbulb',
        title: 'Povestea Noastră',
        paragraph1: 'ControlMax s-a născut pe șantier, nu într-un birou de IT. Totul a început când am văzut cum inginerii și antreprenorii se luptă zilnic cu procese învechite, evidențe pe hârtie și lipsa vizibilității asupra resurselor și costurilor.',
        paragraph2: 'Am petrecut luni întregi alături de profesioniști din construcții - șefi de șantier, ingineri constructori, directori tehnici, antreprenori și administratori de flote. Am ascultat fiecare frustrare, fiecare nevoie nesatisfăcută, fiecare oră pierdută din cauza lipsei de informație în timp real.',
        paragraph3: 'Fiecare funcționalitate din ControlMax vine direct din teren.',
        paragraph3Prefix: 'Fiecare funcționalitate din ControlMax vine direct din teren. ',
        paragraph3Rest: 'Mentenanța predictivă pentru utilaje? Ideea unui director de parc auto care pierdea zeci de mii de euro pe reparații de urgență. Pontajul automat cu GPS? Cererea unui antreprenor care gestiona 15 șantiere simultan și pierdea controlul asupra orelor lucrate. Managementul achizițiilor inteligent? Soluția la problema unui administrator care nu putea urmări mii de comenzi și furnizori.',
        paragraph4: 'Am transformat toate aceste nevoi reale în funcționalități concrete, testate și rafinate împreună cu cei care le folosesc zi de zi. Rezultatul este o platformă care înțelege cu adevărat provocările din construcții și oferă soluții care funcționează în practică, nu doar în teorie.'
      },
      values: {
        title: 'Valorile Noastre',
        subtitle: 'Principiile care ghidează fiecare decizie și linie de cod din ControlMax.',
        practical: {
          title: 'Practic și Aplicat',
          description: 'Construim doar funcționalități care rezolvă probleme reale de pe șantier. Zero features inutile.'
        },
        users: {
          title: 'Ascultat Folositorii',
          description: 'Dezvoltarea e ghidată de feedback constant de la ingineri și antreprenori activi.'
        },
        support: {
          title: 'Suport Dedicat',
          description: 'Echipă care înțelege construcțiile și răspunde rapid, în română, 24/7.'
        },
        innovation: {
          title: 'Inovație Constantă',
          description: 'Îmbunătățim continuu platforma cu AI și tehnologii noi, fără costuri extra.'
        }
      },
      mission: {
        title: 'Misiunea Noastră',
        paragraph1: 'Să digitalizăm și să transformăm industria construcțiilor din România prin tehnologie accesibilă, inteligentă și adaptată nevoilor reale din teren.',
        paragraph2: 'Credem că fiecare constructor, indiferent de mărime, merită acces la instrumente de nivel enterprise care îi ajută să reducă pierderile, să optimizeze resursele și să crească profitabilitatea.',
        paragraph3: 'Vrem ca la finalul fiecărei zile, managerii să știe exact ce s-a întâmplat pe șantier, cât a costat și cum pot îmbunătăți procesele.',
        stats: {
          companies: {
            number: 'Zeci de',
            label: 'Companii Active'
          },
          users: {
            number: '1,000+',
            label: 'Utilizatori Zilnici'
          },
          projects: {
            number: '€15M+',
            label: 'Proiecte Gestionate'
          },
          satisfaction: {
            number: '98%',
            label: 'Satisfacție Clienți'
          }
        }
      },
      benefits: {
        title: 'De Ce Aleg Constructorii ControlMax',
        subtitle: 'Beneficii concrete măsurate de companiile care folosesc platforma.',
        efficiency: {
          title: 'Eficiență cu 40% Mai Mare',
          description: 'Automatizarea proceselor elimină munca repetitivă și reduce timpul petrecut pe administrare cu aproape jumătate.'
        },
        reduction: {
          title: 'Reducere 30% Pierderi',
          description: 'Vizibilitatea totală asupra resurselor și costurilor identifică și previne pierderile înainte să devină probleme majore.'
        },
        ai: {
          title: 'AI Care Învață din Datele Tale',
          description: 'Sistemul devine mai inteligent cu fiecare proiect, oferind predicții și recomandări tot mai precise.'
        }
      },
      faq: {
        title: 'Întrebări Frecvente Despre ControlMax',
        subtitle: 'Tot ce trebuie să știi despre compania și platforma noastră.',
        q1: {
          question: 'Cine este în spatele ControlMax și de ce pot avea încredere în această platformă?',
          answer: 'ControlMax este dezvoltat de o echipă mixtă de ingineri software și profesioniști din construcții cu experiență combinată de peste 50 de ani în industrie. Fondatorii au lucrat direct pe șantiere și înțeleg provocările reale cu care te confrunți zilnic. Platforma este folosită de zeci de companii din România care gestionează proiecte în valoare totală de peste €15 milioane. Avem o rată de satisfacție de 98% și suport tehnic dedicat în română disponibil 24/7. Nu suntem o companie software generică care a făcut un produs pentru construcții - suntem oameni din industrie care am construit soluția de care noi înșine aveam nevoie.'
        },
        q2: {
          question: 'Cum diferă ControlMax de alte platforme de management pentru construcții?',
          answer: 'Diferența fundamentală este că ControlMax a fost construit DIN experiența directă de pe șantier, nu pentru ea. În timp ce alte soluții sunt platforme generice adaptate pentru construcții sau sisteme complicate făcute pentru corporații mari, noi am pornit de la nevoile specifice ale constructorilor români. FIECARE FUNCȚIONALITATE vine din probleme reale întâlnite pe teren și a fost testată de ingineri și antreprenori activi. Nu te obligăm să îți adaptezi procesele la software - software-ul se adaptează la cum lucrezi deja. Plus inteligența artificială integrată care învață continuu din datele tale și devine mai utilă cu timpul. Și cel mai important: implementare rapidă (2-4 săptămâni vs 6-12 luni la alte soluții) și preț accesibil pentru companii de orice mărime.'
        },
        q3: {
          question: 'De câte timp există ControlMax pe piață și este o soluție stabilă sau încă în dezvoltare?',
          answer: 'ControlMax este pe piață din 2020 și platforma este perfect stabilă și matură pentru producție. În acești ani am implementat sistemul la zeci de companii - de la antreprenori mici cu 10 angajați până la firme mari cu 200+ angajați și zeci de șantiere simultane. Platforma procesează zilnic mii de tranzacții (pontaje, locații GPS, comenzi, facturi) fără probleme. STABILITATE și FIABILITATE sunt prioritatea #1 - știm că te bazezi pe sistem pentru operațiuni critice zilnice. În același timp, îmbunătățim CONTINUU platforma cu funcționalități noi bazate pe feedback-ul tău, dar toate update-urile sunt testate exhaustiv înainte de lansare. Primești gratuit toate noile funcționalități fără costuri suplimentare - investiția ta este protejată pe termen lung.'
        },
        q4: {
          question: 'Cum asigurați securitatea datelor și ce se întâmplă cu informațiile companiei mele?',
          answer: 'Securitatea datelor este EXTREM de serioasă pentru noi. Toate datele sunt stocate în datacenter-uri certificate în Uniunea Europeană (conformitate GDPR completă), criptare militară AES-256 pentru toate datele stocate și în tranzit (aceleași standarde folosite de bănci), backup automat zilnic în multiple locații geografice - datele tale sunt în siguranță chiar în caz de dezastru, acces controlat strict prin autentificare cu doi factori (2FA) și permisiuni granulare pe roluri. PROPRIETATEA: Tu ești proprietarul datelor tale 100%. Noi doar le stocăm și procesăm pentru tine - nu le vindem, nu le partajăm, nu le folosim pentru altceva decât serviciul tău. Poți exporta toate datele oricând în format standard. CONFIDENȚIALITATE: Echipa noastră semnează acorduri de confidențialitate și are acces limitat doar pentru suport tehnic când tu solici explicit. Audituri de securitate regulate efectuate de companii externe. Track record impecabil - zero breșe de securitate în toți anii de funcționare.'
        },
        q5: {
          question: 'Ce nivel de suport tehnic și training oferă ControlMax și cât de ușor este să învăț să folosesc sistemul?',
          answer: 'Suportul și training-ul sunt incluse COMPLET în abonament fără costuri extra. ONBOARDING COMPLET: Consultant dedicat care configurează sistemul specific pentru nevoile tale, sesiuni de training live (online sau la sediul tău) pentru toată echipa, materiale video și documentație scrisă detaliată în română. SUPORT CONTINUU 24/7: Echipă de suport în română disponibilă prin telefon, email și chat în aplicație, timp mediu de răspuns sub 2 ore (mai rapid pentru urgențe critice), specialiști care înțeleg construcțiile și vorbesc limba ta - nu outsourcing în străinătate. UȘURINȚĂ ÎN UTILIZARE: Interfața este intuitivă - majoritatea utilizatorilor învață funcțiile de bază în 30 minute, aplicație mobilă simplă pentru șantier - lucrătorii o folosesc fără training complicat, nu ai nevoie de cunoștințe IT avansate. UPDATE-URI și TRAINING NOU: Când adăugăm funcționalități noi, primești notificări și mini-tutoriale, sesiuni periodice de refresh pentru a folosi sistemul la maxim. Reușita ta = reușita noastră, așa că investim serios în suportul tău.'
        }
      },
      cta: {
        title: 'Gata Să Transformi Modul în Care Construiești?',
        description: 'Alătură-te zecilor de companii care au ales să construiască mai inteligent cu ControlMax.',
        button: 'Solicită Demo Gratuită'
      }
    },
    demo: {
      badge: 'Descoperă ControlMax',
      title: 'Solicită o Prezentare Gratuită',
      subtitle: 'Programează o sesiune personalizată de 30 de minute cu un specialist și vezi cum ControlMax poate transforma modul în care îți gestionezi businessul',
      whatYouWillDiscover: {
        title: 'Ce vei descoperi în demo?',
        platformInAction: {
          title: 'Platforma în acțiune',
          description: 'Vezi funcționalitățile live și cum funcționează în scenarii reale'
        },
        customSolutions: {
          title: 'Soluții personalizate',
          description: 'Analizăm nevoile tale și îți arătăm exact ce te ajută'
        },
        answers: {
          title: 'Răspunsuri la întrebări',
          description: 'Discutăm despre implementare, costuri și beneficii'
        },
        implementationPlan: {
          title: 'Plan de implementare',
          description: 'Primești un roadmap clar pentru integrarea în compania ta'
        }
      },
      noObligations: {
        title: 'Fără Obligații',
        description: 'Prezentarea nu implică niciun angajament. Vei vedea platforma în detaliu și vei decide în propria linie de timp.',
        duration: 'Durata: 30 de minute'
      },
      form: {
        title: 'Completează formularul',
        lastName: 'Nume',
        lastNamePlaceholder: 'Popescu',
        firstName: 'Prenume',
        firstNamePlaceholder: 'Ion',
        email: 'Email',
        emailPlaceholder: 'ion.popescu@companie.ro',
        phone: 'Telefon',
        phonePlaceholder: '0712 345 678',
        company: 'Companie',
        companyPlaceholder: 'SC Compania Mea SRL',
        numberOfEmployees: 'Număr angajați',
        selectPlaceholder: 'Selectează',
        employeesRange: {
          '1-10': '1-10',
          '11-50': '11-50',
          '51-200': '51-200',
          '201-500': '201-500',
          '500+': '500+'
        },
        industry: 'Domeniu',
        industries: {
          construction: 'Construcții',
          services: 'Servicii',
          logistics: 'Logistică',
          production: 'Producție',
          other: 'Altele'
        },
        message: 'Mesaj (opțional)',
        messagePlaceholder: 'Spune-ne mai multe despre nevoile tale...',
        submitButton: 'Trimite Cererea',
        submittingButton: 'Se trimite...',
        privacyText: 'Prin trimiterea formularului, ești de acord cu',
        privacyLink: 'Politica de Confidențialitate',
        required: '*'
      },
      success: {
        title: 'Mulțumim pentru interes!',
        description: 'Cererea ta a fost înregistrată cu succes. Un specialist din echipa noastră te va contacta în următoarele 24 de ore pentru a programa demo-ul personalizat.',
        whatNext: {
          title: 'Ce urmează?',
          step1: 'Un consultant te va contacta pentru a stabili o dată convenabilă',
          step2: 'Vom pregăti o prezentare adaptată nevoilor tale',
          step3: 'Vei vedea platforma în acțiune cu exemple concrete'
        },
        backButton: 'Înapoi la pagina principală'
      },
      error: 'A apărut o eroare. Te rugăm să încerci din nou.'
    },
    footer: {
      tagline: 'Platformă de Management - Dezvoltată de Constructori pentru Constructori',
      solutions: 'Soluții',
      company: 'Companie',
      legal: 'Legal',
      terms: 'Termeni și Condiții',
      privacy: 'Politica de Confidențialitate',
      gdpr: 'GDPR',
      newsletter: {
        title: 'Rămâi la curent',
        description: 'Primești lunar sfaturi practice pentru construcții și actualizări despre industrie.',
        placeholder: 'Email-ul tău',
        button: 'Abonează-te',
        success: 'Te-ai abonat cu succes!',
        error: 'A apărut o eroare. Te rugăm să încerci din nou.'
      },
      rights: 'Toate drepturile rezervate.'
    },
    centreCost: {
      seo: {
        title: 'Centre Cost Constructii Multi-Proiecte Multi-Santier | Software Management Financiar Costuri',
        description: 'Sistem centre cost pentru firme constructii 10-700 angajati: urmarire bugete multi-proiecte, raportare automata cheltuieli, analiza profitabilitate proiecte, monitorizare costuri real-time pe santier. Control financiar total pe proiecte, licitatii, executie. Alocare costuri forta munca materiale utilaje pe centre cost. Software buget enterprise multi-santier Romania.',
        keywords: 'centre cost, centru cost, centre de cost, management financiar constructii, software buget proiecte, urmarire costuri multi-santier, costuri proiect constructii, buget proiect, analiza profitabilitate proiect, raportare costuri automata, alocare costuri forta munca, costuri materiale constructii, costuri utilaje, costuri pe proiect, costuri pe santier, control financiar multi-proiecte, software buget enterprise, management costuri constructii Romania, urmarire buget, deviz proiect, cost direct indirect, profitabilitate proiect, raport costuri real-time, dashboard costuri, alerte depasire buget, software financiar constructii, management financiar firme mijlocii mari, centre cost 10 angajati, centre cost 100 angajati, centre cost 200 angajati, centre cost 500 angajati',
        structuredData: {
          name: 'Centre de Cost - ControlMax',
          description: 'Management avansat centre de cost pentru proiecte de constructii cu urmarire bugete si raportare automata',
          serviceType: 'Software Management Financiar Constructii'
        }
      },
      hero: {
        badge: 'Inima sistemului',
        title: 'Centre de Cost',
        subtitle: 'De la licitație la execuție și închidere. Fiecare proiect urmărit complet, fiecare cost sub control.'
      },
      intro: {
        whatIs: {
          title: 'Ce este un Centru de Cost?',
          description1: 'Centrul de cost este un proiect urmărit complet de la licitație până la închidere. Centralizează datele financiare, administrative și operaționale pentru evidență clară.',
          description2: 'Fiecare pontaj, factură și activitate se leagă automat de centrul de cost, oferind control complet asupra rentabilității.'
        },
        whyEssential: {
          title: 'De ce sunt esențiale?',
          description1: 'Centrele de cost transformă haosul în ordine. Vezi exact costul fiecărui proiect, unde se duc banii și care sunt profiturile reale.',
          description2: 'Date concrete în timp real pentru decizii corecte.'
        }
      },
      lifecycle: {
        title: 'Ciclul complet de viață al unui Centru de Cost',
        subtitle: 'De la oportunitate la profit final',
        phases: {
          bidding: {
            number: '1',
            title: 'Faza de Licitație',
            items: [
              'Crearea centrului de cost din documentația de licitație',
              'Evidență completă a actelor: pregătire, depunere, tracking status',
              'Memento-uri automate pentru termene de depunere',
              'Notificări pentru câștigare sau respingere'
            ]
          },
          offer: {
            number: '2',
            title: 'Importul Ofertei',
            items: [
              'Încărcarea ofertei câștigătoare în sistem',
              'Extragerea automată a tipurilor de lucrări',
              'Structurare pe categorii: materiale, manoperă, utilaje, transport, echipamente',
              'Stabilirea costurilor planificate pentru fiecare categorie'
            ]
          },
          execution: {
            number: '3',
            title: 'Faza de Execuție',
            items: [
              'Memento-uri pentru începere contract, garanții de bună execuție',
              'Toate rapoartele din teren se leagă automat de centrul de cost',
              'Pontaje, consum combustibil, achiziții materiale cumulate instant',
              'Evidență clară: costuri planificate vs. costuri reale în timp real'
            ]
          }
        }
      },
      transparency: {
        title: 'Transparență totală asupra costurilor',
        subtitle: 'Fiecare acțiune din teren se transformă instant în date financiare precise',
        features: {
          realTime: {
            title: 'Actualizare în timp real',
            description: 'Datele din teren ajung instant în centrul de cost. Pontaje, alimentări, achiziții - toate automate.'
          },
          fullControl: {
            title: 'Control complet',
            description: 'Vezi exact unde se duc banii. Compari planificat vs real. Identifici devierile înainte să devină probleme.'
          },
          smartAlerts: {
            title: 'Alerte inteligente',
            description: 'Notificări automate pentru depășiri bugetare, termene de garanții și finaluri de contract.'
          },
          fullHistory: {
            title: 'Istoric complet',
            description: 'Fiecare modificare, cost și document arhivat și accesibil instant.'
          }
        }
      },
      dashboard: {
        badge: 'Date live din teren',
        title: 'Dashboard Centre de Cost în acțiune',
        subtitle: 'Fiecare pontaj, consum de combustibil și achiziție actualizat automat din teren. Date precise, decizii rapide.',
        heading: 'Dashboard Centre de Cost',
        subheading: 'Date actualizate automat din teren',
        live: 'Live',
        projects: {
          bucharest: 'Șantier București Nord',
          cluj: 'Proiect Cluj',
          timisoara: 'Șantier Timișoara'
        },
        costs: {
          materials: 'Materiale:',
          labor: 'Forță muncă:',
          equipment: 'Utilaje:'
        },
        updated: {
          now2min: 'Actualizat acum 2 min',
          now5min: 'Actualizat acum 5 min',
          now1min: 'Actualizat acum 1 min'
        },
        liveData: {
          title: 'Date live din teren',
          subtitle: 'Actualizare automată la fiecare acțiune',
          features: [
            'Pontaje și prezențe sincronizate instant din telefoanele echipelor',
            'Alimentari integrate automat din Rompetrol & OMV',
            'Tracking GPS utilaje cu consum în timp real',
            'Achiziții materiale automat legate de centre de cost'
          ]
        }
      },
      benefits: {
        title: 'Beneficii Concrete ale Sistemului Centre de Cost',
        subtitle: 'Date reale de la companii care utilizează centre de cost în managementul proiectelor de construcții',
        stats: {
          costReduction: {
            percentage: '34%',
            title: 'Reducere costuri operaționale pe proiect',
            description: 'Prin eliminarea risipei și optimizare resurse în primele 6 luni'
          },
          realTime: {
            title: 'Real-time',
            subtitle: 'Vizibilitate completă costuri proiect',
            description: 'Date actualizate automat din teren fără delay sau erori'
          },
          accuracy: {
            percentage: '95%',
            title: 'Acuratețe raportare financiară',
            description: 'Eliminare erori manuale și reconcilieri automate instantanee'
          }
        },
        useCases: {
          title: 'Cazuri de Utilizare Concrete',
          cases: [
            {
              company: 'Firma Construcții București - 15 Șantiere',
              result: 'Reducere 28% costuri operaționale prin identificare rapidă șantiere neprofitabile și realocare resurse în prima lună'
            },
            {
              company: 'Constructor Regional Cluj - 8 Proiecte',
              result: 'Vizibilitate completă profitabilitate per proiect a permis negocieri informate și creștere marjă medie cu 12% în 4 luni'
            },
            {
              company: 'Companie Infrastructură - 25 Contracte',
              result: 'Alocare automată costuri pe centre și raportare consolidată reducea timpul administrativ de la 40 ore la 3 ore lunar'
            }
          ]
        },
        whyEssential: {
          title: 'De ce Centrele de Cost sunt Esențiale',
          reasons: [
            {
              title: 'Control bugetar real:',
              description: 'Fiecare leu cheltuit pe un proiect e tracked și comparat automat cu bugetul planificat'
            },
            {
              title: 'Decizie rapidă informată:',
              description: 'Știi instant care proiecte sunt profitabile și care consumă resurse fără return'
            },
            {
              title: 'Raportare automată stakeholderi:',
              description: 'Generare instant rapoarte financiare pentru investitori, bănci, auditori fără muncă manuală'
            },
            {
              title: 'Învățare și optimizare:',
              description: 'Analiza comparativă între proiecte identifică best practices și probleme recurente pentru îmbunătățire continuă'
            },
            {
              title: 'Conformitate și audit:',
              description: 'Istoric complet modificări și justificări cheltuieli pentru conformitate fiscală și audituri fără stres'
            }
          ]
        }
      },
      faq: {
        title: 'Întrebări Frecvente despre Centre de Cost în Construcții',
        subtitle: 'Răspunsuri la cele mai comune întrebări despre implementarea și utilizarea centrelor de cost pentru proiecte',
        questions: [
          {
            question: 'Ce este exact un centru de cost în contextul construcțiilor și de ce îl necesit?',
            answer: 'Un centru de cost în construcții este o entitate contabilă separată care grupează toate cheltuielile și veniturile asociate unui proiect specific (șantier, contract, licitație). Fiecare pontaj angajat, factură materiale, cost combustibil, aviz transport se alocă automat centrului de cost respectiv. Astfel știi EXACT cât costă fiecare proiect în timp real, poți compara profitabilitatea între șantiere, și iei decizii informate despre alocarea resurselor. Fără centre de cost, toate cheltuielile sunt amestecate și nu poți ști care proiect e profitabil și care pierde bani până la finalul lunii când e prea târziu să intervii.'
          },
          {
            question: 'Cum se alocă automat costurile pe centrele de cost în sistem?',
            answer: 'Alocarea este 100% automată prin integrări directe: 1) Pontajul angajat - când pontează, selectează proiectul/șantierul și costul forței de muncă se alocă instant pe centru cost respectiv. 2) GPS tracking flota - sistemul detectează automat în ce zonă șantier e vehiculul și alocă combustibilul proporțional cu timpul petrecut. 3) Achizitii materiale - la fotografierea avizului de livrare, selectezi centrul de cost și sistemul face legătura automată. 4) Facturi furnizori - la introducere/scanare OCR, specifici proiectul și alocarea e instantanee. Zero calcule manuale, zero Excel, totul tracked în timp real.'
          },
          {
            question: 'Pot avea un angajat sau utilaj care lucrează pe mai multe centre de cost simultan?',
            answer: 'Da, sistemul gestionează perfect scenariul asta comun în construcții. Un angajat care lucrează 3 zile pe Șantier A și 2 zile pe Șantier B va avea costul forței de muncă alocat automat proporțional (3/5 pe A, 2/5 pe B) bazat pe pontajele zilnice unde selectează proiectul. Similar, un buldozer care lucrează dimineața pe un șantier și după-masa pe altul va avea costurile împărțite automat bazat pe tracking GPS care detectează în ce zonă e utilajul. Combustibilul, cheltuielile de întreținere, costul amortizare - toate se împart proporțional fără nicio intervenție manuală.'
          },
          {
            question: 'Ce rapoarte pot genera automat pentru centre de cost și cât de des sunt actualizate?',
            answer: 'Rapoartele sunt generate instant la cerere cu date live din teren: 1) Dashboard profitabilitate - costuri totale vs venituri per centru, actualizat în timp real la fiecare tranzacție. 2) Raport comparativ proiecte - vizualizare side-by-side pentru toate șantierele să vezi care performează. 3) Buget vs Real - comparație automată între costurile planificate din ofertă și cheltuielile reale cumulate. 4) Breakdown pe categorii - detaliere exactă cât ai cheltuit pe materiale, forță muncă, utilaje, transport per proiect. 5) Export financiar - rapoarte formatate pentru contabilitate, investitori, auditori în Excel/PDF. Toate actualizate în timp real, nu mai aștepți sfârșit lună.'
          },
          {
            question: 'Cum ajută centrele de cost la identificarea problemelor în proiecte înainte să devină critice?',
            answer: 'Sistemul monitorizează automat fiecare centru de cost și generează alerte în timp real: 1) Alertă depășire buget - dacă o categorie (ex: materiale) depășește bugetul planificat cu X%, primești notificare instant să investigezi. 2) Alertă trend negativ - dacă rata de consum zilnic indică că vei depăși bugetul total la final, sistemul te avertizează anticipat cu 2-3 săptămâni înainte. 3) Comparație cu proiecte similare - dacă un șantier are costuri semnificativ mai mari decât altele comparabile, vezi discrepanța instant. 4) Anomalii consum - spike neașteptat în combustibil, pontaje excesive, achizitii neplanificate - toate detectate automat. Astfel poți interveni rapid cu măsuri corective când problema e încă mică, nu după 2 luni când ai pierdut deja 50.000 RON.'
          },
          {
            question: 'Cât timp durează să configurez și să devin operațional cu centre de cost pentru proiectele mele?',
            answer: 'Setup-ul inițial durează 2-5 zile lucrătoare: Ziua 1-2: Creare structură centre de cost - adaugi fiecare proiect/șantier activ, configurezi categorii cheltuieli (materiale, forță muncă, etc), definești bugete planificate dacă ai oferte câștigate. Ziua 3: Import istoric opțional - poți importa ultimele 1-3 luni de date pentru context sau poți porni fresh. Ziua 4-5: Training echipă - șefi șantier învață să aloce pontaje și materiale pe centre, manageri învață să interpreteze rapoartele. De la ziua 6 sistemul e live și centrele de cost se populează automat cu fiecare acțiune din teren. În prima săptămână vezi deja vizibilitate completă pe fiecare proiect. Pentru companii mari cu 20+ proiecte, procesul poate dura 2 săptămâni.'
          },
          {
            question: 'Ce se întâmplă cu datele când un proiect se finalizează? Pot face analiză retrospectivă?',
            answer: 'Când un proiect se închide, centrul de cost trece în status \'Finalizat\' dar toate datele rămân accesibile permanent pentru analiză retrospectivă. Ai acces complet la: 1) Istoric financiar complet - toate cheltuielile și veniturile cu detalii granulare de la început până la final. 2) Comparație buget vs real - vezi exact unde ai deviat de la planificare și cu cât. 3) Documente arhivate - toate facturile, avizele, rapoartele, situațiile de lucrări legate de proiect. 4) Analiză profitabilitate - calcul exact profit net, marje, ROI pentru proiect finalizat. 5) Template pentru viitor - poți folosi datele reale ca bază pentru estimări în licitații similare viitoare. Sistemul generează automat un \'Project Closure Report\' cu toate KPI-urile esențiale care devine learning material pentru echipă. Ideal pentru audituri, litigii, sau pur și simplu pentru a îmbunătăți estimările la proiecte viitoare.'
          }
        ]
      },
      cta: {
        title: 'Transformă-ți proiectele în centre de profit',
        subtitle: 'Vezi cum centrele de cost îți pot transforma complet managementul proiectelor și profitabilitatea',
        button: 'Solicită prezentare live'
      }
    },
    hrPontaj: {
      badge: 'Modul HR & Pontaj',
      title: {
        line1: 'HR & Pontaj',
        line2: 'Complet Automatizat'
      },
      subtitle: 'De la pontaj cu recunoaștere facială până la generare automată de contracte. Totul într-o platformă.',
      dashboard: {
        title: 'Dashboard HR Live',
        live: 'LIVE',
        stats: {
          activeEmployees: 'Angajați Activi',
          attendanceToday: 'Prezență Azi',
          onLeave: 'În Concediu'
        },
        cards: {
          timeEntries: {
            title: 'Pontaje Procesate',
            subtitle: 'Ultima oră'
          },
          approvedLeave: {
            title: 'Concedii Aprobate',
            subtitle: 'Luna aceasta'
          },
          documents: {
            title: 'Documente Generate',
            subtitle: 'Săptămâna aceasta'
          }
        }
      },
      mainFeatures: {
        smartTimeTracking: {
          title: 'Pontaj Inteligent din Telefon',
          description: 'Un click și gata. Recunoaștere facială + GPS. Fiecare angajat vede orele lucrate în timp real.'
        },
        supervisorControl: {
          title: 'Control pentru Supervizori',
          description: 'Managerii marchează prezența echipei instant din teren. Validare rapidă, zero hârtii.'
        },
        autoPayroll: {
          title: 'Salarizare Automată',
          description: 'Calculează automat ore lucrate, sporuri și diurne. Export direct pentru transfer bancar.'
        },
        zeroMissing: {
          title: 'Zero Documente Lipsă',
          description: 'Contracte generate automat la angajare. Acte adiționale create instant. Totul digital.'
        }
      },
      allInOne: {
        title: 'Totul într-un Singur Loc',
        subtitle: 'Totul centralizat și automat.',
        features: {
          leaveManagement: {
            title: 'Concedii & Absențe',
            description: 'Toate concediile gestionate automat. Solicitări aprobate instant. Sincronizare cu pontajul și salarizarea.'
          },
          instantDocuments: {
            title: 'Documente Generate Instant',
            description: 'Contracte, adeverințe, acte adiționale - toate generate automat. Șabloane personalizate.'
          },
          transparentHistory: {
            title: 'Istoric Transparent',
            description: 'Tot istoricul fiecărui angajat: contracte, modificări, concedii, pontaje. Organizat cronologic.'
          },
          onDemandReports: {
            title: 'Rapoarte La Cerere',
            description: 'Raport complet pe angajat în secunde. Export în Excel, PDF sau CSV.'
          }
        }
      },
      trackingMethods: {
        title: 'Metode Flexibile de Pontaj',
        subtitle: 'Alege metoda potrivită echipei tale.',
        methods: {
          app: {
            title: 'Din Aplicație',
            description: 'Deschizi app-ul, te recunoaște automat și ești pontat. 3 secunde.'
          },
          gps: {
            title: 'Cu Verificare GPS',
            description: 'Pentru echipe mobile. Confirmare locație + recunoaștere facială.'
          },
          supervisor: {
            title: 'Prin Supervizor',
            description: 'Șeful de șantier marchează rapid întreaga echipă. Ideal pentru grupuri mari.'
          },
          webTerminal: {
            title: 'Web sau Terminal',
            description: 'Pontaj din browser sau terminal fizic la intrare.'
          }
        }
      },
      guaranteedResults: {
        title: 'Rezultate Măsurabile',
        subtitle: 'Îmbunătățiri din prima lună de utilizare.',
        benefits: {
          timeSaved: {
            stat: '-90%',
            title: 'Timp HR Economisit',
            description: 'HR-ul nu mai pierde ore cu pontaje manuale, calcule și documente. Totul automat.'
          },
          accuracy: {
            stat: '100%',
            title: 'Precizie',
            description: 'Zero erori la pontaj și salarii. Zero documente pierdute.'
          },
          disputes: {
            stat: '0',
            title: 'Dispute',
            description: 'Totul transparent și verificabil. Angajații văd exact orele lucrate.'
          },
          access: {
            stat: '24/7',
            title: 'Acces Non-Stop',
            description: 'Angajații pot verifica pontaje, cere concedii sau descărca documente oricând.'
          }
        }
      },
      howItWorks: {
        title: 'Cum Funcționează?',
        subtitle: 'Implementare rapidă în 3 pași.',
        steps: {
          setup: {
            number: '1',
            title: 'Configurare Instantanee',
            description: 'Adaugi angajații în sistem, setezi programul de lucru și politicile de pontaj. Totul se face din browser în maximum 30 de minute. Sistemul se adaptează oricărei structuri organizaționale.'
          },
          mobileInstall: {
            number: '2',
            title: 'Instalare Aplicație Mobilă',
            description: 'Angajații își instalează aplicația pe telefon (Android sau iOS). Prima pontare activează recunoașterea facială și GPS-ul. Zero training necesar - interfața este extrem de intuitivă.'
          },
          autoMonitoring: {
            number: '3',
            title: 'Monitorizare Automată',
            description: 'De aici totul merge pe pilot automat: pontaje validate instant, ore calculate automat, rapoarte generate la cerere, salarii pregătite pentru export. Tu doar supravegezi dashboard-ul.'
          }
        }
      },
      industries: {
        title: 'Pentru Orice Industrie',
        subtitle: 'Soluție adaptată nevoilor specifice fiecărei industrii.',
        list: {
          construction: {
            title: 'Construcții & Șantiere',
            description: 'Pontaj mobil cu GPS pentru echipe în teren. Tracking locații multiple simultan. Raportare automată pentru ITM. Gestionare diurne și deplasări.'
          },
          retail: {
            title: 'Retail & Magazine',
            description: 'Pontaj flexibil pentru ture și schimburi. Gestionare program neregulat. Calculare automată a sporurilor de noapte și sărbători legale.'
          },
          production: {
            title: 'Producție & Fabrici',
            description: 'Pontaj terminal la intrare sau tablete în secțiile de producție. Tracking pe linii de producție. Rapoarte detaliate pe centre de cost și produse.'
          },
          services: {
            title: 'Servicii & Consultanță',
            description: 'Pontaj remote pentru munca de acasă. Tracking timp pe proiecte și clienți. Facturare automată bazată pe ore lucrate. Export către sistemele tale existente.'
          },
          horeca: {
            title: 'Horeca & Turism',
            description: 'Pontaj rapid pentru personal sezonier. Gestionare ture flexibile. Calcul automat a orelor suplimentare. Conformitate legislație muncă.'
          },
          logistics: {
            title: 'Logistică & Transport',
            description: 'Pontaj șoferi și depozitari. Tracking flotă cu GPS. Gestionare curse și trasee. Calculare diurne și timp de odihnă conform legislației.'
          }
        }
      },
      faq: {
        title: 'Întrebări Frecvente Despre Pontaj Electronic',
        subtitle: 'Răspunsuri la cele mai comune întrebări despre sistemul nostru de pontaj HR.',
        questions: {
          compliance: {
            question: 'Este sistemul de pontaj compatibil cu legislația românească și cerințele ITM?',
            answer: 'Da, sistemul nostru este 100% conform cu Codul Muncii și cerințele Inspecției Muncii din România. Păstrează istoric complet de pontaje, permite exporturi în formatele cerute de ITM, și documentează toate modificările pentru audit. Fiecare pontare este însoțită de timestamp și locație GPS pentru verificare.'
          },
          fraud: {
            question: 'Cum previne sistemul fraudele la pontaj (pontare din alte locații sau pentru alte persoane)?',
            answer: 'Sistemul folosește recunoaștere facială obligatorie la fiecare pontare și verifică locația GPS în timp real. Poți seta raze geografice permise pentru pontare - dacă angajatul nu e în zona definită, pontarea nu se înregistrează. Fiecare pontare include și ID-ul unic al dispozitivului pentru tracking suplimentar.'
          },
          forgotPunch: {
            question: 'Ce se întâmplă dacă un angajat uită să se ponteze sau telefonul rămâne fără baterie?',
            answer: 'Supervizorul sau departamentul HR poate corecta manual pontajele. Sistemul păstrează istoric complet al tuturor modificărilor - cine a făcut modificarea, când și de ce. Angajatul poate și el să facă cerere de corectare prin aplicație, iar managerul o aprobă sau respinge cu un click.'
          },
          flexibleSchedule: {
            question: 'Pot folosi sistemul de pontaj pentru echipe cu program flexibil sau remote work?',
            answer: 'Absolut! Sistemul suportă orice tip de program: fix, flexibil, remote, hibrid, ture, schimburi. Pentru remote work, poți dezactiva verificarea GPS și să te bazezi doar pe recunoaștere facială. Fiecare angajat poate avea setări diferite de pontaj în funcție de tipul contractului.'
          },
          implementation: {
            question: 'Cât timp durează implementarea și când pot începe să folosesc sistemul?',
            answer: 'Implementarea de bază durează sub 1 oră: adaugi angajații, setezi programul, ei își instalează aplicația. În aceeași zi poți avea primul pontaj înregistrat. Pentru configurări avansate (integrări cu alte sisteme, setări complexe de sporuri) putem oferi suport dedicat de implementare.'
          },
          integration: {
            question: 'Se integrează sistemul cu software-ul nostru actual de salarizare sau contabilitate?',
            answer: 'Da, oferim integrări prin API cu majoritatea sistemelor populare de salarizare și contabilitate din România. Dacă nu există integrare nativă, poți exporta pontajele în Excel, CSV sau alte formate compatibile cu orice sistem. Datele sunt structurate și standardizate pentru import facil.'
          },
          security: {
            question: 'Ce garanții de securitate și confidențialitate oferă sistemul pentru datele angajaților?',
            answer: 'Toate datele sunt criptate (SSL/TLS), stocate în cloud securizat cu backup automat, și conforme 100% cu GDPR. Doar persoanele autorizate au acces la date, cu loguri complete de acces. Fiecare companie are instanță separată - datele tale nu se amestecă niciodată cu ale altora. Oferim și contracte de confidențialitate semnate.'
          },
          pricing: {
            question: 'Care sunt costurile? Există taxe ascunse sau costuri de instalare?',
            answer: 'Prețul este transparent: abonament lunar per angajat activ, fără costuri de instalare sau setup. Nu există contracte pe termen lung obligatorii - poți anula oricând. Includere în preț: aplicații mobile, suport tehnic, actualizări automate, backup și securitate.'
          }
        }
      },
      cta: {
        title: 'Gata Să Scapi de Stresul HR?',
        subtitle: 'Peste 500 de companii au făcut deja switch-ul. Vezi live cum funcționează totul.',
        button: 'Prezentare Gratuită'
      }
    },
    common: {
      learnMore: 'Află Mai Mult',
      readMore: 'Citește Mai Mult',
      backToHome: 'Înapoi Acasă',
      loading: 'Se încarcă...',
      error: 'A apărut o eroare',
      success: 'Succes!',
      live: 'Live',
      updated: 'Actualizat',
      ago: 'acum'
    },
    logistica: {
      meta: {
        title: 'GPS Tracking Flota Constructii Logistica | Integrare Rompetrol OMV Foi Parcurs Consum Combustibil Costuri Transport',
        description: 'Sistem GPS tracking flota cu integrare API Rompetrol si OMV pentru firme constructii 10-700 angajati: monitorizare flota real-time, consum combustibil automat, foi parcurs generate automat, geofencing santier, alocare costuri pe centre cost, detectare furt motorina, tracking vehicule multi-santier. Software logistica transport enterprise Romania. Reducere costuri transport 25-30%.',
        keywords: 'gps tracking flota, gps flota, tracking flota, monitorizare flota, software gps flota, gps vehicule, tracking vehicule, flota constructii, gps constructii, foi parcurs, foaie parcurs, consum combustibil, control combustibil, furt motorina, gps rompetrol, gps omv, integrare rompetrol api, integrare omv api, geofencing santier, alocare costuri flota, centre cost flota, costuri transport, software logistica, management flota, fleet management, gps tracking romania, gps flota firme mari, gps flota firme mijlocii, gps flota 10 angajati, gps flota 100 angajati, gps flota 200 angajati, gps flota 500 angajati, monitorizare multi-flota, gestionare flota cloud, reducere costuri transport',
        ogImage: 'https://images.pexels.com/photos/1098460/pexels-photo-1098460.jpeg?auto=compress&cs=tinysrgb&w=1200',
        structuredData: {
          name: 'Logistica GPS - ControlMax',
          description: 'Software tracking GPS flota cu monitorizare vehicule timp real si urmarire combustibil',
          serviceType: 'Software GPS Tracking Flota'
        }
      },
      hero: {
        badge: 'Modul Logistică & Flote',
        title1: 'Sistem Complet',
        title2: 'Gestionare Flotă',
        subtitle: 'Integrare API Rompetrol & OMV. Alimentări automate, foi de parcurs generate instant, costuri alocate pe centre de cost.'
      },
      dashboard: {
        title: 'Dashboard Live Flotă',
        liveGps: 'LIVE GPS',
        activeVehicles: 'Vehicule Active',
        inMotion: 'În Mișcare',
        activeAlerts: 'Alerte Active',
        kmToday: 'Km Parcurși Azi',
        allVehicles: 'Toate vehiculele',
        autoFuelingsToday: 'Alimentări Auto Azi',
        apiIntegration: 'API Rompetrol & OMV',
        maintenanceCosts: 'Costuri Întreținere',
        thisMonth: 'Luna aceasta'
      },
      mainFeatures: {
        gps: {
          title: 'GPS + Geofencing',
          description: 'Urmărire live 24/7. Pontaj automat la intrare/ieșire din șantier. Istoric trasee + alerte pentru devieri.'
        },
        apiIntegration: {
          title: 'Integrare API Rompetrol & OMV',
          description: 'Alimentările vin automat prin API. Se verifică cu rapoartele șoferilor. Foi de parcurs generate instant.'
        },
        aiInvoices: {
          title: 'AI Pentru Facturi',
          description: 'Faci poză la factură → AI extrage piesele schimbate. Se asociază cu vehiculul și integrează în istoric.'
        },
        fuelControl: {
          title: 'Control Combustibil',
          description: 'Limite de consum + alerte automate. Monitorizare stații. Rapoarte pe centre de cost.'
        }
      },
      apiSection: {
        badge: 'INTEGRARE API DIRECTĂ',
        title: 'Rompetrol & OMV Direct În Platformă',
        description: 'Integrare API directă. Alimentările vin automat, verificare cu rapoartele șoferilor, foi de parcurs generate instant.',
        process: {
          step1: 'Șoferul alimentează la Rompetrol sau OMV cu cardul flotei',
          step2: 'Tranzacția apare AUTOMAT în platformă prin API în câteva secunde',
          step3: 'Se verifică cu ce a raportat șoferul → discrepanțe = alertă instant',
          step4: 'Foi de parcurs generate automat + costuri pe centre de cost'
        },
        liveCard: {
          title: 'Alimentări Live API',
          subtitle: 'Sincronizare automată',
          vehicle1: 'B-123-ABC',
          location1: 'Rompetrol Pipera',
          time1: 'Acum 2 min',
          vehicle2: 'B-456-DEF',
          location2: 'OMV Unirii',
          time2: 'Acum 15 min'
        }
      },
      premiumFeatures: {
        title: 'Feature-uri Premium Flotă',
        subtitle: 'Totul ce ai nevoie pentru control total asupra flotei tale.',
        documents: {
          title: 'Documente & Alerte',
          description: 'Monitorizare ITP, RCA, roviniete, permise conducere. Alerte automate cu 30 zile înainte de expirare. Zero amenzi.'
        },
        unauthorized: {
          title: 'Detectare Utilizare Neautorizată',
          description: 'Alertă instant dacă vehiculul se mișcă în afara programului. Notificare la ieșire din zonele permise. Siguranță maximă.'
        },
        components: {
          title: 'Accesorii & Componente',
          description: 'Monitorizare completă: anvelope, baterii, filtre, ulei. Istoric pe fiecare componenă. Predictie când trebuie înlocuite.'
        },
        costCenters: {
          title: 'Alocare Automată Centre Cost',
          description: 'Fiecare alimentare se alocă AUTOMAT pe centrul de cost corespunzător șantierului. Rapoarte instant per proiect. Export contabilitate gata.'
        }
      },
      fuelManagement: {
        title: 'Gestionare Combustibil Nivel Expert',
        subtitle: 'Control absolut asupra celui mai mare cost operațional.',
        limits: {
          title: 'Limite Consum & Alerte',
          description: 'Setezi limită maximă de consum pe vehicul. Alertă instant dacă se depășește. Detectare scurgeri sau furturi automat.'
        },
        ownStations: {
          title: 'Stații Proprii Monitorizate',
          description: 'Dacă ai stații proprii: monitorizare nivel rezervor, pontaj alimentări, rapoarte consum pe vehicul. Control total.'
        },
        analysis: {
          title: 'Analiză Avansată Consum',
          description: 'Compară consumul pe șoferi, rute, tipuri vehicule. Identifică cine conduce eficient. Rapoarte pentru optimizare.'
        }
      },
      verification: {
        title: 'Verificări Automate & Foi Parcurs',
        subtitle: 'Sistemul compară automat datele din API cu ce raportează șoferii. Zero discrepanțe.',
        crossCheck: {
          title: 'Cross-Check Automat',
          description: 'Șoferul raportează zilnic combustibilul consumat. Sistemul compară cu datele din API Rompetrol/OMV. Discrepanță = alertă instant.'
        },
        waybills: {
          title: 'Foi Parcurs Generate',
          description: 'Pe baza GPS + alimentări, foi de parcurs complete generate automat pentru fiecare vehicul. Export PDF instant pentru ITI sau contabilitate.'
        },
        costAllocation: {
          title: 'Alocare Centre Cost',
          description: 'Fiecare alimentare se asociază automat cu șantierul/proiectul pe care lucra vehiculul. Rapoarte pe centru de cost instant.'
        }
      },
      benefits: {
        title: 'Rezultate Măsurabile',
        subtitle: 'Clienții noștri reduc costurile flotei dramatic în primele luni.',
        costReduction: {
          stat: '-25%',
          title: 'Reducere Costuri Totale',
          description: 'Optimizare rute + control combustibil + mentenanță preventivă = economii majore lunare garantate.'
        },
        fines: {
          stat: '0',
          title: 'Amenzi & Documente Expirate',
          description: 'Alertele automate elimină complet amenzile pentru ITP/RCA expirate. Sistemul te anunță cu 30 zile înainte.'
        },
        adminTime: {
          stat: '-95%',
          title: 'Timp Administrare Fleet',
          description: 'Nu mai introduci alimentări, nu mai verifici documente, nu mai calculezi costuri manual. Totul automat.'
        },
        transparency: {
          stat: '100%',
          title: 'Transparență Totală',
          description: 'Știi oricând: unde e fiecare mașină, cât a consumat, ce costuri are, când trebuie la service. Zero surprize.'
        }
      },
      implementation: {
        title: 'Cum Implementezi Sistemul GPS Tracking în 3 Pași Simpli',
        subtitle: 'De la comenză până la tracking complet live în mai puțin de 48 ore.',
        step1: {
          number: '1',
          title: 'Comandă & Instalare GPS',
          description: 'Comandă device-uri GPS profesionale pentru fiecare vehicul din flotă. Instalarea durează 30-60 minute per vehicul și se face de tehnicieni certificați. Device-urile se conectează la bateria și ECU-ul vehiculului pentru date complete despre consum, kilometraj și stare motor.'
        },
        step2: {
          number: '2',
          title: 'Configurare Platformă Cloud',
          description: 'Adaugi vehiculele în platformă, setezi limite de consum, zone geofencing pentru șantiere, centre de cost pentru alocări automate. Configurezi integrarea API cu Rompetrol și OMV pentru alimentări automate. Setup complet durează 2-3 ore pentru o flotă medie.'
        },
        step3: {
          number: '3',
          title: 'Training & Go Live',
          description: 'Șoferii primesc training rapid (30 minute) pentru aplicația mobilă - raportare zilnică combustibil și km. Managerii învață să folosească dashboard-ul pentru monitorizare live. De aici totul e automat: tracking GPS, alimentări din API, foi de parcurs generate, alerte instant.'
        }
      },
      fleetTypes: {
        title: 'Soluții GPS Tracking Pentru Orice Tip de Flotă',
        subtitle: 'Sistem versatil adaptat perfect la specificul fiecărei industrii și tipuri de vehicule.',
        construction: {
          title: 'Flote Construcții & Șantiere',
          description: 'GPS pentru camioane, excavatoare, buldozere, autobetoniere. Geofencing pe fiecare șantier pentru pontaj automat. Alocare costuri transport pe proiecte. Monitorizare utilaje pentru prevenire furt. Foi de parcurs pentru ITI și raportare ITM.'
        },
        freight: {
          title: 'Transport Marfă & Logistică',
          description: 'Tracking rute lungi, monitoring consum combustibil pe traseu, planificare optimă curse pentru reducere costuri. Alerte deviere traseu sau opriri neautorizate. Raportare conformitate legislație timp conducere și odihnă.'
        },
        courier: {
          title: 'Curierat & Livrări Last Mile',
          description: 'Tracking live pentru toți curieri simultan. Optimizare rute automat pentru economie combustibil. Proof of delivery cu GPS verificat. Dashboard live pentru dispatcher. Istoric complet livrări pentru reclamații clienți.'
        },
        field: {
          title: 'Servicii Field & Intervenții',
          description: 'Tracking echipe service în teren. Alocare automată cea mai apropiată echipă de client. Timp răspuns măsurat precis. Raportare ore lucrate pe client pentru facturare. Istoric deplasări pentru audit și optimizare.'
        },
        sales: {
          title: 'Vânzări & Reprezentanți Comerciali',
          description: 'Monitorizare vizite la clienți cu geofencing automat. Raportare kilometri pentru decontare deplasări. Verificare conformitate program vizite planificate. Analiză eficiență teritorii și reprezentanți.'
        },
        passenger: {
          title: 'Transport Persoane & Turism',
          description: 'Tracking autobuze și microbuze turism. Monitorizare respectare itinerar și opriri programate. Siguranță pasageri cu istoric complet traseu. Raportare conformitate norme siguranță transport persoane. Întreținere preventivă pentru siguranță maximă.'
        }
      },
      faq: {
        title: 'Întrebări Frecvente Despre GPS Tracking Flotă',
        subtitle: 'Răspunsuri la cele mai comune întrebări despre sistemul nostru de monitorizare flote.',
        q1: {
          question: 'Cum funcționează integrarea API cu Rompetrol și OMV și ce avantaje reale oferă?',
          answer: 'Odată configurată integrarea (proces automat care durează câteva minute), fiecare alimentare făcută de șoferi cu cardul flotei la Rompetrol sau OMV apare INSTANT în platformă - nu mai introduci manual nimic. Sistemul face automat cross-check între ce raportează șoferul și ce arată tranzacția API. Dacă apar discrepanțe (șoferul a uitat să raporteze sau a raportat greșit), primești alertă instant. Foi de parcurs se generează automat cu toate datele verificate, gata pentru ITI sau contabilitate. Economie de 5-10 ore/lună doar la administrare combustibil.'
        },
        q2: {
          question: 'Ce device-uri GPS recomandați și cât costă instalarea per vehicul?',
          answer: 'Lucrăm cu device-uri GPS profesionale de top (Teltonika, Queclink) cu garanție 3-5 ani. Device-ul se conectează la bateria vehiculului și la portul OBD2/CAN pentru date complete: consum real combustibil din ECU, kilometraj exact, stare motor, poziție GPS precisă. Instalarea durează 30-60 minute per vehicul și se face de tehnicieni certificați. Pentru flote 10+ vehicule oferim instalare la sediul clientului pentru minimă întrerupere activitate. Prețul include device + instalare + garanție + mentenanță.'
        },
        q3: {
          question: 'Pot seta zone geofencing pentru șantiere și să primesc alerte automate când vehiculele intră/ies?',
          answer: 'Absolut! Geofencing este una din funcțiile cele mai utile pentru construcții și servicii field. Desenezi pe hartă zonele șantierelor (poligoane sau cercuri) și setezi alerte: notificare când vehiculul intră/iese din zonă, rapoarte automate ore petrecute pe șantier, pontaj vehicule per locație. Poți aloca automat costurile de transport pe centrul de cost al șantierului respectiv. Sistemul păstrează istoric complet pentru audit și facturare clienți.'
        },
        q4: {
          question: 'Cum detectează sistemul consumuri anormale de combustibil sau posibile furturi?',
          answer: 'Sistemul monitorizează continuu consumul real vs consum teoretic (bazat pe km, tip vehicul, condiții drum). Setezi limite maxime de consum per vehicul - dacă se depășește, primești alertă instant. Pentru vehicule cu senzori în rezervor, detectează scăderi bruște de nivel care nu corespund cu alimentări (posibil furt sau scurgere). Compară și consumul între șoferi pentru același tip de vehicul - identifici rapid cine conduce neeconomic sau posibile probleme tehnice vehicul.'
        },
        q5: {
          question: 'Sistemul ajută la respectarea legislației pentru foi de parcurs și raportări ITM/ITI?',
          answer: 'Da, foi de parcurs conforme legislație românească se generează automat: traseu GPS complet, alimentări verificate prin API, kilometri parcurși exact din ECU, scopul deplasării (șantier/client), șofer și vehicul. Export PDF gata semnat de șofer pentru ITI. Pentru ITM, rapoarte complete privind respectarea normelor de siguranță, timpul de conducere și odihnă (pentru transport marfă), istoric mentenanță preventivă. Toate datele sunt ștampilate temporal și nu pot fi modificate retroactiv - audit trail complet.'
        },
        q6: {
          question: 'Ce se întâmplă dacă GPS-ul se defectează sau un vehicul intră în zonă fără semnal?',
          answer: 'Device-urile GPS au memorie internă și continuă să înregistreze toate datele chiar fără conexiune internet/GPS (tuneluri, parcări subterane, zone montane). Când semnalul revine, datele se sincronizează automat - nu pierzi niciun km sau informație. În caz de defecțiune device, primești alertă și înlocuire rapidă în garanție. Pentru vehicule care merg frecvent în zone fără semnal, recomandăm device-uri cu memorie extinsă care stochează până la 6 luni de date local.'
        },
        q7: {
          question: 'Pot integra sistemul GPS cu software-ul actual de contabilitate?',
          answer: 'Da, oferim integrări prin API cu majoritatea sistemelor de contabilitate din România (SAP, Oracle, Microsoft Dynamics, software-uri locale). Poți exporta automat foi de parcurs, costuri combustibil alocate pe centre cost, facturi service, decontări kilometri în formatul cerut de sistemul tău. Dacă nu există integrare nativă, exporturi în Excel/CSV cu structură personalizată pentru import manual rapid. Datele sunt standardizate și includ toate detaliile necesare contabilității.'
        },
        q8: {
          question: 'Care sunt costurile și există contracte pe termen lung obligatorii?',
          answer: 'Prețul este transparent: cost inițial device GPS + instalare (one-time), apoi abonament lunar per vehicul care include: platformă cloud, aplicații mobile, stocare date nelimitată, suport tehnic, actualizări automate, mentenanță device-uri. Pentru integrarea API Rompetrol/OMV există un mic cost lunar fix per flotă (nu per vehicul). NU există contracte pe termen lung obligatorii - funcționăm lunar, poți anula oricând. Pentru flote 15+ vehicule, oferte personalizate cu reduceri substanțiale.'
        }
      },
      cta: {
        title: 'Gata Să Controlezi Flota Perfect?',
        description: 'Vezi live cum integrarea Rompetrol & OMV plus GPS tracking transformă complet gestionarea flotei tale.',
        button: 'Prezentare Gratuită'
      }
    },
    achizitii: {
      hero: {
        badge: 'Modul Achiziții & Stocuri',
        title1: 'Achiziții Fără',
        title2: 'Birocrație',
        subtitle: 'Faci poză la aviz, restul e automat. Zero tastare, zero verificări manuale. Totul digitalizat instant cu AI.'
      },
      aiDemo: {
        title: 'Scanare AI Live',
        badge: 'AI ACTIVE',
        step1: 'Poză → Date Complete',
        step2: 'În mai puțin de 3 secunde',
        feature1: 'Extragere automată date furnizor',
        feature2: 'Citire produse, cantități, prețuri',
        feature3: 'Actualizare automată stocuri',
        feature4: 'Arhivare digitală instant',
        statsTitle: 'Luna Aceasta',
        stat1Label: 'Avize Scanate',
        stat2Label: 'Comenzi Auto',
        stat3Label: 'Valoare Totală'
      },
      mainFeatures: {
        aiScan: {
          title: 'Scanare Instantanee Cu AI',
          description: 'Faci poză la aviz sau factură → AI-ul extrage automat TOATE datele: furnizor, produse, cantități, prețuri. Zero tastare manuală!'
        },
        autoReceipt: {
          title: 'Recepție Automată Marfă',
          description: 'La sosirea mărfii: scanezi avizul → stocurile se actualizează instant → documentul e arhivat digital. 30 secunde, gata!'
        },
        autoOrders: {
          title: 'Comenzi Generate Automat',
          description: 'Când stocul ajunge la minim, sistemul generează singur comanda. Tu doar aprobi. Integrare directă cu furnizorii.'
        },
        zeroShortages: {
          title: 'Zero Lipsuri Pe Șantier',
          description: 'Alertele inteligente te anunță înainte să rămâi fără materiale. AI prezice consumul și sugerează când să comanzi.'
        }
      },
      manualWork: {
        title: 'Uită De Munca Manuală',
        subtitle: 'AI-ul face treaba grea pentru tine. Tu doar supervizezi.'
      },
      advancedFeatures: {
        ocr: {
          title: 'OCR Inteligent',
          description: 'Recunoaștere text din orice aviz, factură sau document. Funcționează chiar și cu poze proaste sau documente șifonate.'
        },
        aiPrediction: {
          title: 'Predicție AI Necesități',
          description: 'Analizează consumul istoric și planul de lucru. Îți spune exact când și cât material să comanzi pentru a nu rămâne fără.'
        },
        costOptimization: {
          title: 'Optimizare Costuri',
          description: 'Compară automat prețurile furnizorilor. Identifică oportunități de economisire. Reducere costuri cu până la 20%.'
        },
        traceability: {
          title: 'Trasabilitate 100%',
          description: 'Fiecare material urmărit de la furnizor până pe șantier. Certificate calitate, loturi, PV-uri. Totul digital și organizat.'
        }
      },
      aiScanSection: {
        badge: 'FEATURE EXCLUSIV',
        title: 'Cum Funcționează Scanarea AI?',
        subtitle: 'E atât de simplu încât pare magic. Dar e doar tehnologie avansată care îți economisește ore întregi de muncă plictisitoare.',
        step1: 'Faci poză la aviz cu telefonul când sosește marfa',
        step2: 'AI-ul citește și extrage automat toate datele în 3 secunde',
        step3: 'Stocurile se actualizează instant, documentul e arhivat',
        step4: 'Tu doar verifici că totul e corect. Gata!',
        demoTitle: 'Scanare cu AI',
        demoSubtitle: 'Procesare în timp real',
        stat1Label: 'Precizie extragere date',
        stat2Label: 'Timp mediu procesare',
        stat3Label: 'Documente scanate/lună'
      },
      results: {
        title: 'Rezultate Concrete',
        subtitle: 'Clienții noștri economisesc timp și bani din prima săptămână.',
        timeReduction: {
          stat: '-95%',
          title: 'Timp Administrare Redus',
          description: 'Nu mai tastezi avize, nu mai verifici manual facturi, nu mai cauți documente. AI-ul face totul automat în secunde.'
        },
        zeroShortages: {
          stat: '0',
          title: 'Lipsuri Pe Șantier',
          description: 'Sistemul predictiv și alertele inteligente garantează că materialele necesare sunt mereu disponibile când trebuie.'
        },
        costReduction: {
          stat: '-20%',
          title: 'Costuri Reduse',
          description: 'Optimizarea comenzilor, comparare automată prețuri și eliminarea achizițiilor de urgență scad costurile semnificativ.'
        },
        traceability: {
          stat: '100%',
          title: 'Trasabilitate Digitală',
          description: 'Fiecare aviz, factură și certificat arhivat digital. Găsești orice document în 2 secunde. Zero hârtii pierdute.'
        }
      },
      implementation: {
        title: 'Implementare Simplă În 3 Pași',
        subtitle: 'De la setup la digitalizare completă în mai puțin de 24 ore.',
        step1: {
          number: '1',
          title: 'Configurare Inițială',
          description: 'Adaugi furnizorii tăi în platformă cu detalii contact și condiții comerciale. Configurezi categoriile de materiale și produsele pe care le folosești frecvent. Setezi depozitele și locațiile unde gestionezi stocuri. Încarci stocul inițial actual (manual sau import Excel). Setup completat în 2-3 ore.'
        },
        step2: {
          number: '2',
          title: 'Activare AI & Training Echipă',
          description: 'Sistemul AI învață automat să recunoască facturi și avize de la furnizorii tăi - cu cât scanezi mai multe documente, cu atât devine mai precis. Echipa ta primește training de 30-60 minute: cum să scaneze documente cu telefonul, cum să verifice datele extrase de AI, cum să gestioneze comenzi și alerte. Totul e intuitiv.'
        },
        step3: {
          number: '3',
          title: 'Go Live & Automatizare',
          description: 'Începi să scanezi fiecare aviz/factură când sosește marfa - stocurile se actualizează automat. Setezi nivele minime de stoc pentru materiale critice - sistemul generează automat comenzi când e necesar. Toate documentele sunt arhivate digital instant. AI-ul gestionează munca grea, tu doar supervizezi și aprobi.'
        }
      },
      industries: {
        title: 'Soluții Pentru Orice Industrie',
        subtitle: 'Sistem versatil adaptat perfect la specificul fiecărui business și flux de lucru.',
        construction: {
          title: 'Construcții & Șantiere',
          description: 'Gestionare materiale multiple șantiere simultan: ciment, oțel beton, agregate, vopsele, feronerie. Scanare avize livrare direct pe șantier cu telefonul. Transferuri materiale între șantiere trackuite complet. Alocare costuri materiale pe proiecte pentru facturare clienți. Eliminare lipsuri sau suprastocări.'
        },
        production: {
          title: 'Producție & Fabrici',
          description: 'Gestiune materii prime și componente producție: metale, plastic, electronică, chimicale, ambalaje. Comenzi automate furnizori bazate pe planul de producție. Trasabilitate completă loturi și certificate calitate. Integrare cu sistemul tău pentru sincronizare stocuri. Control strict inventar pentru audit și conformitate.'
        },
        retail: {
          title: 'Retail & Magazine',
          description: 'Management stocuri produse finite pentru vânzare: îmbrăcăminte, electronice, mobilă, alimentare non-perisabile. Scanare rapid facturi furnizori cu telefon - stocuri actualizate instant. Alerte automate când produse populare ajung la stoc minim. Raportare rotație stoc pentru optimizare achiziții. Inventar rapid cu scanare coduri de bare.'
        },
        distribution: {
          title: 'Distribuție & En-Gros',
          description: 'Gestiune complexă mii SKU-uri în depozite mari: electrice, instalații, scule, IT, FMCG. Recepție rapidă marfă cu scanare avize - verificare automată cantități vs comandă. Transferuri automate între depozite bazate pe cerere zonală. Raportare avansată: valoare stoc, rotație, produse slow-moving. Export date pentru contabilitate și facturare.'
        },
        horeca: {
          title: 'HoReCa & Catering',
          description: 'Administrare ingrediente și consumabile: alimente, băuturi, ambalaje, produse curățenie. Scanare facturi furnizori zilnic - control precis ce intră în stoc. Predictie AI consum bazată pe istoric și rezervări evenimente. Alerte expirare produse perisabile. Trasabilitate completă pentru conformitate ANPC și controale sanitare.'
        },
        services: {
          title: 'Servicii & Maintenance',
          description: 'Gestiune piese de schimb și consumabile service: filtre, baterii, lubrifianți, scule, echipamente. Scanare rapid facturi furnizori piese - actualizare stoc instant. Comenzi automate piese critice uzură mare. Istoric utilizare piese pe echipamente clienți pentru facturare și raportare. Eliminare piese lips urgent când ai intervenții.'
        }
      },
      faq: {
        title: 'Întrebări Frecvente Despre Sistemul de Achiziții',
        subtitle: 'Răspunsuri la cele mai comune întrebări despre platforma noastră de procurement.',
        q1: {
          question: 'Cum funcționează exact scanarea cu AI a facturilor și avizelor și cât de precisă este?',
          answer: 'Tehnologia noastră de AI OCR (Optical Character Recognition) este antrenată specific pe documente comerciale românești - facturi, avize, bonuri fiscale. Când faci poză la un document, AI-ul identifică automat tipul documentului, extrage datele furnizorului (nume, CUI, adresă), citește tabelul cu produse/materiale (denumire, UM, cantitate, preț unitar, valoare), recunoaște totaluri și TVA. Precizia medie este 99.2% pentru documente clare. Funcționează chiar și cu poze făcute în condiții mai proaste (lumină slabă, document îndoit). În 2-3 secunde, toate datele sunt extrase și gata de verificare. Tu doar confirmi că e totul corect sau corectezi rapid eventualele erori (de obicei sub 5% din cazuri necesită ajustări minore).'
        },
        q2: {
          question: 'Pot gestiona stocuri pe mai multe locații simultan - depozite diferite, șantiere, magazine?',
          answer: 'Absolut! Sistemul suportă gestiune multi-locație nelimitată. Definești fiecare depozit, șantier, magazin sau punct de lucru ca locație separată. Fiecare material/produs are stoc independent pe fiecare locație - vezi instant unde ai ce cantitate. Poți face transferuri între locații (cu document de transfer generat automat). Dashboard-ul centralizat îți arată stocurile consolidate pe toate locațiile plus detalierea pe fiecare în parte. Poți seta nivele minime de stoc diferite pe fiecare locație. Alertele automate iau în considerare și transferurile posibile între locații. Rapoartele pot fi generate global sau filtrate pe locații specifice.'
        },
        q3: {
          question: 'Sistemul poate genera automat comenzi către furnizori când stocul scade sub un nivel minim?',
          answer: 'Da, acesta e unul din feature-urile cheie pentru eliminare lipsuri. Pentru fiecare material/produs setezi: nivel minim de stoc (stoc de siguranță), cantitate optimă de comandat (lot economic), furnizor preferat și furnizori alternativi. Când stocul ajunge la nivelul minim, sistemul generează automat o comandă cu cantitatea setată către furnizorul preferat. Comanda poate fi configurată să fie trimisă automat prin email furnizorului sau să aștepte aprobare manager (depinde de politica ta). Pentru predictie avansată, AI-ul analizează consumul istoric și planul de lucru viitor - sugerează comenzi proactive înainte să ajungi efectiv la stoc minim. Poți avea și integrări API directe cu furnizorii care acceptă comenzi electronice automate.'
        },
        q4: {
          question: 'Cum mă ajută sistemul să reduc costurile de achiziții și să identific economii?',
          answer: 'Sistemul oferă mai multe mecanisme de optimizare costuri: 1) Compară automat prețurile pentru același material de la furnizori diferiți - îți sugerează furnizorul cu prețul cel mai bun. 2) Identifică oportunități de discount pe volum - când cantitatea totală necesară pe mai multe șantiere justifică o comandă mare cu discount. 3) Analizează istoricul de achiziții și detectează variații anormale de preț - alertă dacă un furnizor a mărit prețurile semnificativ. 4) Elimină achizițiile de urgență scumpe prin predictie și comenzi proactive la timp. 5) Reduce pierderile din materiale expirate sau degradate prin rotație optimă stoc (FIFO/FEFO). 6) Rapoarte detaliate pe categorie, furnizor, proiect - identifici unde cheltui cel mai mult și unde poți negocia mai bine. Clienții noștri raportează economii reale de 15-25% în primul an.'
        },
        q5: {
          question: 'Cum asigură sistemul trasabilitate completă a materialelor de la furnizor până pe șantier/producție?',
          answer: 'Fiecare intrare în stoc prin scanare aviz/factură păstrează: furnizor, dată livrare, număr aviz, număr lot (dacă e cazul), certificat calitate atasat digital, preț achiziție, locație depozitare inițială. La fiecare mișcare material (transfer între locații, consum pe șantier/comandă producție, retur furnizor, inventar/ajustare), sistemul înregistrează: cine, când, de unde, unde, cât, motiv. Pentru materiale cu cerințe speciale (certificate calitate obligatorii, loturi, expirare), poți atașa documente digitale - certificate, agremente, fișe tehnice, PV-uri. La orice moment poți vedea istoricul complet al unui material: de unde a fost procurat, unde a stat în depozit, cât timp, unde a fost folosit final. Pentru audit, conformitate sau reclamații clienți, extragi instant rapoarte de trasabilitate complete. Toate datele sunt ștampilate temporal și nu pot fi modificate retroactiv - audit trail complet pentru controale oficiale.'
        },
        q6: {
          question: 'Pot integra sistemul cu software-ul actual de contabilitate pe care îl folosim?',
          answer: 'Da, oferim multiple opțiuni de integrare. Pentru sisteme de contabilitate populare în România (SAP Business One, Oracle NetSuite, Microsoft Dynamics, Saga, WizCount, SmartBill, Facturis), avem conectori ready-made - activare în câteva ore. Integrarea sincronizează automat: facturi și avize scanate devin intrări în stoc, comenzi generate se transmit în modulul de achiziții, stocurile se pot sincroniza bidirecțional, articole noi se pot importa din sistemul tău. Pentru sisteme custom sau mai puțin comune, oferim API REST deschis documentat complet - echipa ta IT poate dezvolta integrarea. Alternative: exporturi programate automate în format Excel/CSV cu structură personalizabilă pentru import în sistemul tău, sau export manual la cerere. Datele exportate sunt standardizate și includ toate detaliile cerute de contabilitate: CUI furnizor, număr factură, dată, produse cu coduri, cantități, prețuri, TVA.'
        },
        q7: {
          question: 'Ce se întâmplă dacă AI-ul extrage greșit date dintr-o factură sau aviz scanat?',
          answer: 'Sistemul e construit cu verificare umană în loop. După ce AI-ul extrage datele din documentul scanat, acestea îți sunt prezentate pentru confirmare într-o interfață simplă. Vezi documentul original scanat alături de datele extrase - poți compara vizual rapid. Dacă observi o eroare (de exemplu AI a citit 15 în loc de 18 bucăți), o corectezi instant direct în interfață - modificarea durează 2-3 secunde. Când salvezi, datele corecte se înregistrează și AI-ul învață din corecția ta - următoarea dată va fi mai precis pentru documente similare. Pentru furnizori noi sau documente cu layout neobișnuit, precizia inițială poate fi mai mică (85-90%), dar crește rapid pe măsură ce scanezi mai multe documente de la același furnizor. În practica, pentru furnizori recurenți, ajungi rapid la 99%+ precizie și practic doar confirmi fără să modifici nimic. Chiar și cu verificare, procesul e de 10x mai rapid decât tastare manuală completă.'
        },
        q8: {
          question: 'Care sunt costurile și ce e inclus în abonament? Există limite de documente sau utilizatori?',
          answer: 'Prețul este transparent și predictibil: abonament lunar fix bazat pe numărul de locații/depozite și volumul de tranzacții lunare (număr documente scanate și mișcări stoc). Toate feature-urile sunt incluse: AI OCR nelimitat pentru scanare documente, gestiune multi-locație, comenzi automate, predictie AI, raportare avansată, integrări cu sistemele tale de contabilitate, aplicație mobilă pentru scanare, stocare cloud securizată cu backup, suport tehnic permanent, actualizări automate. NU există costuri ascunse sau module extra cu plată separată. NU există limite de utilizatori - toată echipa ta poate folosi sistemul (șefi șantier, magazioneri, manageri achiziții, contabili). NU există limitări artificiale pe număr de furnizori, produse, categorii. Pentru businessuri mici (1-2 locații, sub 200 documente/lună), planuri entry-level la preț accesibil. Pentru corporații mari (10+ locații, mii documente/lună), oferte enterprise personalizate cu reduceri volum.'
        }
      },
      cta: {
        title: 'Gata Să Scapi De Hârtii?',
        subtitle: 'Vezi live cum un simplu poză transformă complet gestionarea achizițiilor tale.',
        button: 'Prezentare Gratuită'
      }
    },
    echipamente: {
      seo: {
        title: 'Management Echipamente Utilaje Constructii | GPS Tracking Mentenanta Active Fixe Costuri Operare',
        description: 'Sistem management echipamente si utilaje pentru firme constructii 10-700 angajati: evidenta utilaje multi-santier, planificare mentenanta, GPS tracking echipamente, costuri operare, gestiune active fixe, amortizare, alocare utilaje pe proiecte. Reducere costuri operare 30%. Software Romania.',
        keywords: 'management echipamente, management utilaje, evidenta utilaje, gestiune echipamente, echipamente constructii, utilaje constructii, planificare mentenanta, mentenanta utilaje, gps tracking echipamente, gps utilaje, costuri operare echipamente, costuri utilaje, active fixe, gestiune active fixe, amortizare utilaje, alocare utilaje pe proiect, utilaje multi-santier, software echipamente romania, management echipamente constructii, evidenta echipamente, inventar echipamente, scule instrumente, echipamente atribuite, verificare echipamente, software management echipamente firme mijlocii mari, echipamente 10 angajati, echipamente 100 angajati, echipamente 200 angajati, echipamente 500 angajati, reducere costuri operare, monitorizare echipamente real-time',
        ogImage: 'https://images.pexels.com/photos/1169754/pexels-photo-1169754.jpeg?auto=compress&cs=tinysrgb&w=1200',
        structuredData: {
          name: 'Management Echipamente - ControlMax',
          description: 'Software management echipamente si utilaje pentru constructii cu planificare mentenanta',
          serviceType: 'Software Management Echipamente Constructii'
        }
      },
      hero: {
        badge: 'Modul Inventar Echipamente',
        title1: 'Gestionare Inteligentă',
        title2: 'Utilaje & Echipamente',
        subtitle: 'Evidență completă utilaje, mentenanță predictivă cu AI și optimizare utilizare. Maximizează rentabilitatea echipamentelor tale.'
      },
      dashboard: {
        title: 'Parc Echipamente',
        stats: {
          totalEquipment: 'Total Utilaje',
          operational: 'Operaționale',
          inService: 'În Service'
        },
        equipment: {
          excavator: 'Excavator Caterpillar 320',
          crane: 'Automacara 25T',
          bulldozer: 'Buldozer Komatsu D65'
        },
        status: {
          operational: 'Operațional',
          service: 'În Service'
        },
        hoursLabel: 'ore funcționare',
        alert: {
          title: '3 Utilaje necesită revizii',
          subtitle: 'În următoarele 7 zile'
        }
      },
      features: {
        inventory: {
          title: 'Inventar Digital Complet',
          description: 'Evidență detaliată pentru fiecare utilaj: date tehnice, documente, certificări, istoric complet. Coduri QR pentru identificare rapidă.'
        },
        maintenance: {
          title: 'Mentenanță Predictivă AI',
          description: 'Algoritmi inteligenti analizează ore lucrate, condiții utilizare și vârstă pentru a prezice exact când este nevoie de service. Previne defecțiunile.'
        },
        scheduling: {
          title: 'Planificare Automată Service',
          description: 'Programare automată revizii periodice și ITP. Alerte în avans pentru scadențe. Integrare cu service-uri partenere.'
        },
        optimization: {
          title: 'Optimizare Utilizare',
          description: 'Analiză grad de utilizare pe fiecare echipament. Sugestii de realocare pentru maximizarea rentabilității. Calcul automat depreciere.'
        }
      },
      advancedFeatures: {
        title: 'Funcționalități Avansate',
        tracking: {
          title: 'Tracking Ore Funcționare',
          description: 'Monitorizare automată ore lucrate pentru fiecare utilaj. Calcul automat depreciere și costuri pe oră. Raportare detaliată pe proiect.'
        },
        history: {
          title: 'Istoric Intervenții',
          description: 'Registru complet al tuturor intervențiilor: revizii, reparații, piese schimbate. Costuri detaliate și furnizori de service.'
        },
        allocation: {
          title: 'Alocare Inteligentă',
          description: 'Sugestii AI pentru cea mai bună alocare a echipamentelor pe șantiere. Optimizare costuri transport și maximizare utilizare.'
        }
      },
      benefits: {
        title: 'Beneficii Măsurabile',
        costReduction: {
          stat: '35%',
          title: 'Reducere Costuri Mentenanță',
          description: 'Mentenanța predictivă previne defecțiuni costisitoare și optimizează intervalele de service, reducând semnificativ cheltuielile.'
        },
        uptime: {
          stat: '50%',
          title: 'Creștere Timp Operațional',
          description: 'Planificarea inteligentă a service-ului minimizează timpii de nefuncționare și maximizează disponibilitatea echipamentelor.'
        },
        savings: {
          stat: '€25,000',
          title: 'Economii Lunare',
          description: 'Optimizarea utilizării, reducerea defecțiunilor și negociere mai bună cu service-urile generează economii substanțiale.'
        },
        compliance: {
          stat: '100%',
          title: 'Conformitate Legislativă',
          description: 'Toate certificările, ITP-urile și documentele la zi. Alerte automate pentru scadențe. Zero riscuri de amenzi.'
        }
      },
      faq: {
        title: 'Întrebări Frecvente Despre Management Echipamente',
        subtitle: 'Răspunsuri la cele mai comune întrebări despre sistemul nostru de gestiune echipamente și utilaje.',
        q1: {
          question: 'Cum funcționează exact mentenanța predictivă cu AI și cât de precisă este în anticiparea defecțiunilor?',
          answer: 'Sistemul nostru de mentenanță predictivă folosește algoritmi avansați de machine learning antrenați pe milioane de date din industrie plus datele specifice utilajelor tale. AI-ul analizează continuu: ore funcționare totale și pe diferite tipuri sarcină (normal, intensiv, ralanti), condițiile de operare (temperatură, umiditate, tipul terenului), vârsta echipamentului și uzura normală conform specificațiilor producătorului, istoricul intervențiilor anterioare și tipurile de defecțiuni întâlnite, piesele schimbate și frecvența înlocuirii lor. Pe baza acestor date, AI-ul calculează probabilitatea unei defecțiuni în următoarele 30/60/90 zile și recomandă intervenții preventive ÎNAINTE să apară problema. Precizia medie este 85-90% - sistemul identifică corect 9 din 10 probleme viitoare și previne defecțiuni costisitoare. Cu cât folosești mai mult sistemul pe utilajele tale, cu atât AI învață pattern-urile specifice și devine și mai precis. Beneficiu concret: reduci defecțiunile neașteptate cu 70-80% și transformi reparațiile de urgență în service programat predictibil.'
        },
        q2: {
          question: 'Pot urmări în timp real locația și statusul echipamentelor mele pe toate șantierele?',
          answer: 'Da, sistemul oferă tracking complet și vizibilitate totală asupra parcului tău de echipamente. LOCALIZARE GPS: Fiecare utilaj poate fi echipat cu tracker GPS (opțional) - vezi pe hartă exact unde se află fiecare echipament în timp real, istoric complete trasee și deplasări (pentru detectare utilizări neautorizate), alerte automate dacă echipamentul iese din zona autorizată (geofencing). STATUS OPERAȚIONAL: Dashboard live cu statusul fiecărui utilaj: operațional pe șantier X, în transport către șantier Y, în service programat/urgență, stație/parcare/depozit. ORE FUNCȚIONARE: Contorizare automată ore lucrate zilnic (prin senzori sau raportare șef șantier), calculare automată ore rămase până la revizii, comparație utilizare reală vs capacitate maximă (idle time, utilizare optimă, suprasolicitare). DISPONIBILITATE: Vizualizare rapidă care echipamente sunt libere pentru alocare nouă, planificare inteligentă - sistemul sugerează când să muți utilaj de pe șantier slab activ către unul cu cerere mare. Accesezi totul din aplicația mobilă - vezi oricând, oriunde tot parcul de echipamente și iei decizii rapide de realocare.'
        },
        q3: {
          question: 'Cum gestionează sistemul certificările ITP documente tehnice și scadențele legale pentru fiecare echipament?',
          answer: 'Sistemul menține o arhivă digitală completă și conformitate 100% pentru fiecare utilaj. DOCUMENTAȚIE DIGITALĂ: Pentru fiecare echipament stochezi: certificat de înmatriculare/carte de identitate utilaj, certificate ITP cu istoricul complet, autorizații speciale (ridicare, macara, ADR pentru transporturi periculoase), documentație tehnică producător (manual operare, specificații, diagrame), certificate de verificare metrologică (cântare, aparate măsură), asigurări (CASCO, RCA pentru autovehicule). SCADENȚE AUTOMATE: Sistemul monitorizează constant toate datele de expirare și trimite alerte cu 90/60/30/7 zile înainte pentru ITP, certificate tehnice, autorizații temporare, asigurări și polițe. PROGRAMARE SERVICE: Integrare cu service-uri partenere - programare automată ITP și verificări periodice din sistem, evidență completă a fiecărei inspecții efectuate. CONFORMITATE: Raportare instant conformitate întregului parc - știi oricând câte echipamente au documentația la zi, alerte vizibile pentru echipamente cu risc legal (document expirat/în curs de expirare), blocare alocare echipament fără acte la zi pe șantier. Zero risc de amenzi pentru lipsa documentației sau certificate expirate.'
        },
        q4: {
          question: 'Se integrează sistemul cu GPS tracking existent sau alte soluții hardware pe care le folosim deja?',
          answer: 'Da, oferim flexibilitate maximă și integrare cu majoritatea sistemelor și hardware-ului existent. GPS TRACKING: Integrare nativă cu trackere GPS populare - Teltonika, Concox, Queclink, Calamp, Meitrack prin protocoale standard, importă automat poziția și datele de la trackerele tale curente (nu trebuie să cumperi altele noi), sau folosește tracker-ul nostru recomandat cu instalare și integrare inclusă. SISTEME TELEMATICĂ: Integrare cu platforme constructori - Caterpillar VisionLink, Komatsu KOMTRAX, Volvo CareTrack, JCB LiveLink, sincronizare automată date tehnice și ore funcționare direct de la producător, evită înregistrarea manuală - datele vin automat din sistemele telematice. SENZORI IoT: Conectare la senzori de temperatură, presiune, consum combustibil, vibrații pentru monitorizare avansată, date în timp real pentru AI-ul de mentenanță predictivă, alerte instant la parametri anormali. API DESCHIS: Pentru sisteme custom sau mai puțin comune oferim API REST documentat complet, echipa ta IT poate dezvolta integrări specifice, webhook-uri pentru evenimente critice (service urgent, deplasare neautorizată). IMPORT DATE: Poți importa istoric complet din sistemele vechi - Excel, CSV sau alte formate, migrare asistată - te ajutăm cu transferul datelor și configurarea inițială.'
        },
        q5: {
          question: 'Cum ajută sistemul la optimizarea costurilor cu echipamentele și ce raportări financiare oferă?',
          answer: 'Sistemul oferă analize financiare complete și instrumente concrete de optimizare costuri. COSTURI OPERARE: Evidență detaliată toate cheltuielile pe fiecare utilaj: combustibil (consum real vs standard, detectare anomalii), piese schimb și materiale consumabile, manoperă service și reparații, asigurări și taxe, amortizare calculată automat conform normelor. RENTABILITATE: Calcul automat cost/oră operare pentru fiecare echipament, facturare către proiecte - cât costă efectiv utilizarea pe fiecare șantier, comparație cost real vs tarif facturat (vezi profitabilitatea), identificare utilaje nerentabile (cost operare prea mare vs utilizare). OPTIMIZARE UTILIZARE: Analiză grad utilizare - vezi care echipamente stau degeaba și care sunt suprasolicitate, sugestii realocare inteligentă - mută utilaje subutilizate pe șantiere cu cerere mare, calcul moment optim vânzare/înlocuire - când costurile depășesc valoarea utilajului. DECIZIE ÎNCHIRIERE vs ACHIZIȚIE: Analize comparative - când e mai rentabil să închiriezi echipament decât să-l cumperi, tracking echipamente închiriate - asigură respectarea termenelor și evită costurile penalități. RAPORTARE: Rapoarte detaliate cost total proprietate (TCO) pe fiecare echipament, top echipamente după rentabilitate/costuri, previziune bugete mentenanță pentru anul următor, export Excel/PDF pentru analize financiare și contabilitate.'
        },
        q6: {
          question: 'Pot gestiona și echipamentele mici și uneltele nu doar utilajele mari și cum se face inventarul?',
          answer: 'Da, sistemul gestionează TOATE categoriile de echipamente indiferent de mărime sau valoare. UTILAJE MARI: Excavatoare, buldozere, macarale, autobasculante - cu tracking GPS, mentenanță predictivă, ore funcționare, ITP și toate funcțiile avansate. UTILAJE MEDII: Generatoare, compresoare, pompe beton, macarale mici, platforme elevatoare - evidență completă, service programat, alocare pe șantiere. SCULE ȘI UNELTE ELECTRICE: Polizoare, fierăstraie, carotiere, perforatoare - inventar digital cu coduri QR/barcode, tracking cine are ce unealtă pe ce șantier, evidență împrumuturi și returnări. ECHIPAMENTE SIGURANȚĂ: Scări, schele, parapete, centuri siguranță, casci - verificări periodice obligatorii, certificate conformitate și teste periodice. INVENTARIERE SIMPLĂ: Generare coduri QR pentru fiecare echipament (printezi și lipești pe utilaj), scanare cu aplicația mobilă - inventar complet în minute nu zile, raportare instant ce lipsește sau ce e defect. CATEGORII PERSONALIZATE: Creezi categorii specifice nevoilor tale, definești câmpuri custom pentru fiecare tip echipament, setezi reguli mentenanță personalizate. Control complet de la excavator până la ciocan rotopercutor.'
        },
        q7: {
          question: 'Ce raportări și dashboarduri oferă sistemul și pot personaliza indicatorii care mă interesează?',
          answer: 'Sistemul oferă dashboarduri interactive complete și raportare extrem de flexibilă. DASHBOARDURI PREDEFINITE: Overview general parc - total echipamente, operaționale vs service, alerte urgente, status mentenanță - revizii programate, revizii scadente, costuri previzionate, utilizare - echipamente subutilizate, disponibilitate, ore lucrate, conformitate - ITP scadente, certificate expirate, documentație lipsă. RAPOARTE DETALIATE: Raport financiar complet - costuri pe echipament/categorie/perioadă cu trend și comparații, istoric mentenanță - toate intervențiile cu costuri și piese, utilizare și rentabilitate - cost/oră, gradul utilizare, profit generat, conformitate legislativă - status documente toate echipamentele. PERSONALIZARE TOTALĂ: Construiește propriile dashboarduri - alegi exact indicatorii care te interesează, filtrare multiplă după: categorie echipament, șantier/locație, perioadă (azi, săptămână, lună, an), status (operațional, service, disponibil), grafice interactive - bare, linii, pizza, evoluție în timp, alerte vizuale - culori roșu/galben/verde pentru status rapid. EXPORT ȘI PARTAJARE: Export în Excel/PDF/CSV cu formatare personalizată, programare rapoarte automate - primești email cu raportul ales zilnic/săptămânal/lunar, partajare securizată cu manageri sau extern (link temporar cu parolă). ACCES MOBIL: Toate dashboardurile disponibile și în aplicația mobilă - vezi indicatorii cheie oricând oriunde, notificări push pentru alertele critice.'
        },
        q8: {
          question: 'Cât de dificilă este implementarea sistemului și ce suport oferă echipa ControlMax pentru început?',
          answer: 'Implementarea este simplă și rapid iar echipa noastră te sprijină la fiecare pas. ONBOARDING ASISTAT: Consultanță inițială - analizăm specific nevoile tale și configurăm sistemul optim, sesiune training dedicată pentru echipa ta - 2-4 ore învățare interactivă toate funcțiile, suport live la început - specialist disponibil primele 2 săptămâni pentru întrebări și ajustări. IMPORT DATE: Migăm datele din sistemele tale vechi sau Excel - istoric echipamente, mentenanță, costuri, ne ocupăm de tot procesul - tu doar furnizezi datele în orice format, verificare și validare - ne asigurăm că totul e corect înainte de go-live. CONFIGURARE HARDWARE: Recomandări trackere GPS optimale cost-beneficiu, instalare și configurare în parc (opțional) - venim la tine, testare și calibrare - totul funcțional 100% de la început. TIMP IMPLEMENTARE: 1-2 zile pentru companii mici (sub 20 echipamente), 1 săptămână pentru companii medii (20-100 echipamente), 2-3 săptămâni pentru flote mari (100+ echipamente) cu procese complexe. SUPORT CONTINUU: Suport tehnic permanent - email, telefon, chat în aplicație, bază cunoștințe extinsă - articole, video tutoriale, răspunsuri FAQ, actualizări regulate - noi funcții fără costuri suplimentare, training refresh periodic - sesiuni de reîmprospătare cunoștințe. Reușita ta este prioritatea noastră - te ajutăm până totul funcționează perfect.'
        }
      },
      cta: {
        title: 'Gata Să Maximizezi Rentabilitatea?',
        description: 'Descoperă cum poți reduce costurile cu 35% și crește timpul operațional al echipamentelor tale.',
        button: 'Prezentare Gratuită'
      }
    },
    documente: {
      badge: 'Modul Management Documente',
      hero: {
        title: {
          line1: 'Arhivă Digitală Inteligentă',
          line2: 'Contracte & Documente Firmă'
        },
        subtitle: 'Scanezi sau fotografiezi → AI extrage TOATE datele automat. Notificări pentru termene, garanții, valori. Nu-ți mai scapă niciodată nimic.'
      },
      features: {
        aiExtraction: {
          title: 'AI Extrage Date Din Scan/Poză',
          description: 'Încărci contractul semnat (scan/poză) → AI citește TOATE datele: părți, valoare, termene, garanții, acte adiționale. Zero tastare manuală.'
        },
        notifications: {
          title: 'Notificări Automate Termene',
          description: 'Alert instant când începe contract, când expiră, când trebuie garanțiile. Dacă act adițional schimbă valoarea → notificare dacă garanția e prea mică.'
        },
        lifecycle: {
          title: 'Tot Ciclul De Viață Contract',
          description: 'Contract → Ordin Început → Acte Adiționale → Notificări → Situații Lucrări → Garanții. TOTUL într-un singur loc, organizat automat.'
        },
        guarantees: {
          title: 'Control Garanții & Valori',
          description: 'Monitorizare automată garanții de bună execuție/participare. Alertă dacă se apropie expirarea sau dacă valoarea nu corespunde cu contractul.'
        }
      },
      library: {
        title: 'Bibliotecă Documente',
        totalDocuments: 'Total Documente',
        addedThisMonth: 'Adăugate Luna Aceasta',
        upload: 'Upload',
        search: 'Caută',
        documents: {
          contract: 'Contract Santier Mega Mall',
          report: 'Raport Lunar Octombrie',
          invoice: 'Factura #2847 - Materiale',
          processVerbal: 'PV Receptie Lot 3'
        },
        types: {
          contract: 'Contract',
          report: 'Raport',
          invoice: 'Factură',
          processVerbal: 'Proces Verbal',
          guarantee: 'Garanție',
          additionalAct: 'Act Adițional',
          authorization: 'Autorizație'
        },
        status: {
          active: 'Activ',
          alert: 'Alertă',
          new: 'Nou'
        }
      },
      processing: {
        badge: 'EXTRACȚIE INTELIGENTĂ AI',
        title: 'Cum Funcționează Procesarea Inteligentă',
        subtitle: 'Pur și simplu scanezi/fotografiezi documentul → AI-ul face restul.',
        steps: {
          step1: 'Scanezi sau fotografiezi contractul semnat (orice format: PDF, JPG, PNG)',
          step2: 'AI citește și extrage automat: părți, valoare, termen, garanții, clauze',
          step3: 'Toate câmpurile se completează automat în sistem. Zero tastare!',
          step4: 'Adaugi ordine început, acte adiționale, notificări → Tot cu AI'
        },
        example: {
          badge: 'DOCUMENT PROCESAT',
          beneficiary: 'Beneficiar:',
          value: 'Valoare:',
          deadline: 'Termen:',
          guarantee: 'Garanție:',
          company: 'SC MEGA CONSTRUCT SRL',
          amount: '1.850.000 RON',
          date: '15 Dec 2025',
          guaranteeAmount: '10% (185.000 RON)',
          verified: 'Toate datele extrase și verificate automat'
        }
      },
      archives: {
        title: '2 Arhive Complete',
        contracts: {
          title: 'Arhivă Contracte Pe Centre Cost',
          description: 'Fiecare șantier/proiect are contractul său complet: contract inițial, ordine început, acte adiționale, situații, notificări, garanții. TOTUL organizat automat.'
        },
        company: {
          title: 'Arhivă Documente Firmă',
          description: 'Autorizații ISU, ISCIR, mediu, certificate ISO, licențe, asigurări. Notificări automate înainte de expirare. Zero risc să-ți scape ceva.'
        }
      },
      notificationSystem: {
        title: 'Sistemul De Notificări Automate',
        subtitle: 'Nimic nu-ți scapă. Sistemul te anunță automat pentru fiecare termen important.',
        contractDeadlines: {
          title: 'Termene Contracte',
          description: 'Alertă înainte de: începere contract, expirare, termene intermediare, prelungiri necesare.'
        },
        guarantees: {
          title: 'Garanții & Valori',
          description: 'Monitor expirare garanții. Alertă dacă act adițional schimbă valoarea și garanția devine prea mică.'
        },
        authorizations: {
          title: 'Autorizații Firmă',
          description: 'Expirare ISU, ISCIR, mediu, ISO. Te anunță cu 60/30/7 zile înainte să ai timp de înnoire.'
        }
      },
      benefits: {
        title: 'De Ce Clienții Adoră Acest Modul',
        zeroTyping: {
          stat: 'Zero',
          title: 'Tastare Manuală',
          description: 'AI citește și extrage TOATE datele din contracte. Doar scanezi/fotografiezi. Economisire masivă de timp.'
        },
        deadlines: {
          stat: '100%',
          title: 'Termene Respectate',
          description: 'Notificări automate pentru FIECARE termen. Nu mai uiți de garanții, autorizații, prelungiri. Zero risc.'
        },
        lifecycle: {
          stat: '1 Loc',
          title: 'Tot Ciclul De Viață',
          description: 'Contract → Ordine Început → Acte Adiționale → Situații → Garanții. TOTUL organizat automat pe proiect.'
        },
        control: {
          stat: '2 Arhive',
          title: 'Control Complet',
          description: 'Arhivă contracte pe centre cost + Arhivă documente firmă. Acces instant la orice document, oricand.'
        }
      },
      faq: {
        title: 'Întrebări Frecvente Despre Management Documente',
        subtitle: 'Răspunsuri la cele mai comune întrebări despre sistemul nostru DMS pentru constructii.',
        q1: {
          question: 'Cum funcționează exact extracția automată de date din contracte cu AI și cât de precisă este?',
          answer: 'Sistemul nostru folosește tehnologie AI OCR avansată antrenată special pe documente contractuale din România - contracte de construcții, furnizare, prestări servicii. Când încarci un contract scanat sau fotografiat, AI-ul identifică automat tipul documentului și extrage datele cheie: părțile contractante (beneficiar, executant, subcontractori), valoarea totală și pe faze/tranșe, termenele (data începere, finalizare, termene intermediare), garanțiile (bună execuție, participare, de avans cu procent și valoare), clauze importante (penalități, reziliere, forță majoră), acte adiționale și modificări ulterioare. Precizia medie este 95-98% pentru documente clare, funcționează și cu documente scanate mai vechi sau poze de telefon. Datele extrase sunt prezentate pentru verificare rapidă - dacă AI a interpretat ceva greșit, corectezi instant. Cu cât scanezi mai multe contracte, cu atât AI învață specific pentru firma ta și devine și mai precis.'
        },
        q2: {
          question: 'Cum funcționează sistemul de notificări pentru termene și garanții și pot personaliza alertele?',
          answer: 'Sistemul monitorizează automat TOATE termenele din contractele tale și trimite notificări la momentele critice. Pentru contracte: alertă la data început lucrări, la 30/15/7 zile înainte de expirare, când expiră perioada de garanție de bună execuție. Pentru garanții: te anunță cu 60/30/7 zile înainte de expirare pentru prelungire/eliberare, alertă dacă un act adițional modifică valoarea contractului și garanția devine prea mică (sub procentul contractual). Pentru autorizații firmă: alerte cu 60/30/7 zile înainte de expirare ISU, ISCIR, ISO, mediu, licențe. Poți personaliza complet: setezi perioadele de alertă, alegi canalele (email, notificare in-app, SMS), definești cine primește ce alerte (manager proiect, director, contabil). Poți seta și notificări custom pentru orice termen specific din contract.'
        },
        q3: {
          question: 'Pot organiza documentele pe proiecte și centre de cost separate și cum funcționează hierarhia?',
          answer: 'Da, sistemul oferă două arhive paralele perfect organizate. Arhiva CONTRACTE pe Centre Cost: fiecare șantier/proiect are dosarul său complet cu toate documentele aferente - contractul inițial, ordinul de început lucrări, toate actele adiționale (cronologic), situațiile de lucrări (lunare), notificările către/de la beneficiar, procesele verbale, garanțiile de bună execuție, certificatele de calitate materiale. Arhiva DOCUMENTE FIRMĂ: organizată pe categorii - autorizații (ISU, ISCIR, mediu), certificate (ISO, atestare ANRE), licențe și avize, asigurări (RCA, CAR, RCG), documente juridice (statut, hotărâri AGA), contracte furnizori recurenți. Poți avea sub-foldere personalizate nelimitate, taguri pentru căutare rapidă, filtrare multiplă după: tip document, dată, valoare, termen, responsabil, status. Control acces granular - setezi cine vede ce proiecte/categorii.'
        },
        q4: {
          question: 'Cum gestionează sistemul ciclul complet de viață al unui contract de la semnare până la finalizare?',
          answer: 'Sistemul urmărește întregul ciclu de viață automat. START: Încarci contractul semnat → AI extrage toate datele → contract activ în sistem. ORDIN ÎNCEPUT: Încarci ordinul de început (sau îl generează sistemul din template) → se actualizează datele de start efectiv → se activează alertele pentru termene. ACTE ADIȚIONALE: Încarci fiecare act adițional → AI detectează ce s-a modificat (termen, valoare, clauze) → se actualizează automat contractul → dacă valoarea crește, alertă pentru ajustare garanție. SITUAȚII LUCRĂRI: Încarci situațiile lunare → se asociază automat cu contractul → tracking valoare lucrată vs valoare contractuală → alertă la 80%/90%/100% din valoare. NOTIFICĂRI: Încarci sau generezi notificări către/de la beneficiar → se arhivează cronologic → tracking status răspuns. RECEPȚIE & GARANȚIE: Încarci PV recepție → începe perioada garanție de bună execuție → alertă înainte de expirare pentru eliberare garanție. Fiecare document are timestamp și tracking complet - știi exact istoria proiectului.'
        },
        q5: {
          question: 'Pot căuta rapid documente după conținut text nu doar după nume sau dată?',
          answer: 'Da, sistemul are căutare full-text avansată în toate documentele. Caută după: text exact din contract (căutare în conținutul scanat via OCR), nume părți contractante, numere contracte/facturi, valori (intervaluri sau exacte), date (perioade, înainte/după), clauze specifice (cauți \'penalitate\' și găsește toate contractele cu penalități), tipuri documente, statusuri, centre cost/proiecte. Poți combina multiple criterii pentru căutare precisă. Rezultatele arată preview cu textul găsit highlight și context. Salvezi căutările frecvente ca filtre rapide. Funcția \'document similar\' găsește automat documente asemănătoare după structură și conținut (util pentru contracte recurente cu același furnizor). Viteza căutare sub 1 secundă chiar pentru mii de documente - indexare full-text automată.'
        },
        q6: {
          question: 'Cum este asigurată securitatea și confidențialitatea documentelor și cine are acces la ce?',
          answer: 'Securitatea este prioritatea #1. CRIPTARE: Toate documentele sunt criptate în tranzit (SSL/TLS) și în repaus (AES-256). Backup automat zilnic incremental și complet săptămânal în multiple locații geografice. CONTROL ACCES: Setezi permisiuni granulare pe rol, departament, proiect: cine poate vizualiza, edita, șterge, partaja documente. Autentificare securizată cu 2FA opțional. AUDIT TRAIL: Istoric complet și imuabil - cine a accesat ce document când, cine a făcut modificări ce și când. CONFORMITATE: 100% conform GDPR - procesăm și stocăm datele în România/UE, nu le partajăm niciodată cu terți. Contracte de confidențialitate semnate. Funcția de ștergere definitivă (right to be forgotten). PARTAJARE SECURIZATĂ: Când trimiți documente extern, link-uri temporare cu expirare automată și parolă, watermark pe documente partajate, log cine a accesat link-ul. Opțional: hosting on-premise dacă preferi datele pe serverele tale.'
        },
        q7: {
          question: 'Se integrează sistemul DMS cu software-ul nostru actual de contabilitate?',
          answer: 'Da, oferim integrări cu majoritatea sistemelor de contabilitate populare în România. Pentru SAP Business One, Oracle NetSuite, Microsoft Dynamics, Saga, WizCount, SmartBill, avem conectori nativi - sincronizare automată bidirecțională: facturi scanate și procesate de AI se trimit automat în sistemul de contabilitate cu toate detaliile (furnizor, sume, TVA, scadență), contracte și situații lucrări se sincronizează cu modulul proiecte, documente generate (foi parcurs, rapoarte) se exportă în format compatibil. Pentru sisteme custom sau mai puțin comune, oferim API REST deschis complet documentat - echipa ta IT poate dezvolta integrarea, webhook-uri pentru evenimente în timp real (document nou, termen expirat). Alternative: exporturi automate programate în Excel/CSV/PDF cu structură personalizabilă, sau export manual la cerere cu formatare conform cerințelor tale. Datele exportate sunt standardizate și includ toate metadatele necesare pentru import fără erori.'
        },
        q8: {
          question: 'Care sunt costurile și ce este inclus în abonament? Există limite de stocare sau utilizatori?',
          answer: 'Prețul este transparent și predictibil: abonament lunar fix bazat pe numărul de utilizatori activi și volumul de stocare necesar (GB de documente). INCLUSE în preț: AI OCR nelimitat pentru procesare documente, gestiune completă contracte și documente firmă, sistem notificări automate toate tipurile, căutare full-text avansată, control acces pe roluri, audit trail complet, backup automat securizat cloud, aplicație web și mobilă, suport tehnic permanent, actualizări automate toate feature-urile. NU există costuri ascunse sau module extra cu plată. NU există limitări artificiale pe: număr proiecte/centre cost, categorii documente, căutări lunare, alerte/notificări. Spațiu stocare: start de la 100GB inclus, extensii la prețuri transparente dacă depășești. Pentru companii mari (50+ utilizatori, volume mari documente), oferte enterprise personalizate cu reduceri substanțiale. NU există contracte pe termen lung obligatorii - funcționăm lunar flexibil.'
        }
      },
      cta: {
        title: 'Gata Să Nu Mai Uiți Niciodată Un Termen?',
        description: 'Vezi cum AI-ul extrage automat datele din contracte și te anunță pentru fiecare termen important.',
        button: 'Prezentare Gratuită'
      }
    },
    calculator: {
      seo: {
        title: 'Calculator Pierderi Constructii ROI | Calculeaza Costuri Lipsa Control Furt Motorina Pontaje Fictive',
        description: 'Calculator pierderi pentru firme constructii: estimeaza in 30 secunde cat te costa lipsa de control - timp pierdut, furt motorina, pontaje fictive, utilaje inactive, materiale pierdute. Rezultat instant + raport PDF detaliat gratuit. Calculeaza ROI implementare software management.',
        keywords: 'calculator pierderi, calculator pierderi constructii, roi software, roi sistem management, economii management, calcul pierderi, costuri lipsa control, furt motorina, pontaje fictive, utilaje inactive, materiale pierdute, timp pierdut, calcul roi, calculator roi constructii, reducere costuri, raport pierderi, calculator economii, costuri ascunse constructii, pierderi santier, evaluare pierderi, calculator costuri firma, raport pdf pierderi, estimare economii software'
      },
      hero: {
        badge: 'Calculator ROI',
        title: 'Calculează Cât Pierzi Acum',
        subtitle: 'Completează 4 câmpuri și vezi în 30 secunde cât te costă lipsa de control asupra firmei tale'
      },
      form: {
        aboutCompany: 'Despre Firma Ta',
        aboutCompanyDesc: 'Datele tale rămân confidențiale și sunt folosite doar pentru calcul',
        employeesLabel: 'Câți angajați ai pe șantiere?',
        employeesPlaceholder: 'ex: 25',
        vehiclesLabel: 'Câte utilaje/vehicule ai?',
        vehiclesPlaceholder: 'ex: 8',
        fuelLabel: 'Consum combustibil lunar (litri)?',
        fuelPlaceholder: 'ex: 5000',
        sitesLabel: 'Câte șantiere active?',
        sitesPlaceholder: 'ex: 4',
        calculateButton: 'Calculează Pierderea →',
        guarantee: 'Rezultat instant • Zero obligații • Zero spam'
      },
      results: {
        title: 'Rezultatul Tău',
        subtitle: 'Pe baza datelor tale, firma ta pierde estimate:',
        perYear: 'pe an',
        breakdownTitle: 'Breakdown Pierderi:',
        adminTime: {
          label: 'Timp administrativ',
          formula: 'angajați × 0.3 ore/zi × 20 zile × 50 RON × 12 luni'
        },
        fuelTheft: {
          label: 'Furt motorină (15%)',
          formula: 'litri × 15% × 7 RON × 12 luni'
        },
        fakeTimeCards: {
          label: 'Pontaje fictive (5%)',
          formula: 'angajați × 3000 RON/lună × 5% × 12 luni'
        },
        materialLoss: {
          label: 'Lipsuri materiale și comenzi urgență',
          formula: 'șantiere × 800 RON/lună × 12 luni'
        },
        unprofitableSites: {
          label: 'Șantiere neprofitabile oprite târziu',
          formula: 'șantiere × 700 RON/lună × 12 luni'
        }
      },
      withControlMax: {
        title: 'Cu ControlMax:',
        investmentYear1: 'Investiție an 1:',
        implementation: 'Implementare',
        subscription: 'Abonament',
        monthlySubscription: '/lună × 12',
        totalYear1: 'Total an 1:',
        estimatedSavings: 'Economii estimate anul 1:',
        netProfit: 'Profit net anul 1:',
        roi: 'ROI:',
        breakEven: 'Recuperare investiție:',
        month: 'Luna',
        years: 'ani',
        followingYears: 'Ani următori:',
        followingYearsDesc: 'Investiție doar',
        followingYearsSavings: 'Economie anuală de',
        smallCompanyWarning: 'Pentru dimensiunea actuală a firmei tale, sistemul s-ar putea recupera în mai mult de un an. Hai să discutăm despre nevoile tale specifice și să găsim cea mai bună soluție.'
      },
      emailForm: {
        title: 'Primește Analiza Detaliată',
        subtitle: 'Lasă-ne email-ul tău și te contactăm pentru o consultație personalizată despre situația firmei tale.',
        emailLabel: 'Email',
        emailPlaceholder: 'nume@companie.ro',
        submitButton: 'Trimite și Programează Consultație →',
        submitting: 'Se trimite...',
        error: 'A apărut o eroare. Te rugăm să ne contactezi direct.',
        features: {
          consultation: 'Consultație personalizată',
          recommendations: 'Recomandări concrete',
          noSpam: 'Zero spam'
        }
      },
      success: {
        title: 'Mulțumim!',
        message: 'Am primit datele tale. Te vom contacta în următoarele 24 de ore pentru o consultație personalizată.',
        callPrompt: 'Între timp, ne poți suna direct pentru a discuta mai repede:',
        phone: '+40 787 683 304'
      },
      callDirect: {
        title: 'Sau sună direct pentru o consultație:',
        phone: '+40 787 683 304'
      }
    },
    blog: {
      meta: {
        title: 'Blog - Ghiduri Management Constructii, Control Operational, GPS Flota, Pontaj | ControlMax Romania',
        description: 'Articole experte despre management constructii, optimizare costuri, control operational, GPS tracking flota, pontaj electronic. Ghiduri practice, studii de caz si best practices pentru constructii Romania.',
        keywords: 'blog constructii romania, ghid management santier, articole control operational constructii, pontaj electronic ghid, gps flota tutorial, optimizare costuri constructii, management proiecte blog, software constructii articole',
        blogName: 'ControlMax Blog',
        blogDescription: 'Ghiduri si articole despre management constructii, control operational, GPS si pontaj'
      },
      listing: {
        badge: 'Cunoștințe Expert',
        title: 'Blog ControlMax',
        subtitle: 'Ghiduri complete, strategii dovedite și insight-uri practice pentru optimizarea business-ului tău în construcții.',
        readTime: 'citire',
        readArticle: 'Citește articolul',
        ctaTitle: 'Vrei să Aplici Aceste Strategii?',
        ctaDescription: 'Toate strategiile din articolele noastre sunt implementate în ControlMax. Vezi cum funcționează în practică cu o demonstrație personalizată.',
        ctaButton: 'Solicită Demo Gratuit'
      },
      post: {
        backToBlog: 'Înapoi la Blog',
        backToAllArticles: 'Înapoi la toate articolele',
        readTime: 'citire',
        calculateNow: 'Calculează Acum',
        ctaTitle: 'Implementează Strategiile Din Acest Articol',
        ctaDescription: 'Vezi cum ControlMax te ajută să aplici toate strategiile prezentate. Programează o demonstrație personalizată - 30 minute, zero obligații.',
        ctaButton: 'Solicită Demo Gratuit'
      }
    },
    newsletter: {
      meta: {
        title: 'Newsletter - ControlMax',
        description: 'Abonează-te la newsletter-ul ControlMax și primește cele mai recente articole, sfaturi și noutăți despre software-ul de management pentru afaceri.'
      },
      header: {
        title: 'Abonează-te la Newsletter',
        subtitle: 'Primește cele mai recente articole, ghiduri practice și noutăți despre optimizarea afacerii tale direct în inbox.'
      },
      benefits: {
        articles: {
          title: 'Articole & Ghiduri',
          description: 'Conținut de calitate despre eficiență operațională, management financiar și automatizare'
        },
        trends: {
          title: 'Tendințe & Insights',
          description: 'Cele mai recente evoluții în software-ul de business și tehnologie'
        },
        caseStudies: {
          title: 'Studii de Caz',
          description: 'Povești reale de succes de la companii care au optimizat procesele'
        },
        solutions: {
          title: 'Soluții Practice',
          description: 'Sfaturi acționabile pentru a-ți îmbunătăți operațiunile de business'
        }
      },
      recentArticles: {
        title: 'Articole Recente',
        viewAll: 'Vezi Toate Articolele'
      }
    },
    unsubscribe: {
      meta: {
        title: 'Dezabonare Newsletter - ControlMax',
        description: 'Dezabonează-te de la newsletter-ul ControlMax'
      },
      loading: {
        title: 'Se procesează cererea...',
        message: 'Te rugăm să aștepți câteva momente.'
      },
      success: {
        title: 'Dezabonare Reușită',
        message: 'Adresa {email} a fost dezabonată cu succes.',
        regret: 'Ne pare rău că pleci. Nu vei mai primi emailuri de la noi.',
        resubscribeInfo: 'Dacă ți-ai schimbat părerea, poți să te abonezi din nou oricând.',
        resubscribeButton: 'Reabonează-te',
        homeButton: 'Înapoi la Homepage',
        deleteButton: 'Șterge complet datele mele',
        deleteWarning: 'Această acțiune va șterge permanent toate datele tale din sistemul nostru',
        confirmDelete: 'Sigur vrei să ștergi complet toate datele tale? Această acțiune este ireversibilă.'
      },
      already: {
        title: 'Deja Dezabonat',
        message: 'Adresa {email} este deja dezabonată.',
        noEmails: 'Nu vei primi emailuri de la noi.',
        resubscribeInfo: 'Dacă vrei să primești din nou emailurile noastre, te poți reabona.',
        resubscribeButton: 'Reabonează-te',
        homeButton: 'Înapoi la Homepage',
        deleteButton: 'Șterge complet datele mele',
        deleteWarning: 'Această acțiune va șterge permanent toate datele tale din sistemul nostru'
      },
      deleted: {
        title: 'Date Șterse cu Succes',
        message: 'Toate datele tale au fost șterse permanent din sistemul nostru.',
        futureInfo: 'Dacă dorești să te abonezi din nou în viitor, vei putea face acest lucru oricând.',
        subscribeButton: 'Abonează-te',
        homeButton: 'Înapoi la Homepage'
      },
      error: {
        title: 'Eroare la Dezabonare',
        message: 'Ne pare rău, dar link-ul de dezabonare este invalid sau a expirat.',
        help: 'Dacă ai probleme în continuare, te rugăm să ne contactezi.',
        contactButton: 'Contactează-ne',
        homeButton: 'Înapoi la Homepage',
        deleteError: 'Eroare la ștergerea datelor. Te rugăm să încerci din nou.'
      }
    },
    gdpr: {
      meta: {
        title: 'Conformitate GDPR - ControlMax',
        description: 'ControlMax este complet conform cu Regulamentul General privind Protecția Datelor (GDPR)'
      },
      header: {
        title: 'Conformitate GDPR',
        subtitle: 'ControlMax este complet conform cu Regulamentul General privind Protecția Datelor (GDPR)'
      },
      commitment: {
        title: 'Angajamentul Nostru GDPR',
        content: 'ControlMax tratează protecția datelor personale cu cea mai mare seriozitate. Am implementat toate măsurile tehnice și organizatorice necesare pentru a asigura conformitatea completă cu GDPR și pentru a proteja drepturile persoanelor vizate.'
      },
      principles: {
        title: 'Principiile GDPR pe Care le Respectăm',
        legality: {
          title: '1. Legalitate, Corectitudine și Transparență',
          content: 'Procesăm datele în mod legal, corect și transparent. Vă informăm întotdeauna despre ce date colectăm și de ce.'
        },
        purposeLimitation: {
          title: '2. Limitarea Scopului',
          content: 'Colectăm date doar pentru scopuri specifice, explicite și legitime. Nu le folosim ulterior în moduri incompatibile cu aceste scopuri.'
        },
        dataMinimization: {
          title: '3. Minimizarea Datelor',
          content: 'Colectăm doar datele adecvate, relevante și limitate la ceea ce este necesar pentru scopurile procesării.'
        },
        accuracy: {
          title: '4. Acuratețea',
          content: 'Menținem datele corecte și actualizate. Datele incorecte sunt șterse sau rectificate fără întârziere.'
        },
        storageLimitation: {
          title: '5. Limitarea Stocării',
          content: 'Păstrăm datele doar cât timp este necesar pentru scopurile pentru care sunt procesate.'
        },
        integrity: {
          title: '6. Integritate și Confidențialitate',
          content: 'Procesăm datele într-o manieră care asigură securitatea adecvată, inclusiv protecția împotriva procesării neautorizate sau ilegale.'
        }
      },
      rights: {
        title: 'Drepturile Dumneavoastră GDPR',
        access: {
          title: 'Dreptul de Acces',
          description: 'Aveți dreptul să obțineți o copie a datelor personale pe care le procesăm despre dumneavoastră.'
        },
        rectification: {
          title: 'Dreptul la Rectificare',
          description: 'Puteți solicita corectarea datelor incorecte sau completarea datelor incomplete.'
        },
        erasure: {
          title: 'Dreptul la Ștergere ("Dreptul de a Fi Uitat")',
          description: 'În anumite circumstanțe, puteți solicita ștergerea datelor dumneavoastră personale.'
        },
        restriction: {
          title: 'Dreptul la Restricționarea Prelucrării',
          description: 'Puteți solicita limitarea modului în care procesăm datele dumneavoastră în anumite situații.'
        },
        portability: {
          title: 'Dreptul la Portabilitatea Datelor',
          description: 'Puteți solicita datele dumneavoastră într-un format structurat, utilizat în mod curent și care poate fi citit automat.'
        },
        objection: {
          title: 'Dreptul la Opoziție',
          description: 'Puteți vă opune prelucrării datelor bazate pe interes legitim sau pentru marketing direct.'
        },
        withdraw: {
          title: 'Dreptul la Retragerea Consimțământului',
          description: 'Unde prelucrarea se bazează pe consimțământ, îl puteți retrage oricând.'
        }
      },
      security: {
        title: 'Măsuri de Securitate',
        intro: 'Am implementat măsuri tehnice și organizatorice robuste pentru protejarea datelor:',
        measures: {
          encryption: 'Criptare end-to-end pentru datele în tranzit și în repaus',
          mfa: 'Autentificare multi-factor disponibilă',
          rbac: 'Acces bazat pe rol (RBAC) pentru control granular',
          monitoring: 'Monitorizare continuă și detectare intruziuni',
          audit: 'Audit trails complete pentru toate operațiunile sensibile',
          backup: 'Backup-uri criptate și testate regular',
          training: 'Training GDPR obligatoriu pentru tot personalul'
        }
      },
      transfers: {
        title: 'Transferuri Internaționale',
        content: 'Datele sunt stocate și procesate în Uniunea Europeană. În cazul în care folosim furnizori terți din afara UE, ne asigurăm că există garanții adecvate (clauze contractuale standard sau certificări Privacy Shield) pentru protecția datelor dumneavoastră.'
      },
      breaches: {
        title: 'Încălcări ale Securității Datelor',
        content: 'În cazul unei încălcări a securității datelor care prezintă un risc pentru drepturile și libertățile dumneavoastră, vă vom notifica în termen de 72 de ore conform cerințelor GDPR. De asemenea, vom notifica autoritățile de supraveghere relevante.'
      },
      impact: {
        title: 'Evaluări de Impact',
        content: 'Efectuăm evaluări periodice de impact asupra protecției datelor (DPIA) pentru funcționalități noi care pot prezenta riscuri ridicate pentru drepturile persoanelor vizate, cum ar fi tracking GPS sau procesare automată a deciziilor.'
      },
      exercise: {
        title: 'Cum să Vă Exercitați Drepturile',
        intro: 'Pentru a vă exercita oricare dintre drepturile GDPR, vă rugăm să ne contactați:',
        dpoTitle: 'Responsabil cu Protecția Datelor (DPO)',
        email: 'Email: dpo@controlmax.ro',
        phone: 'Telefon: +40 790 827 957',
        response: 'Vom răspunde cererii dumneavoastră în termen de 30 de zile.'
      },
      authority: {
        title: 'Autoritate de Supraveghere',
        intro: 'Dacă considerați că drepturile dumneavoastră GDPR au fost încălcate, aveți dreptul să depuneți o plângere la autoritatea de supraveghere competentă:',
        name: 'Autoritatea Națională de Supraveghere a Prelucrării Datelor cu Caracter Personal (ANSPDCP)',
        website: 'Website: www.dataprotection.ro',
        email: 'Email: anspdcp@dataprotection.ro',
        phone: 'Telefon: +40 21 252 5599'
      }
    },
    terms: {
      meta: {
        title: 'Termeni și Condiții - ControlMax',
        description: 'Termeni și condiții de utilizare a platformei ControlMax'
      },
      header: {
        title: 'Termeni și Condiții',
        lastUpdated: 'Ultima actualizare: Ianuarie 2025'
      },
      acceptance: {
        title: '1. Acceptarea Termenilor',
        content: 'Prin accesarea și utilizarea platformei ControlMax, acceptați să respectați acești termeni și condiții. Dacă nu sunteți de acord cu acești termeni, vă rugăm să nu utilizați serviciile noastre.'
      },
      services: {
        title: '2. Descrierea Serviciilor',
        intro: 'ControlMax oferă o platformă software de management pentru companii din domeniul construcțiilor și serviciilor, incluzând dar fără a se limita la:',
        items: {
          hr: 'Gestionarea resurselor umane și pontaj',
          gps: 'Tracking GPS și management flotă',
          procurement: 'Gestiunea achizițiilor și stocurilor',
          documents: 'Management documente și contracte',
          reporting: 'Raportare și business intelligence'
        }
      },
      accounts: {
        title: '3. Conturi de Utilizator',
        paragraph1: 'Pentru a utiliza serviciile ControlMax, trebuie să creați un cont. Sunteți responsabil pentru menținerea confidențialității datelor de autentificare și pentru toate activitățile desfășurate sub contul dumneavoastră.',
        paragraph2: 'Vă obligați să furnizați informații corecte, actuale și complete despre compania și utilizatorii dumneavoastră.'
      },
      fees: {
        title: '4. Taxe și Plăți',
        paragraph1: 'Utilizarea platformei ControlMax este supusă taxelor de abonament stabilite în planul selectat. Toate taxele sunt exclusive de TVA, cu excepția cazului în care se specifică altfel.',
        paragraph2: 'Plățile sunt procesate lunar sau anual, în funcție de planul ales. Neefectuarea plăților la timp poate duce la suspendarea serviciilor.'
      },
      intellectual: {
        title: '5. Proprietate Intelectuală',
        paragraph1: 'Platforma ControlMax, inclusiv dar fără a se limita la software, design, conținut, mărci comerciale și logo-uri, sunt proprietatea exclusivă a ControlMax și sunt protejate de legile privind proprietatea intelectuală.',
        paragraph2: 'Datele introduse de dumneavoastră în platformă rămân proprietatea dumneavoastră. ControlMax nu revendică niciun drept asupra acestor date.'
      },
      liability: {
        title: '6. Limitarea Răspunderii',
        paragraph1: 'ControlMax furnizează platforma "ca atare" și nu oferă garanții explicite sau implicite cu privire la funcționarea neîntreruptă sau fără erori a serviciilor.',
        paragraph2: 'În niciun caz ControlMax nu va fi răspunzător pentru daune indirecte, incidentale, speciale sau consecvente rezultate din utilizarea sau imposibilitatea de utilizare a serviciilor.'
      },
      termination: {
        title: '7. Rezilierea',
        paragraph1: 'Puteți rezilia contul dumneavoastră în orice moment prin notificarea echipei ControlMax. La reziliere, veți avea acces la datele dumneavoastră pentru o perioadă de 30 de zile pentru export.',
        paragraph2: 'ControlMax își rezervă dreptul de a suspenda sau rezilia conturile care încalcă acești termeni și condiții.'
      },
      changes: {
        title: '8. Modificări ale Termenilor',
        content: 'ControlMax își rezervă dreptul de a modifica acești termeni în orice moment. Modificările vor fi comunicate prin email cu 30 de zile înainte de intrarea în vigoare. Utilizarea continuă a serviciilor după aceste modificări constituie acceptarea noilor termeni.'
      },
      law: {
        title: '9. Legea Aplicabilă',
        content: 'Acești termeni și condiții sunt guvernați de legile României. Orice dispută va fi soluționată în instanțele competente din România.'
      },
      contact: {
        title: '10. Contact',
        content: 'Pentru întrebări referitoare la acești termeni, vă rugăm să ne contactați la contact@controlmax.ro sau la +40 790 827 957.'
      }
    },
    privacy: {
      meta: {
        title: 'Politica de Confidențialitate - ControlMax',
        description: 'Politica de confidențialitate și protecție a datelor personale ControlMax'
      },
      header: {
        title: 'Politica de Confidențialitate',
        lastUpdated: 'Ultima actualizare: Ianuarie 2025'
      },
      introduction: {
        title: '1. Introducere',
        paragraph1: 'ControlMax respectă confidențialitatea datelor dumneavoastră personale și se angajează să protejeze informațiile pe care le colectăm și le procesăm în conformitate cu Regulamentul General privind Protecția Datelor (GDPR) și legislația aplicabilă din România.',
        paragraph2: 'Această politică descrie ce date colectăm, cum le utilizăm, cum le protejăm și care sunt drepturile dumneavoastră.'
      },
      dataCollected: {
        title: '2. Date Colectate',
        intro: 'Colectăm următoarele categorii de date personale:',
        items: {
          identification: '<strong>Date de identificare:</strong> nume, prenume, adresă email, număr de telefon',
          company: '<strong>Date despre companie:</strong> denumire, CUI, adresă, date de contact',
          authentication: '<strong>Date de autentificare:</strong> username, parolă criptată',
          usage: '<strong>Date de utilizare:</strong> log-uri de acces, adrese IP, tip browser, dispozitiv',
          location: '<strong>Date de localizare:</strong> coordonate GPS pentru tracking vehicule și pontaj (doar cu consimțământul explicit)',
          financial: '<strong>Date financiare:</strong> informații despre plăți și facturare (procesate prin procesatori terți certificați PCI DSS)'
        }
      },
      purpose: {
        title: '3. Scopul Prelucrării',
        intro: 'Utilizăm datele colectate pentru următoarele scopuri:',
        items: {
          services: 'Furnizarea serviciilor platformei ControlMax',
          account: 'Gestionarea contului și autentificarea utilizatorilor',
          payments: 'Procesarea plăților și emiterea facturilor',
          communication: 'Comunicarea cu clienții și suport tehnic',
          improvement: 'Îmbunătățirea și optimizarea serviciilor',
          legal: 'Respectarea obligațiilor legale',
          security: 'Prevenirea fraudei și asigurarea securității'
        }
      },
      legalBasis: {
        title: '4. Baza Legală a Prelucrării',
        intro: 'Prelucrăm datele dumneavoastră pe următoarele baze legale:',
        items: {
          contract: '<strong>Executarea contractului:</strong> pentru furnizarea serviciilor solicitate',
          consent: '<strong>Consimțământul:</strong> pentru anumite funcționalități opționale (ex: tracking GPS)',
          legal: '<strong>Obligație legală:</strong> pentru respectarea cerințelor fiscale și legale',
          legitimate: '<strong>Interes legitim:</strong> pentru îmbunătățirea serviciilor și prevenirea fraudei'
        }
      },
      sharing: {
        title: '5. Partajarea Datelor',
        intro: 'Nu vindem, închiriem sau partajăm datele dumneavoastră personale cu terțe părți pentru scopuri de marketing. Putem partaja date doar în următoarele circumstanțe:',
        items: {
          providers: '<strong>Furnizori de servicii:</strong> procesatori de plăți, servicii cloud hosting, servicii email (toți respectă GDPR)',
          legal: '<strong>Obligații legale:</strong> autorități publice când este cerut de lege',
          consent: '<strong>Consimțământ explicit:</strong> când ați dat acordul pentru partajare'
        }
      },
      security: {
        title: '6. Securitatea Datelor',
        intro: 'Implementăm măsuri tehnice și organizatorice pentru protejarea datelor:',
        items: {
          ssl: 'Criptare SSL/TLS pentru transmiterea datelor',
          database: 'Criptare a bazelor de date',
          twoFactor: 'Autentificare cu doi factori (2FA) disponibilă',
          monitoring: 'Monitorizare continuă și log-uri de securitate',
          access: 'Acces restricționat la date doar pentru personalul autorizat',
          backup: 'Backup-uri regulate și plan de recuperare în caz de dezastru'
        }
      },
      retention: {
        title: '7. Păstrarea Datelor',
        content: 'Păstrăm datele dumneavoastră personale doar cât timp este necesar pentru îndeplinirea scopurilor pentru care au fost colectate sau conform obligațiilor legale (ex: 10 ani pentru documentele fiscale). După rezilierea contului, datele sunt șterse în termen de 90 de zile, cu excepția celor necesare pentru respectarea obligațiilor legale.'
      },
      rights: {
        title: '8. Drepturile Dumneavoastră',
        intro: 'Conform GDPR, aveți următoarele drepturi:',
        items: {
          access: '<strong>Dreptul de acces:</strong> să obțineți o copie a datelor prelucrate',
          rectification: '<strong>Dreptul la rectificare:</strong> să corectați date incorecte sau incomplete',
          erasure: '<strong>Dreptul la ștergere:</strong> să solicitați ștergerea datelor ("dreptul de a fi uitat")',
          restriction: '<strong>Dreptul la restricționare:</strong> să limitați prelucrarea în anumite condiții',
          portability: '<strong>Dreptul la portabilitate:</strong> să primiți datele într-un format structurat',
          objection: '<strong>Dreptul la opoziție:</strong> să vă opuneți prelucrării bazate pe interes legitim',
          withdraw: '<strong>Dreptul de retragere a consimțământului:</strong> oricând pentru prelucrări bazate pe consimțământ'
        },
        contact: 'Pentru exercitarea acestor drepturi, contactați-ne la contact@controlmax.ro.'
      },
      cookies: {
        title: '9. Cookie-uri',
        content: 'Utilizăm cookie-uri esențiale pentru funcționarea platformei (autentificare, preferințe). Nu folosim cookie-uri de marketing fără consimțământul dumneavoastră explicit.'
      },
      changes: {
        title: '10. Modificări ale Politicii',
        content: 'Ne rezervăm dreptul de a actualiza această politică. Vă vom notifica prin email despre orice modificări semnificative cu 30 de zile înainte de implementare.'
      },
      dpo: {
        title: '11. Contact DPO',
        intro: 'Responsabil cu Protecția Datelor (DPO):',
        email: 'Email: dpo@controlmax.ro',
        phone: 'Telefon: +40 790 827 957'
      }
    }
  },
  en: {
    nav: {
      home: 'Home',
      features: 'Solutions',
      blog: 'Blog',
      about: 'About',
      contact: 'Contact',
      demo: 'Free Demo',
      costCenters: 'Cost Centers',
      hrPontaj: 'HR & Timesheet',
      logistics: 'Logistics',
      procurement: 'Procurement',
      equipment: 'Equipment',
      documents: 'Documents'
    },
    home: {
      hero: {
        badge: 'Built by Construction Pros, for Construction Pros',
        title: 'Know exactly where every dollar goes',
        subtitle: 'Real-time visibility into project, site, and labor costs. Automated reporting with precise budget controls.',
        challenges: 'Sound familiar?',
        challenge1: 'No real-time visibility into costs',
        challenge2: 'Hours wasted on manual reports',
        challenge3: 'Budget overruns you can\'t control',
        ctaCalculator: 'Calculate Your Losses',
        ctaDemo: 'See it in Action',
        features: 'Professional Setup • Full Implementation • Dedicated Support',
        trustedBy: 'Trusted by construction and service leaders',
        live: 'Live'
      },
      stats: {
        title: 'Real Results',
        costReduction: 'Cost savings',
        teamEfficiency: 'Team productivity',
        stockOptimization: 'Inventory optimization'
      },
      digital: {
        title: 'The jobsite is today. Digital is tomorrow.',
        subtitle: 'From field to office, on autopilot',
        description: 'Every jobsite action instantly becomes structured data, reports, and smart insights',
        timeTracking: {
          title: 'Automatic time tracking with facial recognition',
          description: 'Workers clock in from their phones with a unique code and photo. Data syncs instantly—no paperwork, no errors.',
          badge: 'Instant sync'
        },
        gpsTracking: {
          title: 'Live GPS tracking and fuel monitoring',
          description: 'Track your entire fleet with integrated GPS. Fuel purchases from Rompetrol & OMV automatically link to vehicles and sites.',
          badge: 'Direct Rompetrol & OMV integration'
        },
        procurement: {
          title: 'Procurement synced with job estimates',
          description: 'Every material order automatically links to its project and cost center. Inventory updates the moment materials arrive.',
          badge: 'Automatic reporting'
        },
        documents: {
          title: 'Smart contracts and document handling',
          description: 'AI extracts data from PDFs, generates contracts, and sends deadline reminders. No manual data entry.',
          badge: 'AI-powered'
        },
        result: {
          title: 'The bottom line: total control, zero busywork',
          description: 'You focus on the big decisions. The platform handles data collection, processing, and reporting.'
        },
        features: {
          costCenters: 'Cost centers',
          costCentersDesc: 'Track unlimited projects, sites, and departments',
          instantReporting: 'Instant reporting',
          instantReportingDesc: 'Real-time data ready when you need it',
          fullControl: 'Full control',
          fullControlDesc: 'Complete visibility into every cost'
        }
      },
      mobileApp: {
        title: 'Mobile App for Jobsite',
        subtitle: 'Everything at your fingertips, right from the construction site',
        description: 'The ControlMax mobile app turns your smartphone into the jobsite command center. Complete management, no paperwork, no office.',
        features: {
          timeTracking: {
            title: 'Employee & Equipment Time Tracking',
            description: 'Simple time tracking with facial recognition. Record attendance for employees and work hours for equipment - all with one tap.'
          },
          equipment: {
            title: 'Equipment Management',
            description: 'QR scan for quick inventory. Assign equipment to employees and track location in real time.'
          },
          stock: {
            title: 'Stock with a Photo',
            description: 'AI recognizes materials from photos. Add or remove from stock instantly - no forms, no manual entry.'
          },
          dailyProgram: {
            title: 'Daily Schedule',
            description: 'Task list for each team. Real-time updates and automatic sync with the office.'
          },
          reports: {
            title: 'Instant Reports',
            description: 'Generate jobsite report with a few taps. Photos, consumptions, issues - all centralized and sent automatically.'
          },
          routeSheets: {
            title: 'Automatic Waybills',
            description: 'Automatic GPS tracking for vehicles. Waybills generated automatically with real routes and consumption.'
          }
        },
        cta: 'Try the app',
        ctaSubtitle: 'Free download • No card required'
      },
      easyToUse: {
        title: 'Simple. Intuitive. Easy to use.',
        subtitle: 'No learning curve. No complications. Your team will figure it out in 5 minutes.',
        features: {
          noTraining: {
            title: 'Zero training required',
            description: 'Intuitive interface, designed for field workers. Learn as you go.'
          },
          instantStart: {
            title: 'Instant start',
            description: 'Log in and start working immediately. Setup in under 10 minutes.'
          },
          everywhere: {
            title: 'Works everywhere',
            description: 'Desktop, tablet, phone. Online or offline. Automatic sync.'
          }
        }
      },
      dashboard: {
        title: 'Live data from the jobsite',
        subtitle: 'Real-time cost center control',
        description: 'Every time entry, fuel purchase, and material order syncs automatically from the field. Better data, faster decisions.',
        heading: 'Cost Centers Dashboard',
        subheading: 'Data automatically updated from field',
        live: 'Live',
        projects: {
          bucharest: 'Bucharest North Site',
          cluj: 'Cluj Project',
          timisoara: 'Timisoara Site'
        },
        costs: {
          materials: 'Materials:',
          labor: 'Labor:',
          equipment: 'Equipment:'
        },
        updated: {
          now2min: 'Updated 2 min ago',
          now5min: 'Updated 5 min ago',
          now1min: 'Updated 1 min ago'
        },
        liveTitle: 'Live jobsite data',
        autoUpdate: 'Updates automatically with every action',
        features: {
          timeTracking: 'Time entries and attendance sync instantly from crew phones',
          fuel: 'Fuel purchases auto-sync from Rompetrol & OMV',
          gps: 'GPS-tracked equipment with real-time usage data',
          procurement: 'Material purchases automatically link to cost centers'
        },
        cta: 'See a live demo',
        ctaSubtitle: 'Watch the platform in action with your own data'
      },
      features: {
        title: 'Everything You Need',
        subtitle: 'All-in-One Platform',
        description: 'Every tool you need for complete control, in one place',
        hr: {
          title: 'HR & Time Tracking',
          description: 'Automated time management, attendance, and leave tracking. Instant reports for every employee.'
        },
        logistics: {
          title: 'Logistics & Fleet',
          description: 'Real-time GPS tracking. Optimize routes and cut costs by up to 25%.'
        },
        procurement: {
          title: 'Procurement & Inventory',
          description: 'Total supply chain visibility. Automate orders and predict needs.'
        },
        equipment: {
          title: 'Equipment Management',
          description: 'Track every piece of equipment. AI-powered predictive maintenance.'
        },
        documents: {
          title: 'Document Management',
          description: 'Go fully digital. Auto-generate reports with e-signatures.'
        },
        analytics: {
          title: 'AI Analytics',
          description: 'Interactive dashboards. Predictive insights and real-time AI recommendations.'
        },
        fuel: {
          title: 'Fuel Management',
          description: 'Direct integration with fuel pumps. Monitor consumption and catch anomalies automatically.'
        },
        costCenters: {
          title: 'Cost Centers',
          description: 'Automatic project allocation. Smart budgets with predictive alerts.'
        },
        security: {
          title: 'Enterprise Security',
          description: 'Bank-grade protection. GDPR compliant with real-time backups.'
        }
      },
      benefits: {
        title: 'Proven Results',
        subtitle: 'Real data from companies using ControlMax',
        costReduction: {
          percentage: '23%',
          title: 'Lower operating costs',
          description: 'Average savings in first year'
        },
        efficiency: {
          percentage: '30%',
          title: 'Higher team productivity',
          description: 'Streamlined processes and reporting'
        },
        stock: {
          percentage: '41%',
          title: 'Better inventory management',
          description: 'Reduced carrying costs'
        },
        roi: {
          title: 'ROI in 90 Days',
          description: 'Recover your investment in under 3 months through lower costs and higher productivity.'
        },
        automation: {
          title: '100% Process Automation',
          description: 'No more repetitive tasks. Your team focuses on what matters.'
        },
        ai: {
          title: 'Real-Time AI Predictions',
          description: 'AI catches problems early and suggests solutions before they escalate.'
        },
        scale: {
          title: 'Unlimited Scalability',
          description: 'From 10 to 10,000 users. The platform scales with you.'
        },
        support: {
          title: '24/7 Premium Support',
          description: 'Dedicated team available around the clock. Fast answers every time.'
        },
        integrations: {
          title: 'Unlimited API Integrations',
          description: 'Connect with any system. Open API with full documentation.'
        }
      },
      testimonials: {
        title: 'What Our Clients Say',
        subtitle: 'Companies that went digital',
        testimonial1: {
          text: 'ControlMax completely changed how we run projects. Real-time visibility means we can make smart decisions fast.',
          author: 'General Manager',
          role: 'M.I.S Group'
        },
        testimonial2: {
          text: 'We saw major cost savings within 6 months. Automated reporting saves us dozens of hours every month.',
          author: 'General Manager',
          role: 'Unitip Global'
        },
        testimonial3: {
          text: 'Super intuitive—our team picked it up fast. Support is top-notch and responds right away.',
          author: 'Andrei Vasile',
          role: 'Operations Director, MegaServ'
        }
      },
      howItWorks: {
        title: 'Fast Implementation',
        subtitle: 'Get Started in 3 Steps',
        description: 'Tailored setup for your business',
        step1: {
          number: '01',
          title: 'Custom Setup',
          description: 'We learn your needs and build the right solution. Import data from any system and configure AI for your business.'
        },
        step2: {
          number: '02',
          title: 'Team Training',
          description: 'A dedicated specialist trains your crew. Video tutorials and live support for everyone.'
        },
        step3: {
          number: '03',
          title: 'Launch & Grow',
          description: 'Go live with a fully working system. 24/7 monitoring and continuous AI improvements.'
        }
      },
      cta: {
        title: 'Ready to see what ControlMax can do?',
        subtitle: 'Book a live demo and see how ControlMax can transform the way you run your business',
        button: 'Schedule Demo',
        buttonAlt: 'Talk to a Specialist',
        guarantee: '30-minute personalized demo • Free • No commitment'
      },
      faq: {
        title: 'Common Questions About Construction Management Software',
        subtitle: 'Everything you need to know about implementing a management system for construction and services',
        contact: 'Still have questions about how ControlMax can help your company?',
        contactButton: 'Get in touch',
        questions: [
          {
            question: 'What is a construction management platform and how does it help my company?',
            answer: 'A construction management platform is an integrated software system that centralizes all operational processes: project management, HR time tracking, fleet GPS tracking, logistics, procurement, cost centers and documents. ControlMax automates workflows, provides real-time reporting and eliminates repetitive manual work, reducing operational costs by up to 23% and increasing team efficiency by 30%.'
          },
          {
            question: 'How does the cost center system work for construction sites?',
            answer: 'Cost centers in ControlMax allow precise tracking of all expenses and revenues for each project or site separately. Each time entry, invoice, material delivery note or fuel cost is automatically allocated to the corresponding cost center. You have complete real-time visibility on each site\'s profitability, can compare performance between projects and make quick decisions based on concrete data, not estimates.'
          },
          {
            question: 'How does GPS tracking help reduce fleet costs?',
            answer: 'The ControlMax GPS system monitors all construction vehicles and equipment in real time. It automatically detects non-optimal routes, excessive fuel consumption, unscheduled stops and unauthorized use. Through integration with Rompetrol, OMV and other stations, you automatically verify each refueling and eliminate fraud. Companies reduce fuel costs by 15-25% in the first 3 months and optimize fleet utilization through intelligent site allocation.'
          },
          {
            question: 'What does automated HR time tracking mean and why is it better than Excel?',
            answer: 'Automated HR time tracking replaces Excel sheets and manual records with a digital system accessible from phone or tablet. Employees clock in through facial recognition or GPS, data syncs instantly to the cloud, and payroll reporting is done automatically. It eliminates human errors, time fraud (when colleagues clock in for each other), and saves 10-15 hours/month of administrative work. Integration with cost centers automatically allocates labor costs to each site.'
          },
          {
            question: 'How long does implementation take and when do we see results?',
            answer: 'ControlMax implementation takes 2-4 weeks, depending on company size and process complexity. In the first 7 days, the time tracking and GPS tracking systems are already functional. Results appear quickly: reduced administrative errors in the first 2 weeks, complete cost visibility in month 1, full ROI (investment recovery) in 90 days through operational cost reduction. Clients report average savings of 23% in the first year.'
          },
          {
            question: 'Is it suitable for small companies or only for large ones?',
            answer: 'ControlMax is scalable and perfectly adapts to both small companies (5-20 employees, 1-3 sites) and large companies (100+ employees, 10+ sites). Small companies benefit from automation and organization without hiring additional administrative staff. Large companies gain centralized control and consolidated reporting across all divisions. Pricing adjusts based on number of users and modules used, so the investment is proportional to business size.'
          },
          {
            question: 'What sets ControlMax apart from other construction solutions?',
            answer: 'ControlMax is the only system built specifically for the Romanian construction and services market, with native integrations for Rompetrol, OMV, local RO legislation and Romanian language. Unlike generic solutions or adaptations from international systems, ControlMax understands the specifics of Romanian construction sites: card or facial time tracking, fuel tracking with local pump integration, reporting according to labor inspection and RO tax requirements. Plus, rapid technical support in Romanian, not external call center.'
          },
          {
            question: 'How does it integrate with existing systems (accounting, payroll)?',
            answer: 'ControlMax integrates via API with most accounting and payroll systems used in Romania (Saga, SAP, WizOne, Clarvision, etc). Time tracking, invoice, and delivery note data is automatically exported in the format required for your existing system. You don\'t have to replace everything - ControlMax overlays operational processes (tracking, time tracking, logistics, site) and automatically feeds back-office financial systems. Implementation includes configuring all necessary integrations.'
          },
          {
            question: 'Is it safe to keep all company data in a cloud system?',
            answer: 'Yes, security is a priority. ControlMax uses bank-level encryption (AES-256) for all data, hosting in EU-certified data centers (GDPR compliant), automatic daily backup and disaster recovery in maximum 4 hours. Your data is safer in the cloud than on an unsecured laptop or local server. You have full control over access: which user sees what data, complete modification history, and export right anytime. 100% compliance with GDPR and Romanian data protection legislation.'
          },
          {
            question: 'Does ControlMax offer a mobile app for construction sites and field work?',
            answer: 'Yes, ControlMax offers native mobile apps for iOS and Android optimized for field work on construction sites. They work offline (synchronization when internet returns), allow employee time tracking, delivery note photography with OCR (automatic text recognition), incident reporting, GPS tracking, and access to project documents. The interface is simple, adapted for small screens and work gloves, so even less technical site managers can use it easily.'
          }
        ]
      }
    },
    contact: {
      title: 'Get in Touch',
      subtitle: 'We\'re here to help. Reach out with questions or to schedule a demo.',
      phone: {
        title: 'Phone',
        number: '0787 683 304',
        schedule: 'Monday - Friday: 09:00 - 18:00'
      },
      email: {
        title: 'Email',
        address: 'contact@controlmax.ro',
        response: 'We reply within 24 hours'
      },
      form: {
        title: 'Drop us a line',
        name: 'Full name',
        namePlaceholder: 'John Doe',
        email: 'Email',
        emailPlaceholder: 'john@company.com',
        company: 'Company',
        companyPlaceholder: 'Your company name',
        phone: 'Phone',
        phonePlaceholder: '+40 7XX XXX XXX',
        message: 'Message',
        messagePlaceholder: 'How can we help?',
        submit: 'Send message',
        submitting: 'Sending...'
      },
      success: {
        title: 'Thanks for reaching out!',
        message: 'Message sent. We\'ll get back to you soon.'
      },
      error: {
        message: 'Something went wrong. Please try again.'
      },
      demo: {
        title: 'Want to see it live?',
        description: 'Book a 30-minute demo with a ControlMax specialist and see the platform in action with your own data.',
        cta: 'Schedule Demo →'
      }
    },
    despre: {
      badge: 'About ControlMax',
      hero: {
        title1: 'Built by Builders,',
        title2: 'For Builders',
        subtitle: 'ControlMax isn\'t just software. It\'s a solution built from real jobsite challenges, alongside the engineers and contractors who live them every day.'
      },
      story: {
        icon: 'Lightbulb',
        title: 'Our Story',
        paragraph1: 'ControlMax was born on the jobsite, not in an office. It started when we saw firsthand how engineers and contractors wrestled daily with outdated processes, paper trails, and zero visibility into resources and costs.',
        paragraph2: 'We spent months embedded with construction pros—site supervisors, project engineers, technical directors, GCs, and fleet managers. We listened to every pain point, every unmet need, every hour wasted from lack of real-time data.',
        paragraph3: 'Every feature comes straight from the field.',
        paragraph3Prefix: 'Every feature comes straight from the field. ',
        paragraph3Rest: 'Predictive maintenance? That came from a fleet director bleeding cash on emergency repairs. GPS-based time tracking? Requested by a contractor juggling 15 sites who couldn\'t keep tabs on labor hours. Smart procurement? Designed for an admin drowning in thousands of orders and vendor relationships.',
        paragraph4: 'We took these real problems and built concrete solutions—tested and refined with the people who use them every day. The result is a platform that gets construction and delivers solutions that actually work, not just sound good on paper.'
      },
      values: {
        title: 'What We Stand For',
        subtitle: 'The principles behind every decision and every line of code.',
        practical: {
          title: 'Practical & Real',
          description: 'We only build features that solve actual jobsite problems. No fluff.'
        },
        users: {
          title: 'User-Driven',
          description: 'Development is guided by constant feedback from working engineers and contractors.'
        },
        support: {
          title: 'Always Available',
          description: 'A team that gets construction and responds fast, in Romanian, 24/7.'
        },
        innovation: {
          title: 'Always Improving',
          description: 'Continuous platform upgrades with AI and new tech—at no extra cost.'
        }
      },
      mission: {
        title: 'Our Mission',
        paragraph1: 'Digitize and transform construction in Romania with smart, accessible technology built for real jobsite needs.',
        paragraph2: 'We believe every builder—no matter their size—deserves enterprise-grade tools to cut waste, optimize resources, and boost profits.',
        paragraph3: 'We want managers to end each day knowing exactly what happened on site, what it cost, and how to do better tomorrow.',
        stats: {
          companies: {
            number: 'Dozens of',
            label: 'Active Companies'
          },
          users: {
            number: '1,000+',
            label: 'Daily Users'
          },
          projects: {
            number: '€15M+',
            label: 'Managed Projects'
          },
          satisfaction: {
            number: '98%',
            label: 'Customer Satisfaction'
          }
        }
      },
      benefits: {
        title: 'Why Builders Choose ControlMax',
        subtitle: 'Real benefits measured by companies using the platform.',
        efficiency: {
          title: '40% More Efficient',
          description: 'Automation cuts out repetitive tasks and slashes admin time nearly in half.'
        },
        reduction: {
          title: '30% Less Waste',
          description: 'Full visibility into resources and costs catches problems before they get expensive.'
        },
        ai: {
          title: 'AI That Gets Smarter',
          description: 'The system learns from each project, delivering better predictions and recommendations over time.'
        }
      },
      faq: {
        title: 'Frequently Asked Questions About ControlMax',
        subtitle: 'Everything you need to know about our company and platform.',
        q1: {
          question: 'Who is behind ControlMax and why can I trust this platform?',
          answer: 'ControlMax is developed by a mixed team of software engineers and construction professionals with combined experience of over 50 years in the industry. The founders worked directly on construction sites and understand the real challenges you face daily. The platform is used by dozens of companies in Romania managing projects with a total value of over €15 million. We have a 98% satisfaction rate and dedicated technical support in Romanian available 24/7. We are not a generic software company that made a product for construction - we are people from the industry who built the solution we ourselves needed.'
        },
        q2: {
          question: 'How does ControlMax differ from other construction management platforms?',
          answer: 'The fundamental difference is that ControlMax was built FROM direct construction site experience, not for it. While other solutions are generic platforms adapted for construction or complicated systems made for large corporations, we started from the specific needs of Romanian builders. EVERY FUNCTIONALITY comes from real problems encountered in the field and has been tested by active engineers and contractors. We do not force you to adapt your processes to the software - the software adapts to how you already work. Plus integrated artificial intelligence that continuously learns from your data and becomes more useful over time. And most importantly: fast implementation (2-4 weeks vs 6-12 months for other solutions) and affordable price for companies of any size.'
        },
        q3: {
          question: 'How long has ControlMax been on the market and is it a stable solution or still in development?',
          answer: 'ControlMax has been on the market since 2020 and the platform is perfectly stable and mature for production. In these years we have implemented the system in dozens of companies - from small contractors with 10 employees to large firms with 200+ employees and dozens of simultaneous construction sites. The platform processes thousands of transactions daily (time tracking, GPS locations, orders, invoices) without problems. STABILITY and RELIABILITY are priority #1 - we know you rely on the system for critical daily operations. At the same time, we CONTINUOUSLY improve the platform with new features based on your feedback, but all updates are thoroughly tested before release. You receive all new features for free without additional costs - your investment is protected long-term.'
        },
        q4: {
          question: 'How do you ensure data security and what happens to my company information?',
          answer: 'Data security is EXTREMELY serious for us. All data is stored in certified datacenters in the European Union (full GDPR compliance), military-grade AES-256 encryption for all stored and in-transit data (same standards used by banks), automatic daily backup in multiple geographic locations - your data is safe even in case of disaster, strictly controlled access through two-factor authentication (2FA) and granular role-based permissions. OWNERSHIP: You are 100% owner of your data. We only store and process it for you - we do not sell it, share it, or use it for anything other than your service. You can export all data anytime in standard format. CONFIDENTIALITY: Our team signs confidentiality agreements and has limited access only for technical support when you explicitly request it. Regular security audits performed by external companies. Impeccable track record - zero security breaches in all years of operation.'
        },
        q5: {
          question: 'What level of technical support and training does ControlMax offer and how easy is it to learn to use the system?',
          answer: 'Support and training are COMPLETELY included in the subscription at no extra cost. COMPLETE ONBOARDING: Dedicated consultant who configures the system specifically for your needs, live training sessions (online or at your location) for the entire team, video materials and detailed written documentation in Romanian. CONTINUOUS 24/7 SUPPORT: Romanian support team available by phone, email, and in-app chat, average response time under 2 hours (faster for critical emergencies), specialists who understand construction and speak your language - no outsourcing abroad. EASE OF USE: Interface is intuitive - most users learn basic functions in 30 minutes, simple mobile app for construction sites - workers use it without complicated training, no advanced IT knowledge needed. UPDATES AND NEW TRAINING: When we add new features, you receive notifications and mini-tutorials, periodic refresh sessions to use the system to its maximum. Your success = our success, so we invest seriously in your support.'
        }
      },
      cta: {
        title: 'Ready to Build Smarter?',
        description: 'Join the dozens of companies already building better with ControlMax.',
        button: 'Get a Free Demo'
      }
    },
    demo: {
      badge: 'See ControlMax in Action',
      title: 'Book a Free Demo',
      subtitle: 'Schedule a 30-minute personalized session and see how ControlMax can transform how you run your business',
      whatYouWillDiscover: {
        title: 'What you\'ll see in the demo',
        platformInAction: {
          title: 'Live walkthrough',
          description: 'See the features in action and how they work in real scenarios'
        },
        customSolutions: {
          title: 'Tailored solutions',
          description: 'We assess your needs and show you what will help most'
        },
        answers: {
          title: 'Get answers',
          description: 'We cover implementation, pricing, and ROI'
        },
        implementationPlan: {
          title: 'Clear roadmap',
          description: 'Leave with a step-by-step integration plan'
        }
      },
      noObligations: {
        title: 'No Strings Attached',
        description: 'The demo is commitment-free. See the platform up close and decide on your own timeline.',
        duration: 'Duration: 30 minutes'
      },
      form: {
        title: 'Complete the form',
        lastName: 'Last Name',
        lastNamePlaceholder: 'Smith',
        firstName: 'First Name',
        firstNamePlaceholder: 'John',
        email: 'Email',
        emailPlaceholder: 'john.smith@company.com',
        phone: 'Phone',
        phonePlaceholder: '+1 234 567 890',
        company: 'Company',
        companyPlaceholder: 'My Company Inc',
        numberOfEmployees: 'Number of employees',
        selectPlaceholder: 'Select',
        employeesRange: {
          '1-10': '1-10',
          '11-50': '11-50',
          '51-200': '51-200',
          '201-500': '201-500',
          '500+': '500+'
        },
        industry: 'Industry',
        industries: {
          construction: 'Construction',
          services: 'Services',
          logistics: 'Logistics',
          production: 'Production',
          other: 'Other'
        },
        message: 'Message (optional)',
        messagePlaceholder: 'Tell us more about your needs...',
        submitButton: 'Submit Request',
        submittingButton: 'Submitting...',
        privacyText: 'By submitting the form, you agree to the',
        privacyLink: 'Privacy Policy',
        required: '*'
      },
      success: {
        title: 'Thanks for your interest!',
        description: 'Request received. A specialist will reach out within 24 hours to schedule your personalized demo.',
        whatNext: {
          title: 'What happens next?',
          step1: 'A consultant will contact you to find a time that works',
          step2: 'We\'ll prepare a demo tailored to your needs',
          step3: 'You\'ll see the platform in action with real examples'
        },
        backButton: 'Back to homepage'
      },
      error: 'Something went wrong. Please try again.'
    },
    footer: {
      tagline: 'Built by Construction Pros, for Construction Pros',
      solutions: 'Solutions',
      company: 'Company',
      legal: 'Legal',
      terms: 'Terms & Conditions',
      privacy: 'Privacy Policy',
      gdpr: 'GDPR',
      newsletter: {
        title: 'Stay in the Loop',
        description: 'Get monthly tips for construction pros and industry updates.',
        placeholder: 'Your email',
        button: 'Subscribe',
        success: 'You\'re subscribed!',
        error: 'Something went wrong. Try again.'
      },
      rights: 'All rights reserved.'
    },
    centreCost: {
      seo: {
        title: 'Construction Cost Centers Multi-Project Multi-Site | Financial Management Cost Tracking Software',
        description: 'Cost center system for construction companies 10-700 employees: multi-project budget tracking, automated expense reporting, project profitability analysis, real-time site cost monitoring. Total financial control on projects, tenders, execution. Labor material equipment cost allocation to cost centers. Enterprise multi-site budget software Romania.',
        keywords: 'construction cost centers, cost center, cost center software, project financial management, construction site budget, cost center software romania, project cost tracking, construction financial reporting, site profitability analysis, project budget control, construction expense management, cost center platform, site budget application, construction financial system, real-time cost monitoring, construction project management software romania, labor cost allocation, material cost tracking, equipment cost allocation, multi-project budget, multi-site cost tracking, budget vs actual, project profitability, financial dashboard construction, budget overrun alerts, construction financial software, enterprise budget management, cost centers 10 employees, cost centers 100 employees, cost centers 200 employees, cost centers 500 employees',
        structuredData: {
          name: 'Cost Centers - ControlMax',
          description: 'Advanced cost center management for construction projects with budget tracking and automated reporting',
          serviceType: 'Construction Financial Management Software'
        }
      },
      hero: {
        badge: 'Heart of the system',
        title: 'Cost Centers',
        subtitle: 'From tender to execution and closure. Every project fully tracked, every cost under control.'
      },
      intro: {
        whatIs: {
          title: 'What is a Cost Center?',
          description1: 'A cost center is a complete project tracked from the tender moment until closure. It centralizes all financial, administrative and operational data for clear and precise records.',
          description2: 'Every field activity, every invoice, every time entry automatically links to the corresponding cost center, giving you total control over profitability.'
        },
        whyEssential: {
          title: 'Why are they essential?',
          description1: 'Cost centers transform chaos in a construction company into perfect order. You know exactly how much each project costs, where the money goes and what the real profits are.',
          description2: 'No more estimating, no more guessing. You have concrete data, updated in real-time, for fast and correct decisions.'
        }
      },
      lifecycle: {
        title: 'Complete lifecycle of a Cost Center',
        subtitle: 'From opportunity to final profit',
        phases: {
          bidding: {
            number: '1',
            title: 'Tender Phase',
            items: [
              'Creating the cost center from tender documentation',
              'Complete record of documents: preparation, submission, status tracking',
              'Automatic reminders for submission deadlines',
              'Notifications for winning or rejection'
            ]
          },
          offer: {
            number: '2',
            title: 'Offer Import',
            items: [
              'Loading the winning offer into the system',
              'Automatic extraction of work types',
              'Structuring by categories: materials, labor, equipment, transport, machinery',
              'Setting planned costs for each category'
            ]
          },
          execution: {
            number: '3',
            title: 'Execution Phase',
            items: [
              'Reminders for contract start, performance bonds',
              'All field reports automatically link to the cost center',
              'Time entries, fuel consumption, material purchases accumulated instantly',
              'Clear evidence: planned costs vs. actual costs in real-time'
            ]
          }
        }
      },
      transparency: {
        title: 'Total transparency over costs',
        subtitle: 'Every field action instantly transforms into precise financial data',
        features: {
          realTime: {
            title: 'Real-time updates',
            description: 'Worker clocks in, data reaches the cost center instantly. Driver refuels, cost appears automatically. No delays, no transcription errors.'
          },
          fullControl: {
            title: 'Complete control',
            description: 'See exactly where the money goes, compare planned vs. actual, identify deviations before they become problems. Decisions based on concrete data, not estimates.'
          },
          smartAlerts: {
            title: 'Smart alerts',
            description: 'Receive automatic notifications for budget overruns, warranty deadlines, contract endings. Never miss an important deadline again.'
          },
          fullHistory: {
            title: 'Complete history',
            description: 'Every change, every cost, every document. Everything archived and instantly accessible. Perfect for audits, reports and future analyses.'
          }
        }
      },
      dashboard: {
        badge: 'Live data from field',
        title: 'Cost Centers Dashboard in action',
        subtitle: 'Every time entry, fuel consumption and purchase automatically updated from the field. Accurate data, fast decisions.',
        heading: 'Cost Centers Dashboard',
        subheading: 'Data automatically updated from field',
        live: 'Live',
        projects: {
          bucharest: 'Bucharest North Site',
          cluj: 'Cluj Project',
          timisoara: 'Timisoara Site'
        },
        costs: {
          materials: 'Materials:',
          labor: 'Labor:',
          equipment: 'Equipment:'
        },
        updated: {
          now2min: 'Updated 2 min ago',
          now5min: 'Updated 5 min ago',
          now1min: 'Updated 1 min ago'
        },
        liveData: {
          title: 'Live data from field',
          subtitle: 'Automatic update on every action',
          features: [
            'Time entries and attendance synced instantly from team phones',
            'Refuelings automatically integrated from Rompetrol & OMV',
            'GPS tracking equipment with real-time consumption',
            'Material purchases automatically linked to cost centers'
          ]
        }
      },
      benefits: {
        title: 'Concrete Benefits of the Cost Center System',
        subtitle: 'Real data from companies using cost centers in construction project management',
        stats: {
          costReduction: {
            percentage: '34%',
            title: 'Operational cost reduction per project',
            description: 'Through waste elimination and resource optimization in the first 6 months'
          },
          realTime: {
            title: 'Real-time',
            subtitle: 'Complete project cost visibility',
            description: 'Data automatically updated from field without delay or errors'
          },
          accuracy: {
            percentage: '95%',
            title: 'Financial reporting accuracy',
            description: 'Manual error elimination and instant automated reconciliations'
          }
        },
        useCases: {
          title: 'Concrete Use Cases',
          cases: [
            {
              company: 'Bucharest Construction Company - 15 Sites',
              result: '28% operational cost reduction through rapid identification of unprofitable sites and resource reallocation in the first month'
            },
            {
              company: 'Regional Builder Cluj - 8 Projects',
              result: 'Complete profitability visibility per project enabled informed negotiations and 12% average margin increase in 4 months'
            },
            {
              company: 'Infrastructure Company - 25 Contracts',
              result: 'Automatic cost allocation to centers and consolidated reporting reduced administrative time from 40 hours to 3 hours monthly'
            }
          ]
        },
        whyEssential: {
          title: 'Why Cost Centers are Essential',
          reasons: [
            {
              title: 'Real budget control:',
              description: 'Every penny spent on a project is tracked and automatically compared with the planned budget'
            },
            {
              title: 'Fast informed decision:',
              description: 'Know instantly which projects are profitable and which consume resources without return'
            },
            {
              title: 'Automated stakeholder reporting:',
              description: 'Instantly generate financial reports for investors, banks, auditors without manual work'
            },
            {
              title: 'Learning and optimization:',
              description: 'Comparative analysis between projects identifies best practices and recurring problems for continuous improvement'
            },
            {
              title: 'Compliance and audit:',
              description: 'Complete history of changes and expense justifications for tax compliance and stress-free audits'
            }
          ]
        }
      },
      faq: {
        title: 'Frequently Asked Questions about Cost Centers in Construction',
        subtitle: 'Answers to the most common questions about implementing and using cost centers for projects',
        questions: [
          {
            question: 'What exactly is a cost center in the construction context and why do I need it?',
            answer: 'A cost center in construction is a separate accounting entity that groups all expenses and revenues associated with a specific project (site, contract, tender). Every employee time entry, material invoice, fuel cost, delivery note is automatically allocated to the respective cost center. This way you know EXACTLY how much each project costs in real-time, can compare profitability between sites, and make informed decisions about resource allocation. Without cost centers, all expenses are mixed and you cannot know which project is profitable and which is losing money until the end of the month when it\'s too late to intervene.'
          },
          {
            question: 'How are costs automatically allocated to cost centers in the system?',
            answer: 'Allocation is 100% automatic through direct integrations: 1) Employee time tracking - when clocking in, selects the project/site and labor cost is instantly allocated to the respective cost center. 2) Fleet GPS tracking - the system automatically detects which site zone the vehicle is in and allocates fuel proportionally to time spent. 3) Material procurement - when photographing delivery note, you select the cost center and the system makes the automatic link. 4) Supplier invoices - upon entry/OCR scanning, you specify the project and allocation is instant. Zero manual calculations, zero Excel, everything tracked in real-time.'
          },
          {
            question: 'Can I have an employee or equipment working on multiple cost centers simultaneously?',
            answer: 'Yes, the system perfectly handles this common scenario in construction. An employee working 3 days on Site A and 2 days on Site B will have labor cost automatically allocated proportionally (3/5 on A, 2/5 on B) based on daily time entries where they select the project. Similarly, a bulldozer working in the morning on one site and afternoon on another will have costs automatically split based on GPS tracking that detects which zone the equipment is in. Fuel, maintenance expenses, depreciation cost - all are split proportionally without any manual intervention.'
          },
          {
            question: 'What reports can I automatically generate for cost centers and how often are they updated?',
            answer: 'Reports are generated instantly on demand with live data from the field: 1) Profitability dashboard - total costs vs revenues per center, updated in real-time with each transaction. 2) Comparative project report - side-by-side view for all sites to see which perform. 3) Budget vs Actual - automatic comparison between planned costs from offer and actual cumulated expenses. 4) Category breakdown - exact detail of how much you spent on materials, labor, equipment, transport per project. 5) Financial export - formatted reports for accounting, investors, auditors in Excel/PDF. All updated in real-time, no more waiting for month-end.'
          },
          {
            question: 'How do cost centers help identify problems in projects before they become critical?',
            answer: 'The system automatically monitors each cost center and generates real-time alerts: 1) Budget overrun alert - if a category (e.g., materials) exceeds the planned budget by X%, you receive instant notification to investigate. 2) Negative trend alert - if the daily consumption rate indicates you will exceed the total budget at the end, the system warns you in advance 2-3 weeks before. 3) Comparison with similar projects - if a site has significantly higher costs than comparable others, you see the discrepancy instantly. 4) Consumption anomalies - unexpected spike in fuel, excessive time entries, unplanned purchases - all detected automatically. This way you can intervene quickly with corrective measures when the problem is still small, not after 2 months when you\'ve already lost 50,000 RON.'
          },
          {
            question: 'How long does it take to configure and become operational with cost centers for my projects?',
            answer: 'Initial setup takes 2-5 working days: Day 1-2: Creating cost center structure - add each active project/site, configure expense categories (materials, labor, etc), define planned budgets if you have won offers. Day 3: Optional history import - you can import the last 1-3 months of data for context or start fresh. Day 4-5: Team training - site managers learn to allocate time entries and materials to centers, managers learn to interpret reports. From day 6 the system is live and cost centers populate automatically with each field action. In the first week you already see complete visibility on each project. For large companies with 20+ projects, the process may take 2 weeks.'
          },
          {
            question: 'What happens to the data when a project is completed? Can I do retrospective analysis?',
            answer: 'When a project closes, the cost center moves to \'Completed\' status but all data remains permanently accessible for retrospective analysis. You have complete access to: 1) Complete financial history - all expenses and revenues with granular details from start to finish. 2) Budget vs actual comparison - see exactly where you deviated from planning and by how much. 3) Archived documents - all invoices, delivery notes, reports, work statements linked to the project. 4) Profitability analysis - exact calculation of net profit, margins, ROI for completed project. 5) Template for future - you can use real data as basis for estimates in similar future tenders. The system automatically generates a \'Project Closure Report\' with all essential KPIs that becomes learning material for the team. Ideal for audits, litigation, or simply to improve estimates on future projects.'
          }
        ]
      },
      cta: {
        title: 'Transform your projects into profit centers',
        subtitle: 'See how cost centers can completely transform your project management and profitability',
        button: 'Request live presentation'
      }
    },
    hrPontaj: {
      badge: 'HR & Time Tracking Module',
      title: {
        line1: 'HR & Time Tracking',
        line2: '100% Automated'
      },
      subtitle: 'From facial recognition time tracking to automatic contract generation. Everything in one modern and intuitive platform.',
      dashboard: {
        title: 'Live HR Dashboard',
        live: 'LIVE',
        stats: {
          activeEmployees: 'Active Employees',
          attendanceToday: 'Attendance Today',
          onLeave: 'On Leave'
        },
        cards: {
          timeEntries: {
            title: 'Time Entries Processed',
            subtitle: 'Last hour'
          },
          approvedLeave: {
            title: 'Leave Approved',
            subtitle: 'This month'
          },
          documents: {
            title: 'Documents Generated',
            subtitle: 'This week'
          }
        }
      },
      mainFeatures: {
        smartTimeTracking: {
          title: 'Smart Phone Time Tracking',
          description: 'One click and done! Facial recognition + GPS for maximum security. Every employee sees their worked hours in real time.'
        },
        supervisorControl: {
          title: 'Total Control for Supervisors',
          description: 'Managers mark team attendance instantly, even from the field. Fast validation, zero paperwork, zero headaches.'
        },
        autoPayroll: {
          title: '100% Automatic Payroll',
          description: 'The system calculates everything automatically: worked hours, custom allowances, per diems. Direct export for bank transfer.'
        },
        zeroMissing: {
          title: 'Zero Missing Documents',
          description: 'Contracts generated automatically on hire. Addendums created instantly on changes. Everything stored digitally, perfectly organized.'
        }
      },
      allInOne: {
        title: 'Everything You Need in One Place',
        subtitle: 'No more juggling 5 different platforms. Everything centralized, everything automatic.',
        features: {
          leaveManagement: {
            title: 'Leave & Absences',
            description: 'All types of leave managed automatically. Requests approved instantly. Perfect synchronization with time tracking and payroll.'
          },
          instantDocuments: {
            title: 'Documents Generated Instantly',
            description: 'New contract? Certificate? Addendum? Everything generated automatically with one click. Custom templates for your company.'
          },
          transparentHistory: {
            title: 'Transparent History',
            description: 'See complete history of each employee: contracts, changes, leave, time entries. Organized chronologically, easy to access.'
          },
          onDemandReports: {
            title: 'Reports On Demand',
            description: 'Complete employee report in 2 seconds. Daily reports with detailed activity. Export to Excel, PDF or CSV.'
          }
        }
      },
      trackingMethods: {
        title: 'Clock In Your Way',
        subtitle: 'Total flexibility. Choose the method that fits your team.',
        methods: {
          app: {
            title: 'From App',
            description: 'The fastest method: open the app, it recognizes you automatically and you\'re clocked in. 3 seconds, done!'
          },
          gps: {
            title: 'With GPS Verification',
            description: 'Perfect for mobile teams. Automatic location confirmation + facial recognition for maximum security.'
          },
          supervisor: {
            title: 'Through Supervisor',
            description: 'Site manager or supervisor quickly marks the entire team. Ideal for large groups.'
          },
          webTerminal: {
            title: 'Web or Terminal',
            description: 'Classic time tracking from browser or physical terminal at office entrance. Simple and efficient.'
          }
        }
      },
      guaranteedResults: {
        title: 'Guaranteed Results',
        subtitle: 'Our clients see major improvements from the first month of use.',
        benefits: {
          timeSaved: {
            stat: '-90%',
            title: 'HR Time Saved',
            description: 'HR department no longer wastes hours on manual time tracking, calculations and documents. Everything on autopilot.'
          },
          accuracy: {
            stat: '100%',
            title: 'Total Accuracy',
            description: 'Zero errors in time tracking. Zero errors in salaries. Zero lost documents. Math never lies.'
          },
          disputes: {
            stat: '0',
            title: 'Arguments & Disputes',
            description: 'Everything transparent and verifiable. Employees see exactly their worked hours. No more \'but I worked more\'.'
          },
          access: {
            stat: '24/7',
            title: 'Non-Stop Access',
            description: 'Any employee can check time entries, request leave or download documents from their phone. Anytime, anywhere.'
          }
        }
      },
      howItWorks: {
        title: 'How Does the Electronic Time Tracking System Work?',
        subtitle: 'Quick implementation in 3 simple steps. No complicated installations or lengthy training.',
        steps: {
          setup: {
            number: '1',
            title: 'Instant Setup',
            description: 'You add employees to the system, set work schedules and time tracking policies. Everything is done from the browser in maximum 30 minutes. The system adapts to any organizational structure.'
          },
          mobileInstall: {
            number: '2',
            title: 'Mobile App Installation',
            description: 'Employees install the app on their phone (Android or iOS). First clock-in activates facial recognition and GPS. Zero training needed - interface is extremely intuitive.'
          },
          autoMonitoring: {
            number: '3',
            title: 'Automatic Monitoring',
            description: 'From here everything goes on autopilot: time entries validated instantly, hours calculated automatically, reports generated on demand, salaries prepared for export. You just monitor the dashboard.'
          }
        }
      },
      industries: {
        title: 'Perfect For Any Industry',
        subtitle: 'Versatile solution adapted to the specific needs of each industry.',
        list: {
          construction: {
            title: 'Construction & Sites',
            description: 'Mobile time tracking with GPS for field teams. Tracking multiple locations simultaneously. Automatic reporting for labor inspections. Management of per diems and travel.'
          },
          retail: {
            title: 'Retail & Stores',
            description: 'Flexible time tracking for shifts and rotations. Irregular schedule management. Automatic calculation of night and holiday allowances.'
          },
          production: {
            title: 'Production & Factories',
            description: 'Terminal time tracking at entrance or tablets in production sections. Tracking on production lines. Detailed reports by cost centers and products.'
          },
          services: {
            title: 'Services & Consulting',
            description: 'Remote time tracking for work from home. Time tracking on projects and clients. Automatic invoicing based on worked hours. Export to your existing systems.'
          },
          horeca: {
            title: 'Horeca & Tourism',
            description: 'Fast time tracking for seasonal staff. Flexible shift management. Automatic calculation of overtime. Labor legislation compliance.'
          },
          logistics: {
            title: 'Logistics & Transport',
            description: 'Time tracking for drivers and warehouse workers. Fleet tracking with GPS. Route and trip management. Per diem calculation and rest time according to legislation.'
          }
        }
      },
      faq: {
        title: 'Frequently Asked Questions About Electronic Time Tracking',
        subtitle: 'Answers to the most common questions about our HR time tracking system.',
        questions: {
          compliance: {
            question: 'Is the time tracking system compatible with Romanian legislation and labor inspection requirements?',
            answer: 'Yes, our system is 100% compliant with the Labor Code and Romanian Labor Inspection requirements. It maintains complete time tracking history, allows exports in formats required by inspections, and documents all changes for audit. Each clock-in is accompanied by timestamp and GPS location for verification.'
          },
          fraud: {
            question: 'How does the system prevent time tracking fraud (clocking in from other locations or for other people)?',
            answer: 'The system uses mandatory facial recognition for each clock-in and verifies GPS location in real time. You can set allowed geographic zones for clocking in - if the employee is not in the defined area, the clock-in is not registered. Each clock-in also includes the unique device ID for additional tracking.'
          },
          forgotPunch: {
            question: 'What happens if an employee forgets to clock in or the phone runs out of battery?',
            answer: 'The supervisor or HR department can manually correct time entries. The system keeps complete history of all modifications - who made the change, when and why. The employee can also request a correction through the app, and the manager approves or rejects it with one click.'
          },
          flexibleSchedule: {
            question: 'Can I use the time tracking system for teams with flexible schedule or remote work?',
            answer: 'Absolutely! The system supports any type of schedule: fixed, flexible, remote, hybrid, shifts, rotations. For remote work, you can disable GPS verification and rely only on facial recognition. Each employee can have different time tracking settings based on contract type.'
          },
          implementation: {
            question: 'How long does implementation take and when can I start using the system?',
            answer: 'Basic implementation takes under 1 hour: you add employees, set schedules, they install the app. On the same day you can have the first time entry registered. For advanced configurations (integrations with other systems, complex allowance settings) we can provide dedicated implementation support.'
          },
          integration: {
            question: 'Does the system integrate with our current payroll or accounting software?',
            answer: 'Yes, we offer API integrations with most popular payroll and accounting systems in Romania. If there is no native integration, you can export time entries to Excel, CSV or other formats compatible with any system. Data is structured and standardized for easy import.'
          },
          security: {
            question: 'What security and privacy guarantees does the system offer for employee data?',
            answer: 'All data is encrypted (SSL/TLS), stored in secure cloud with automatic backup, and 100% GDPR compliant. Only authorized persons have access to data, with complete access logs. Each company has a separate instance - your data never mixes with others. We also offer signed confidentiality agreements.'
          },
          pricing: {
            question: 'What are the costs? Are there hidden fees or installation costs?',
            answer: 'The price is transparent: monthly subscription per active employee, no installation or setup costs. No mandatory long-term contracts - you can cancel anytime. Included in price: mobile apps, technical support, automatic updates, backup and security.'
          }
        }
      },
      cta: {
        title: 'Ready to Get Rid of HR Stress?',
        subtitle: 'Over 500 companies have already made the switch. See live how everything works.',
        button: 'Free Presentation'
      }
    },
    common: {
      learnMore: 'Learn More',
      readMore: 'Read More',
      backToHome: 'Back Home',
      loading: 'Loading...',
      error: 'An error occurred',
      success: 'Success!',
      live: 'Live',
      updated: 'Updated',
      ago: 'ago'
    },
    logistica: {
      meta: {
        title: 'GPS Fleet Tracking Construction Logistics | Rompetrol OMV Integration Waybills Fuel Consumption Transport Costs',
        description: 'Real-time fleet GPS tracking system with Rompetrol and OMV API integration. Logistics transport software with live vehicle monitoring, automatic fuel consumption tracking, instant waybill generation, advanced geofencing. GPS fleet solution for construction, freight transport, courier, field services. Guaranteed 25-30% transport cost reduction. Manage entire fleet from cloud: live GPS tracking on map, location alerts, distance reports, route deviation detection. Total fuel control: consumption limits, overage alerts, own station monitoring, cross-check verification API fueling vs driver reports. Complete fleet document management: ITP RCA insurance vignettes driving licenses, automatic expiration alerts 30 days in advance. Vehicle maintenance history: invoices parts service repairs tires batteries filters oil, component wear prediction, preventive scheduling. Automatic cost center allocation by project sites, accounting export client billing. Live fleet KPI dashboard, custom reports, payroll system integration. GPS fleet software Romania for SMEs and corporations.',
        keywords: 'fleet gps tracking software, real-time vehicle monitoring system, fleet gps romania, fleet tracking application, construction fleet gps, logistics transport software, live vehicle monitoring, truck car equipment gps tracking, rompetrol api integration, omv api integration, automatic fuel consumption tracking, automatic waybill generation, fleet geofencing, gps location alerts, fleet management software romania, cloud fleet management, android ios vehicle tracking, fleet gps tracker installation, distance monitoring, gps route report, vehicle trip history, route deviation detection, fleet fuel control, fuel consumption limits alerts, own fuel station monitoring, cross-check fueling verification, fuel refueling timesheet, driver vehicle consumption reports, abnormal fuel consumption alerts, fuel theft leak detection, fleet document management itp rca, vehicle document expiration alerts, fleet insurance monitoring, electronic vignette management, driving license expiration alert, vehicle maintenance history, auto service invoices, parts replacement history components, tire battery wear prediction, preventive maintenance planning, total vehicle ownership costs, project cost center allocation, site transport cost reporting, fleet accounting export, client trip billing, ITI compliant waybills legislation, ITM labor inspection reports, live fleet kpi dashboard, custom fleet reports, logistics system integration, driver payroll synchronization, courier delivery fleet gps, freight transport fleet tracking, construction equipment fleet monitoring, excavator bulldozer construction equipment gps, field service team tracking, fleet route optimization fuel economy, transport operational cost reduction, sme fleet software romania, large corporate fleet gps system, scalable fleet management solution, secure cloud gps tracking backup, fleet reports excel pdf export, android ios driver mobile app, push notification alerts drivers managers, technical support implementation training, transparent monthly fleet subscription pricing, free gps tracking system demo',
        ogImage: 'https://images.pexels.com/photos/1098460/pexels-photo-1098460.jpeg?auto=compress&cs=tinysrgb&w=1200',
        structuredData: {
          name: 'GPS Logistics - ControlMax',
          description: 'GPS fleet tracking software with real-time vehicle monitoring and fuel tracking',
          serviceType: 'GPS Fleet Tracking Software'
        }
      },
      hero: {
        badge: 'Logistics & Fleet Module',
        title1: 'Complete Fleet',
        title2: 'Management System',
        subtitle: 'Direct Rompetrol & OMV API integration. Refuelings come automatically, waybills generated instantly, costs allocated to cost centers. Total automated control.'
      },
      dashboard: {
        title: 'Live Fleet Dashboard',
        liveGps: 'LIVE GPS',
        activeVehicles: 'Active Vehicles',
        inMotion: 'In Motion',
        activeAlerts: 'Active Alerts',
        kmToday: 'Km Driven Today',
        allVehicles: 'All vehicles',
        autoFuelingsToday: 'Auto Refuelings Today',
        apiIntegration: 'Rompetrol & OMV API',
        maintenanceCosts: 'Maintenance Costs',
        thisMonth: 'This month'
      },
      mainFeatures: {
        gps: {
          title: 'GPS + Advanced Geofencing',
          description: 'Live 24/7 tracking on map. Automatic time tracking when entering/leaving site (geofencing). Complete route history + instant deviation alerts.'
        },
        apiIntegration: {
          title: 'Rompetrol & OMV API Integration',
          description: 'Refuelings come AUTOMATICALLY to the platform via direct API from supplier. Cross-checked with driver reports. Waybills generated instantly.'
        },
        aiInvoices: {
          title: 'AI For Maintenance Invoices',
          description: 'Take photo of invoice → AI automatically extracts parts replaced. Associates with correct vehicle, integrates into maintenance history.'
        },
        fuelControl: {
          title: 'Total Fuel Control',
          description: 'Maximum consumption limits + automatic alerts. Own station monitoring. Reports for each cost center. Instant anomaly detection.'
        }
      },
      apiSection: {
        badge: 'DIRECT API INTEGRATION',
        title: 'Rompetrol & OMV Direct In Platform',
        description: 'The only platform in Romania with direct API integration. Refuelings come automatically into system, cross-checked with driver reports, waybills generated instantly.',
        process: {
          step1: 'Driver refuels at Rompetrol or OMV with fleet card',
          step2: 'Transaction appears AUTOMATICALLY in platform via API within seconds',
          step3: 'Cross-checked with driver report → discrepancies = instant alert',
          step4: 'Waybills generated automatically + costs to cost centers'
        },
        liveCard: {
          title: 'Live API Refuelings',
          subtitle: 'Automatic synchronization',
          vehicle1: 'B-123-ABC',
          location1: 'Rompetrol Pipera',
          time1: '2 min ago',
          vehicle2: 'B-456-DEF',
          location2: 'OMV Unirii',
          time2: '15 min ago'
        }
      },
      premiumFeatures: {
        title: 'Premium Fleet Features',
        subtitle: 'Everything you need for total control over your fleet.',
        documents: {
          title: 'Documents & Alerts',
          description: 'ITP, RCA, vignettes, driving licenses monitoring. Automatic alerts 30 days before expiration. Zero fines.'
        },
        unauthorized: {
          title: 'Unauthorized Use Detection',
          description: 'Instant alert if vehicle moves outside schedule. Notification upon leaving permitted zones. Maximum security.'
        },
        components: {
          title: 'Accessories & Components',
          description: 'Complete monitoring: tires, batteries, filters, oil. History for each component. Prediction when replacement needed.'
        },
        costCenters: {
          title: 'Automatic Cost Center Allocation',
          description: 'Each refueling allocates AUTOMATICALLY to corresponding site cost center. Instant per-project reports. Ready accounting export.'
        }
      },
      fuelManagement: {
        title: 'Expert Level Fuel Management',
        subtitle: 'Absolute control over the largest operational cost.',
        limits: {
          title: 'Consumption Limits & Alerts',
          description: 'Set maximum consumption limit per vehicle. Instant alert if exceeded. Automatic leak or theft detection.'
        },
        ownStations: {
          title: 'Own Stations Monitored',
          description: 'If you have own stations: tank level monitoring, refueling timesheet, vehicle consumption reports. Total control.'
        },
        analysis: {
          title: 'Advanced Consumption Analysis',
          description: 'Compare consumption by drivers, routes, vehicle types. Identify efficient drivers. Optimization reports.'
        }
      },
      verification: {
        title: 'Automatic Verifications & Waybills',
        subtitle: 'System automatically compares API data with driver reports. Zero discrepancies.',
        crossCheck: {
          title: 'Automatic Cross-Check',
          description: 'Driver reports daily fuel consumed. System compares with Rompetrol/OMV API data. Discrepancy = instant alert.'
        },
        waybills: {
          title: 'Waybills Generated',
          description: 'Based on GPS + refuelings, complete waybills automatically generated for each vehicle. Instant PDF export for ITI or accounting.'
        },
        costAllocation: {
          title: 'Cost Center Allocation',
          description: 'Each refueling automatically associates with site/project vehicle was working on. Instant cost center reports.'
        }
      },
      benefits: {
        title: 'Measurable Results',
        subtitle: 'Our clients dramatically reduce fleet costs in the first months.',
        costReduction: {
          stat: '-25%',
          title: 'Total Cost Reduction',
          description: 'Route optimization + fuel control + preventive maintenance = guaranteed major monthly savings.'
        },
        fines: {
          stat: '0',
          title: 'Fines & Expired Documents',
          description: 'Automatic alerts completely eliminate fines for expired ITP/RCA. System notifies 30 days in advance.'
        },
        adminTime: {
          stat: '-95%',
          title: 'Fleet Administration Time',
          description: 'No more entering refuelings, checking documents, calculating costs manually. Everything automated.'
        },
        transparency: {
          stat: '100%',
          title: 'Total Transparency',
          description: 'Know anytime: where each car is, how much consumed, what costs, when service due. Zero surprises.'
        }
      },
      implementation: {
        title: 'How To Implement GPS Tracking System In 3 Simple Steps',
        subtitle: 'From order to complete live tracking in less than 48 hours.',
        step1: {
          number: '1',
          title: 'Order & GPS Installation',
          description: 'Order professional GPS devices for each fleet vehicle. Installation takes 30-60 minutes per vehicle by certified technicians. Devices connect to vehicle battery and ECU for complete data on consumption, mileage and engine status.'
        },
        step2: {
          number: '2',
          title: 'Cloud Platform Configuration',
          description: 'Add vehicles to platform, set consumption limits, geofencing zones for sites, cost centers for automatic allocations. Configure Rompetrol and OMV API integration for automatic refuelings. Complete setup takes 2-3 hours for average fleet.'
        },
        step3: {
          number: '3',
          title: 'Training & Go Live',
          description: 'Drivers receive quick training (30 minutes) for mobile app - daily fuel and km reporting. Managers learn to use dashboard for live monitoring. From here everything is automatic: GPS tracking, API refuelings, waybills generated, instant alerts.'
        }
      },
      fleetTypes: {
        title: 'GPS Tracking Solutions For Any Fleet Type',
        subtitle: 'Versatile system perfectly adapted to each industry specifics and vehicle types.',
        construction: {
          title: 'Construction & Site Fleets',
          description: 'GPS for trucks, excavators, bulldozers, concrete mixers. Geofencing on each site for automatic time tracking. Transport cost allocation to projects. Equipment monitoring for theft prevention. Waybills for ITI and ITM reporting.'
        },
        freight: {
          title: 'Freight Transport & Logistics',
          description: 'Long route tracking, fuel consumption monitoring on route, optimal trip planning for cost reduction. Route deviation or unauthorized stop alerts. Compliance reporting for driving and rest time legislation.'
        },
        courier: {
          title: 'Courier & Last Mile Delivery',
          description: 'Live tracking for all couriers simultaneously. Automatic route optimization for fuel economy. GPS-verified proof of delivery. Live dashboard for dispatcher. Complete delivery history for customer complaints.'
        },
        field: {
          title: 'Field Services & Interventions',
          description: 'Field service team tracking. Automatic nearest team allocation to customer. Response time measured precisely. Client billable hours reporting. Trip history for audit and optimization.'
        },
        sales: {
          title: 'Sales & Commercial Representatives',
          description: 'Client visit monitoring with automatic geofencing. Mileage reporting for travel reimbursement. Compliance verification for planned visit schedules. Territory and representative efficiency analysis.'
        },
        passenger: {
          title: 'Passenger Transport & Tourism',
          description: 'Tourism bus and minibus tracking. Compliance monitoring for itinerary and scheduled stops. Passenger safety with complete route history. Compliance reporting for passenger transport safety standards. Preventive maintenance for maximum safety.'
        }
      },
      faq: {
        title: 'Frequently Asked Questions About Fleet GPS Tracking',
        subtitle: 'Answers to the most common questions about our fleet monitoring system.',
        q1: {
          question: 'How does Rompetrol and OMV API integration work and what real benefits does it offer?',
          answer: 'Once the integration is configured (automatic process taking a few minutes), every refueling made by drivers with the fleet card at Rompetrol or OMV appears INSTANTLY in the platform - no more manual entry. The system automatically cross-checks between what the driver reports and what the API transaction shows. If discrepancies appear (driver forgot to report or reported incorrectly), you get instant alert. Waybills are automatically generated with all verified data, ready for ITI or accounting. Saves 5-10 hours/month just on fuel administration.'
        },
        q2: {
          question: 'What GPS devices do you recommend and how much does installation cost per vehicle?',
          answer: 'We work with top professional GPS devices (Teltonika, Queclink) with 3-5 year warranty. Device connects to vehicle battery and OBD2/CAN port for complete data: actual fuel consumption from ECU, exact mileage, engine status, precise GPS position. Installation takes 30-60 minutes per vehicle by certified technicians. For fleets 10+ vehicles we offer installation at client location for minimal activity disruption. Price includes device + installation + warranty + maintenance.'
        },
        q3: {
          question: 'Can I set geofencing zones for sites and receive automatic alerts when vehicles enter/exit?',
          answer: 'Absolutely! Geofencing is one of the most useful features for construction and field services. Draw site zones on map (polygons or circles) and set alerts: notification when vehicle enters/exits zone, automatic reports hours spent on site, vehicle time tracking per location. You can automatically allocate transport costs to that site cost center. System keeps complete history for audit and client billing.'
        },
        q4: {
          question: 'How does the system detect abnormal fuel consumption or possible thefts?',
          answer: 'System continuously monitors actual consumption vs theoretical consumption (based on km, vehicle type, road conditions). Set maximum consumption limits per vehicle - if exceeded, get instant alert. For vehicles with tank sensors, detects sudden level drops not matching refuelings (possible theft or leak). Also compares consumption between drivers for same vehicle type - quickly identify inefficient driving or possible vehicle technical issues.'
        },
        q5: {
          question: 'Does the system help with compliance for waybills and ITM/ITI reporting?',
          answer: 'Yes, Romanian legislation-compliant waybills are automatically generated: complete GPS route, API-verified refuelings, exact km driven from ECU, trip purpose (site/client), driver and vehicle. PDF export ready for driver signature for ITI. For ITM, complete reports regarding safety standards compliance, driving and rest time (for freight transport), preventive maintenance history. All data is timestamped and cannot be retroactively modified - complete audit trail.'
        },
        q6: {
          question: 'What happens if the GPS malfunctions or a vehicle enters an area without signal?',
          answer: 'GPS devices have internal memory and continue recording all data even without internet/GPS connection (tunnels, underground parking, mountain areas). When signal returns, data automatically synchronizes - you lose no km or information. In case of device malfunction, you receive alert and quick warranty replacement. For vehicles frequently going to areas without signal, we recommend devices with extended memory storing up to 6 months of data locally.'
        },
        q7: {
          question: 'Can I integrate the GPS system with current accounting software?',
          answer: 'Yes, we offer API integrations with most accounting systems in Romania (SAP, Oracle, Microsoft Dynamics, local software). You can automatically export waybills, fuel costs allocated to cost centers, service invoices, mileage reimbursements in format required by your system. If no native integration exists, Excel/CSV exports with custom structure for quick manual import. Data is standardized and includes all details needed for accounting.'
        },
        q8: {
          question: 'What are the costs and are there mandatory long-term contracts?',
          answer: 'Price is transparent: initial GPS device + installation cost (one-time), then monthly subscription per vehicle including: cloud platform, mobile apps, unlimited data storage, technical support, automatic updates, device maintenance. For Rompetrol/OMV API integration there is a small fixed monthly cost per fleet (not per vehicle). NO mandatory long-term contracts - we operate monthly, you can cancel anytime. For fleets 15+ vehicles, personalized offers with substantial discounts.'
        }
      },
      cta: {
        title: 'Ready To Control Your Fleet Perfectly?',
        description: 'See live how Rompetrol & OMV integration plus GPS tracking completely transforms your fleet management.',
        button: 'Free Presentation'
      }
    },
    achizitii: {
      hero: {
        badge: 'Procurement & Inventory Module',
        title1: 'Procurement Without',
        title2: 'Bureaucracy',
        subtitle: 'Take a photo of the delivery note, the rest is automatic. Zero typing, zero manual verification. Everything digitized instantly with AI.'
      },
      aiDemo: {
        title: 'AI Live Scanning',
        badge: 'AI ACTIVE',
        step1: 'Photo → Complete Data',
        step2: 'In less than 3 seconds',
        feature1: 'Automatic supplier data extraction',
        feature2: 'Reading products, quantities, prices',
        feature3: 'Automatic stock update',
        feature4: 'Instant digital archiving',
        statsTitle: 'This Month',
        stat1Label: 'Scanned Documents',
        stat2Label: 'Auto Orders',
        stat3Label: 'Total Value'
      },
      mainFeatures: {
        aiScan: {
          title: 'Instant AI Scanning',
          description: 'Take a photo of delivery note or invoice → AI automatically extracts ALL data: supplier, products, quantities, prices. Zero manual typing!'
        },
        autoReceipt: {
          title: 'Automatic Goods Receipt',
          description: 'When goods arrive: scan the delivery note → stocks update instantly → document is archived digitally. 30 seconds, done!'
        },
        autoOrders: {
          title: 'Automatically Generated Orders',
          description: 'When stock reaches minimum, the system generates the order itself. You just approve. Direct integration with suppliers.'
        },
        zeroShortages: {
          title: 'Zero Site Shortages',
          description: 'Smart alerts notify you before running out of materials. AI predicts consumption and suggests when to order.'
        }
      },
      manualWork: {
        title: 'Forget About Manual Work',
        subtitle: 'AI does the heavy lifting for you. You just supervise.'
      },
      advancedFeatures: {
        ocr: {
          title: 'Intelligent OCR',
          description: 'Text recognition from any delivery note, invoice or document. Works even with poor photos or crumpled documents.'
        },
        aiPrediction: {
          title: 'AI Needs Prediction',
          description: 'Analyzes historical consumption and work plan. Tells you exactly when and how much material to order to avoid running out.'
        },
        costOptimization: {
          title: 'Cost Optimization',
          description: 'Automatically compares supplier prices. Identifies savings opportunities. Cost reduction up to 20%.'
        },
        traceability: {
          title: '100% Traceability',
          description: 'Every material tracked from supplier to site. Quality certificates, batches, PVs. Everything digital and organized.'
        }
      },
      aiScanSection: {
        badge: 'EXCLUSIVE FEATURE',
        title: 'How Does AI Scanning Work?',
        subtitle: 'It\'s so simple it seems magical. But it\'s just advanced technology that saves you hours of tedious work.',
        step1: 'Take a photo of the delivery note with your phone when goods arrive',
        step2: 'AI reads and automatically extracts all data in 3 seconds',
        step3: 'Stocks update instantly, document is archived',
        step4: 'You just verify everything is correct. Done!',
        demoTitle: 'AI Scanning',
        demoSubtitle: 'Real-time processing',
        stat1Label: 'Data extraction accuracy',
        stat2Label: 'Average processing time',
        stat3Label: 'Documents scanned/month'
      },
      results: {
        title: 'Concrete Results',
        subtitle: 'Our clients save time and money from the first week.',
        timeReduction: {
          stat: '-95%',
          title: 'Reduced Administration Time',
          description: 'No more typing delivery notes, no more manually checking invoices, no more searching for documents. AI does everything automatically in seconds.'
        },
        zeroShortages: {
          stat: '0',
          title: 'Site Shortages',
          description: 'The predictive system and smart alerts guarantee that necessary materials are always available when needed.'
        },
        costReduction: {
          stat: '-20%',
          title: 'Reduced Costs',
          description: 'Order optimization, automatic price comparison and elimination of urgent purchases significantly reduce costs.'
        },
        traceability: {
          stat: '100%',
          title: 'Digital Traceability',
          description: 'Every delivery note, invoice and certificate archived digitally. Find any document in 2 seconds. Zero lost papers.'
        }
      },
      implementation: {
        title: 'Simple Implementation In 3 Steps',
        subtitle: 'From setup to complete digitization in less than 24 hours.',
        step1: {
          number: '1',
          title: 'Initial Configuration',
          description: 'Add your suppliers to the platform with contact details and commercial terms. Configure material categories and products you frequently use. Set up warehouses and locations where you manage inventory. Upload current initial stock (manual or Excel import). Setup completed in 2-3 hours.'
        },
        step2: {
          number: '2',
          title: 'AI Activation & Team Training',
          description: 'The AI system automatically learns to recognize invoices and delivery notes from your suppliers - the more documents you scan, the more accurate it becomes. Your team receives 30-60 minute training: how to scan documents with phone, how to verify data extracted by AI, how to manage orders and alerts. Everything is intuitive.'
        },
        step3: {
          number: '3',
          title: 'Go Live & Automation',
          description: 'Start scanning every delivery note/invoice when goods arrive - stocks update automatically. Set minimum stock levels for critical materials - system automatically generates orders when needed. All documents are instantly archived digitally. AI handles the heavy work, you just supervise and approve.'
        }
      },
      industries: {
        title: 'Solutions For Any Industry',
        subtitle: 'Versatile system perfectly adapted to each business specifics and workflow.',
        construction: {
          title: 'Construction & Sites',
          description: 'Material management across multiple sites simultaneously: cement, steel rebar, aggregates, paints, hardware. Scan delivery notes directly on site with phone. Material transfers between sites fully tracked. Allocate material costs to projects for client billing. Eliminate shortages or overstocking.'
        },
        production: {
          title: 'Production & Factories',
          description: 'Raw materials and production components management: metals, plastics, electronics, chemicals, packaging. Automatic supplier orders based on production plan. Complete batch and quality certificate traceability. Integration with your system for stock synchronization. Strict inventory control for audit and compliance.'
        },
        retail: {
          title: 'Retail & Stores',
          description: 'Finished product inventory management for sale: clothing, electronics, furniture, non-perishable food. Quick supplier invoice scanning with phone - stocks updated instantly. Automatic alerts when popular products reach minimum stock. Stock rotation reporting for procurement optimization. Fast inventory with barcode scanning.'
        },
        distribution: {
          title: 'Distribution & Wholesale',
          description: 'Complex management of thousands of SKUs in large warehouses: electrical, plumbing, tools, IT, FMCG. Fast goods receipt with delivery note scanning - automatic quantity verification vs order. Automatic transfers between warehouses based on regional demand. Advanced reporting: stock value, rotation, slow-moving products. Data export for accounting and billing.'
        },
        horeca: {
          title: 'HoReCa & Catering',
          description: 'Ingredient and consumables administration: food, beverages, packaging, cleaning products. Daily supplier invoice scanning - precise control of stock entries. AI consumption prediction based on history and event reservations. Perishable product expiration alerts. Complete traceability for ANPC compliance and sanitary inspections.'
        },
        services: {
          title: 'Services & Maintenance',
          description: 'Spare parts and service consumables management: filters, batteries, lubricants, tools, equipment. Quick supplier invoice scanning - instant stock update. Automatic orders for critical high-wear parts. Part usage history on client equipment for billing and reporting. Eliminate urgent part shortages during interventions.'
        }
      },
      faq: {
        title: 'Frequently Asked Questions About Procurement System',
        subtitle: 'Answers to the most common questions about our procurement platform.',
        q1: {
          question: 'How exactly does AI scanning of invoices and delivery notes work and how accurate is it?',
          answer: 'Our AI OCR (Optical Character Recognition) technology is specifically trained on Romanian commercial documents - invoices, delivery notes, fiscal receipts. When you take a photo of a document, AI automatically identifies the document type, extracts supplier data (name, CUI, address), reads the product/material table (name, UM, quantity, unit price, value), recognizes totals and VAT. Average accuracy is 99.2% for clear documents. Works even with photos taken in poor conditions (low light, folded document). In 2-3 seconds, all data is extracted and ready for verification. You just confirm everything is correct or quickly correct any errors (usually less than 5% of cases require minor adjustments).'
        },
        q2: {
          question: 'Can I manage inventory across multiple locations simultaneously - different warehouses, sites, stores?',
          answer: 'Absolutely! The system supports unlimited multi-location management. You define each warehouse, site, store or work point as a separate location. Each material/product has independent stock at each location - you instantly see where you have what quantity. You can make transfers between locations (with automatically generated transfer document). Centralized dashboard shows consolidated stocks across all locations plus breakdown for each. You can set different minimum stock levels at each location. Automatic alerts consider possible transfers between locations. Reports can be generated globally or filtered by specific locations.'
        },
        q3: {
          question: 'Can the system automatically generate orders to suppliers when stock drops below minimum level?',
          answer: 'Yes, this is one of the key features for eliminating shortages. For each material/product you set: minimum stock level (safety stock), optimal order quantity (economic lot), preferred supplier and alternative suppliers. When stock reaches minimum level, system automatically generates an order with set quantity to preferred supplier. Order can be configured to be automatically sent via email to supplier or await manager approval (depends on your policy). For advanced prediction, AI analyzes historical consumption and future work plan - suggests proactive orders before you actually reach minimum stock. You can also have direct API integrations with suppliers who accept automatic electronic orders.'
        },
        q4: {
          question: 'How does the system help reduce procurement costs and identify savings?',
          answer: 'The system offers multiple cost optimization mechanisms: 1) Automatically compares prices for same material from different suppliers - suggests supplier with best price. 2) Identifies volume discount opportunities - when total quantity needed across multiple sites justifies large order with discount. 3) Analyzes purchase history and detects abnormal price variations - alerts if supplier has significantly raised prices. 4) Eliminates expensive urgent purchases through prediction and proactive timely orders. 5) Reduces losses from expired or degraded materials through optimal stock rotation (FIFO/FEFO). 6) Detailed reports by category, supplier, project - identify where you spend most and where you can negotiate better. Our clients report real savings of 15-25% in first year.'
        },
        q5: {
          question: 'How does the system ensure complete material traceability from supplier to site/production?',
          answer: 'Each stock entry through delivery note/invoice scanning stores: supplier, delivery date, delivery note number, lot number (if applicable), digitally attached quality certificate, purchase price, initial storage location. At each material movement (transfer between locations, consumption on site/production order, supplier return, inventory/adjustment), system records: who, when, from where, where, how much, reason. For materials with special requirements (mandatory quality certificates, batches, expiration), you can attach digital documents - certificates, approvals, technical sheets, PVs. At any time you can see complete history of a material: where it was procured, where it stayed in warehouse, how long, where it was finally used. For audit, compliance or client complaints, instantly extract complete traceability reports. All data is timestamped and cannot be retroactively modified - complete audit trail for official inspections.'
        },
        q6: {
          question: 'Can I integrate the system with current accounting software we use?',
          answer: 'Yes, we offer multiple integration options. For popular accounting systems in Romania (SAP Business One, Oracle NetSuite, Microsoft Dynamics, Saga, WizCount, SmartBill, Facturis), we have ready-made connectors - activation in few hours. Integration automatically synchronizes: scanned invoices and delivery notes become stock entries, generated orders are transmitted to the procurement module, stocks can synchronize bidirectionally, new items can be imported from your system. For custom or less common systems, we offer fully documented open REST API - your IT team can develop integration. Alternatives: scheduled automatic exports in Excel/CSV format with customizable structure for import into your system, or manual export on demand. Exported data is standardized and includes all details required by accounting: supplier CUI, invoice number, date, products with codes, quantities, prices, VAT.'
        },
        q7: {
          question: 'What happens if AI extracts wrong data from a scanned invoice or delivery note?',
          answer: 'The system is built with human verification in loop. After AI extracts data from scanned document, it is presented to you for confirmation in simple interface. You see original scanned document next to extracted data - you can visually compare quickly. If you notice an error (e.g., AI read 15 instead of 18 pieces), you correct it instantly directly in interface - modification takes 2-3 seconds. When you save, correct data is recorded and AI learns from your correction - next time will be more accurate for similar documents. For new suppliers or documents with unusual layout, initial accuracy may be lower (85-90%), but grows rapidly as you scan more documents from same supplier. In practice, for recurring suppliers, you quickly reach 99%+ accuracy and practically just confirm without modifying anything. Even with verification, process is 10x faster than complete manual typing.'
        },
        q8: {
          question: 'What are the costs and what is included in subscription? Are there document or user limits?',
          answer: 'Price is transparent and predictable: fixed monthly subscription based on number of locations/warehouses and monthly transaction volume (number of scanned documents and stock movements). All features included: unlimited AI OCR for document scanning, multi-location management, automatic orders, AI prediction, advanced reporting, integrations with your accounting systems, mobile app for scanning, secure cloud storage with backup, permanent technical support, automatic updates. NO hidden costs or extra modules with separate payment. NO user limits - your whole team can use system (site managers, warehouse workers, procurement managers, accountants). NO artificial limitations on number of suppliers, products, categories. For small businesses (1-2 locations, under 200 documents/month), entry-level plans at affordable price. For large corporations (10+ locations, thousands documents/month), personalized enterprise offers with volume discounts.'
        }
      },
      cta: {
        title: 'Ready To Get Rid Of Papers?',
        subtitle: 'See live how a simple photo completely transforms your procurement management.',
        button: 'Free Presentation'
      }
    },
    echipamente: {
      seo: {
        title: 'Construction Equipment Machinery Management | GPS Tracking Maintenance Fixed Assets Operating Costs',
        description: 'Equipment and machinery management system for construction companies 10-700 employees: site equipment tracking, maintenance planning, GPS equipment tracking, operating costs, fixed assets management, depreciation, equipment allocation to projects. 30% operating cost reduction. Software Romania.',
        keywords: 'construction equipment management, equipment management software, machinery management, site equipment tracking, construction equipment tracking, equipment inventory, equipment maintenance, maintenance planning, predictive maintenance, GPS equipment tracking, equipment GPS, equipment operating costs, machinery operating costs, fixed assets management, fixed assets software, equipment depreciation, equipment allocation to project, multi-site equipment, equipment management romania, equipment management system, equipment management application, tools management, equipment compliance, equipment inspections, equipment management software sme, equipment 10 employees, equipment 100 employees, equipment 200 employees, equipment 500 employees, operating cost reduction, real-time equipment monitoring',
        ogImage: 'https://images.pexels.com/photos/1169754/pexels-photo-1169754.jpeg?auto=compress&cs=tinysrgb&w=1200',
        structuredData: {
          name: 'Equipment Management - ControlMax',
          description: 'Equipment and machinery management software for construction with maintenance planning',
          serviceType: 'Construction Equipment Management Software'
        }
      },
      hero: {
        badge: 'Equipment Inventory Module',
        title1: 'Intelligent Management',
        title2: 'Machinery & Equipment',
        subtitle: 'Complete equipment records, AI predictive maintenance and usage optimization. Maximize your equipment profitability.'
      },
      dashboard: {
        title: 'Equipment Fleet',
        stats: {
          totalEquipment: 'Total Equipment',
          operational: 'Operational',
          inService: 'In Service'
        },
        equipment: {
          excavator: 'Caterpillar 320 Excavator',
          crane: '25T Mobile Crane',
          bulldozer: 'Komatsu D65 Bulldozer'
        },
        status: {
          operational: 'Operational',
          service: 'In Service'
        },
        hoursLabel: 'operating hours',
        alert: {
          title: '3 Equipment require maintenance',
          subtitle: 'In the next 7 days'
        }
      },
      features: {
        inventory: {
          title: 'Complete Digital Inventory',
          description: 'Detailed records for each equipment: technical data, documents, certifications, complete history. QR codes for quick identification.'
        },
        maintenance: {
          title: 'AI Predictive Maintenance',
          description: 'Intelligent algorithms analyze operating hours, usage conditions and age to precisely predict when service is needed. Prevents breakdowns.'
        },
        scheduling: {
          title: 'Automatic Service Scheduling',
          description: 'Automatic scheduling of periodic maintenance and technical inspections. Advance alerts for deadlines. Integration with partner service centers.'
        },
        optimization: {
          title: 'Usage Optimization',
          description: 'Usage analysis for each equipment. Reallocation suggestions to maximize profitability. Automatic depreciation calculation.'
        }
      },
      advancedFeatures: {
        title: 'Advanced Features',
        tracking: {
          title: 'Operating Hours Tracking',
          description: 'Automatic monitoring of hours worked for each equipment. Automatic depreciation and cost per hour calculation. Detailed project reporting.'
        },
        history: {
          title: 'Intervention History',
          description: 'Complete register of all interventions: maintenance, repairs, replaced parts. Detailed costs and service providers.'
        },
        allocation: {
          title: 'Intelligent Allocation',
          description: 'AI suggestions for best equipment allocation on sites. Transport cost optimization and usage maximization.'
        }
      },
      benefits: {
        title: 'Measurable Benefits',
        costReduction: {
          stat: '35%',
          title: 'Maintenance Cost Reduction',
          description: 'Predictive maintenance prevents costly breakdowns and optimizes service intervals, significantly reducing expenses.'
        },
        uptime: {
          stat: '50%',
          title: 'Operational Time Increase',
          description: 'Intelligent service planning minimizes downtime and maximizes equipment availability.'
        },
        savings: {
          stat: '€25,000',
          title: 'Monthly Savings',
          description: 'Usage optimization, breakdown reduction and better service negotiation generate substantial savings.'
        },
        compliance: {
          stat: '100%',
          title: 'Legal Compliance',
          description: 'All certifications, technical inspections and documents up to date. Automatic deadline alerts. Zero risk of fines.'
        }
      },
      faq: {
        title: 'Frequently Asked Questions About Equipment Management',
        subtitle: 'Answers to the most common questions about our equipment and machinery management system.',
        q1: {
          question: 'How exactly does AI predictive maintenance work and how accurate is it in anticipating breakdowns?',
          answer: 'Our predictive maintenance system uses advanced machine learning algorithms trained on millions of industry data points plus your specific equipment data. The AI continuously analyzes: total operating hours and different load types (normal, intensive, idle), operating conditions (temperature, humidity, terrain type), equipment age and normal wear according to manufacturer specifications, history of previous interventions and types of defects encountered, replaced parts and replacement frequency. Based on this data, AI calculates the probability of a breakdown in the next 30/60/90 days and recommends preventive interventions BEFORE the problem appears. Average accuracy is 85-90% - the system correctly identifies 9 out of 10 future problems and prevents costly breakdowns. The more you use the system on your equipment, the more AI learns specific patterns and becomes even more accurate. Concrete benefit: you reduce unexpected breakdowns by 70-80% and transform emergency repairs into predictable scheduled service.'
        },
        q2: {
          question: 'Can I track the real-time location and status of my equipment across all sites?',
          answer: 'Yes, the system offers complete tracking and total visibility over your equipment fleet. GPS LOCATION: Each equipment can be equipped with GPS tracker (optional) - see on map exactly where each equipment is in real time, complete route and movement history (to detect unauthorized use), automatic alerts if equipment leaves authorized area (geofencing). OPERATIONAL STATUS: Live dashboard with status of each equipment: operational on site X, in transport to site Y, in scheduled/emergency service, station/parking/storage. OPERATING HOURS: Automatic counting of hours worked daily (through sensors or site manager reporting), automatic calculation of hours remaining until maintenance, comparison of actual usage vs maximum capacity (idle time, optimal usage, overload). AVAILABILITY: Quick view of which equipment is free for new allocation, intelligent planning - system suggests when to move equipment from low-activity site to high-demand one. Access everything from mobile app - see anytime, anywhere your entire equipment fleet and make quick reallocation decisions.'
        },
        q3: {
          question: 'How does the system manage technical inspection certifications, technical documents and legal deadlines for each equipment?',
          answer: 'The system maintains a complete digital archive and 100% compliance for each equipment. DIGITAL DOCUMENTATION: For each equipment you store: registration certificate/equipment identity card, technical inspection certificates with complete history, special permits (lifting, crane, hazardous transport ADR), manufacturer technical documentation (operation manual, specifications, diagrams), metrological verification certificates (scales, measuring devices), insurance (CASCO, liability for vehicles). AUTOMATIC DEADLINES: The system constantly monitors all expiration dates and sends alerts 90/60/30/7 days in advance for technical inspections, technical certificates, temporary permits, insurance and policies. SERVICE SCHEDULING: Integration with partner service centers - automatic scheduling of inspections and periodic checks from system, complete record of each inspection performed. COMPLIANCE: Instant compliance reporting for entire fleet - know anytime how many equipment have up-to-date documentation, visible alerts for equipment with legal risk (expired/expiring document), block allocation of equipment without valid documents on site. Zero risk of fines for missing documentation or expired certificates.'
        },
        q4: {
          question: 'Does the system integrate with existing GPS tracking or other hardware solutions we already use?',
          answer: 'Yes, we offer maximum flexibility and integration with most existing systems and hardware. GPS TRACKING: Native integration with popular GPS trackers - Teltonika, Concox, Queclink, Calamp, Meitrack through standard protocols, automatically imports position and data from your current trackers (no need to buy new ones), or use our recommended tracker with installation and integration included. TELEMATICS SYSTEMS: Integration with manufacturer platforms - Caterpillar VisionLink, Komatsu KOMTRAX, Volvo CareTrack, JCB LiveLink, automatic synchronization of technical data and operating hours directly from manufacturer, avoid manual entry - data comes automatically from telematics systems. IoT SENSORS: Connection to temperature, pressure, fuel consumption, vibration sensors for advanced monitoring, real-time data for AI predictive maintenance, instant alerts for abnormal parameters. OPEN API: For custom or less common systems we offer fully documented REST API, your IT team can develop specific integrations, webhooks for critical events (urgent service, unauthorized movement). DATA IMPORT: You can import complete history from old systems - Excel, CSV or other formats, assisted migration - we help with data transfer and initial configuration.'
        },
        q5: {
          question: 'How does the system help optimize equipment costs and what financial reporting does it offer?',
          answer: 'The system offers complete financial analysis and concrete cost optimization tools. OPERATING COSTS: Detailed record of all expenses for each equipment: fuel (actual vs standard consumption, anomaly detection), spare parts and consumables, service and repair labor, insurance and taxes, depreciation calculated automatically according to standards. PROFITABILITY: Automatic calculation of cost/operating hour for each equipment, billing to projects - how much usage actually costs on each site, comparison of actual cost vs billed rate (see profitability), identification of unprofitable equipment (operating cost too high vs usage). USAGE OPTIMIZATION: Usage analysis - see which equipment sits idle and which is overloaded, intelligent reallocation suggestions - move underutilized equipment to high-demand sites, calculation of optimal sale/replacement moment - when costs exceed equipment value. RENTAL vs PURCHASE DECISION: Comparative analysis - when it is more profitable to rent equipment than buy it, rented equipment tracking - ensures deadline compliance and avoids penalty costs. REPORTING: Detailed total cost of ownership (TCO) reports for each equipment, top equipment by profitability/costs, maintenance budget forecast for next year, Excel/PDF export for financial analysis and accounting.'
        },
        q6: {
          question: 'Can I manage small equipment and tools not just large machinery and how is inventory done?',
          answer: 'Yes, the system manages ALL equipment categories regardless of size or value. LARGE MACHINERY: Excavators, bulldozers, cranes, dump trucks - with GPS tracking, predictive maintenance, operating hours, technical inspections and all advanced features. MEDIUM MACHINERY: Generators, compressors, concrete pumps, small cranes, lifting platforms - complete records, scheduled service, site allocation. TOOLS AND POWER TOOLS: Grinders, saws, core drills, hammer drills - digital inventory with QR/barcode codes, tracking who has what tool on what site, loan and return records. SAFETY EQUIPMENT: Ladders, scaffolding, guardrails, safety harnesses, helmets - mandatory periodic checks, compliance certificates and periodic tests. SIMPLE INVENTORY: QR code generation for each equipment (print and stick on equipment), scanning with mobile app - complete inventory in minutes not days, instant reporting of what is missing or defective. CUSTOM CATEGORIES: Create categories specific to your needs, define custom fields for each equipment type, set personalized maintenance rules. Complete control from excavator to rotary hammer drill.'
        },
        q7: {
          question: 'What reporting and dashboards does the system offer and can I customize the indicators I am interested in?',
          answer: 'The system offers complete interactive dashboards and extremely flexible reporting. PREDEFINED DASHBOARDS: General fleet overview - total equipment, operational vs service, urgent alerts, maintenance status - scheduled maintenance, overdue maintenance, forecast costs, usage - underutilized equipment, availability, hours worked, compliance - overdue inspections, expired certificates, missing documentation. DETAILED REPORTS: Complete financial report - costs by equipment/category/period with trends and comparisons, maintenance history - all interventions with costs and parts, usage and profitability - cost/hour, usage rate, profit generated, legal compliance - document status all equipment. TOTAL CUSTOMIZATION: Build your own dashboards - choose exactly the indicators you are interested in, multiple filtering by: equipment category, site/location, period (today, week, month, year), status (operational, service, available), interactive charts - bars, lines, pie, evolution over time, visual alerts - red/yellow/green colors for quick status. EXPORT AND SHARING: Export to Excel/PDF/CSV with custom formatting, automatic report scheduling - receive email with chosen report daily/weekly/monthly, secure sharing with managers or external (temporary password-protected link). MOBILE ACCESS: All dashboards available in mobile app too - see key indicators anytime anywhere, push notifications for critical alerts.'
        },
        q8: {
          question: 'How difficult is the system implementation and what support does the ControlMax team offer for getting started?',
          answer: 'Implementation is simple and fast and our team supports you every step. ASSISTED ONBOARDING: Initial consultation - we analyze your specific needs and configure the optimal system, dedicated training session for your team - 2-4 hours interactive learning all features, live support at start - specialist available first 2 weeks for questions and adjustments. DATA IMPORT: We migrate data from your old systems or Excel - equipment history, maintenance, costs, we handle the whole process - you just provide data in any format, verification and validation - we ensure everything is correct before go-live. HARDWARE CONFIGURATION: Optimal cost-benefit GPS tracker recommendations, fleet installation and configuration (optional) - we come to you, testing and calibration - everything 100% functional from start. IMPLEMENTATION TIME: 1-2 days for small companies (under 20 equipment), 1 week for medium companies (20-100 equipment), 2-3 weeks for large fleets (100+ equipment) with complex processes. CONTINUOUS SUPPORT: Permanent technical support - email, phone, in-app chat, extensive knowledge base - articles, video tutorials, FAQ answers, regular updates - new features at no extra cost, periodic training refresh - knowledge refresher sessions. Your success is our priority - we help until everything works perfectly.'
        }
      },
      cta: {
        title: 'Ready To Maximize Profitability?',
        description: 'Discover how you can reduce costs by 35% and increase your equipment operational time.',
        button: 'Free Presentation'
      }
    },
    documente: {
      badge: 'Document Management Module',
      hero: {
        title: {
          line1: 'Intelligent Digital Archive',
          line2: 'Contracts & Company Documents'
        },
        subtitle: 'Scan or photograph → AI extracts ALL data automatically. Notifications for deadlines, guarantees, values. Never miss anything again.'
      },
      features: {
        aiExtraction: {
          title: 'AI Extracts Data From Scan/Photo',
          description: 'Upload the signed contract (scan/photo) → AI reads ALL data: parties, value, deadlines, guarantees, additional acts. Zero manual typing.'
        },
        notifications: {
          title: 'Automated Deadline Notifications',
          description: 'Instant alert when contract starts, expires, guarantees are due. If additional act changes value → notification if guarantee is too small.'
        },
        lifecycle: {
          title: 'Complete Contract Lifecycle',
          description: 'Contract → Start Order → Additional Acts → Notifications → Work Progress → Guarantees. EVERYTHING in one place, automatically organized.'
        },
        guarantees: {
          title: 'Guarantee & Value Control',
          description: 'Automatic monitoring of performance/participation guarantees. Alert if expiration is approaching or if value doesn\'t match the contract.'
        }
      },
      library: {
        title: 'Document Library',
        totalDocuments: 'Total Documents',
        addedThisMonth: 'Added This Month',
        upload: 'Upload',
        search: 'Search',
        documents: {
          contract: 'Mega Mall Site Contract',
          report: 'October Monthly Report',
          invoice: 'Invoice #2847 - Materials',
          processVerbal: 'Lot 3 Acceptance Report'
        },
        types: {
          contract: 'Contract',
          report: 'Report',
          invoice: 'Invoice',
          processVerbal: 'Process Verbal',
          guarantee: 'Guarantee',
          additionalAct: 'Additional Act',
          authorization: 'Authorization'
        },
        status: {
          active: 'Active',
          alert: 'Alert',
          new: 'New'
        }
      },
      processing: {
        badge: 'INTELLIGENT AI EXTRACTION',
        title: 'How Intelligent Processing Works',
        subtitle: 'Simply scan/photograph the document → AI does the rest.',
        steps: {
          step1: 'Scan or photograph the signed contract (any format: PDF, JPG, PNG)',
          step2: 'AI reads and automatically extracts: parties, value, deadline, guarantees, clauses',
          step3: 'All fields are automatically filled in the system. Zero typing!',
          step4: 'Add start orders, additional acts, notifications → All with AI'
        },
        example: {
          badge: 'DOCUMENT PROCESSED',
          beneficiary: 'Beneficiary:',
          value: 'Value:',
          deadline: 'Deadline:',
          guarantee: 'Guarantee:',
          company: 'MEGA CONSTRUCT LLC',
          amount: '1,850,000 RON',
          date: 'Dec 15, 2025',
          guaranteeAmount: '10% (185,000 RON)',
          verified: 'All data extracted and automatically verified'
        }
      },
      archives: {
        title: '2 Complete Archives',
        contracts: {
          title: 'Contract Archive By Cost Centers',
          description: 'Each site/project has its complete contract: initial contract, start orders, additional acts, progress reports, notifications, guarantees. EVERYTHING automatically organized.'
        },
        company: {
          title: 'Company Documents Archive',
          description: 'ISU, ISCIR, environmental authorizations, ISO certificates, licenses, insurance. Automatic notifications before expiration. Zero risk of missing anything.'
        }
      },
      notificationSystem: {
        title: 'Automated Notification System',
        subtitle: 'Nothing escapes you. The system automatically notifies you for every important deadline.',
        contractDeadlines: {
          title: 'Contract Deadlines',
          description: 'Alert before: contract start, expiration, intermediate deadlines, necessary extensions.'
        },
        guarantees: {
          title: 'Guarantees & Values',
          description: 'Monitor guarantee expiration. Alert if additional act changes value and guarantee becomes too small.'
        },
        authorizations: {
          title: 'Company Authorizations',
          description: 'ISU, ISCIR, environmental, ISO expiration. Notifies you 60/30/7 days in advance to have time for renewal.'
        }
      },
      benefits: {
        title: 'Why Clients Love This Module',
        zeroTyping: {
          stat: 'Zero',
          title: 'Manual Typing',
          description: 'AI reads and extracts ALL data from contracts. Just scan/photograph. Massive time savings.'
        },
        deadlines: {
          stat: '100%',
          title: 'Deadlines Met',
          description: 'Automatic notifications for EVERY deadline. Never forget guarantees, authorizations, extensions. Zero risk.'
        },
        lifecycle: {
          stat: '1 Place',
          title: 'Complete Lifecycle',
          description: 'Contract → Start Orders → Additional Acts → Progress Reports → Guarantees. EVERYTHING automatically organized by project.'
        },
        control: {
          stat: '2 Archives',
          title: 'Complete Control',
          description: 'Contract archive by cost centers + Company documents archive. Instant access to any document, anytime.'
        }
      },
      faq: {
        title: 'Frequently Asked Questions About Document Management',
        subtitle: 'Answers to the most common questions about our DMS system for construction.',
        q1: {
          question: 'How exactly does the AI automatic data extraction from contracts work and how accurate is it?',
          answer: 'Our system uses advanced AI OCR technology specially trained on contractual documents from Romania - construction contracts, supply, service provision. When you upload a scanned or photographed contract, the AI automatically identifies the document type and extracts key data: contracting parties (beneficiary, contractor, subcontractors), total value and by phases/tranches, deadlines (start date, completion, intermediate deadlines), guarantees (performance, participation, advance with percentage and value), important clauses (penalties, termination, force majeure), additional acts and subsequent modifications. Average accuracy is 95-98% for clear documents, also works with older scanned documents or phone photos. Extracted data is presented for quick verification - if AI misinterpreted something, you correct it instantly. The more contracts you scan, the more AI learns specifically for your company and becomes even more accurate.'
        },
        q2: {
          question: 'How does the notification system for deadlines and guarantees work and can I customize alerts?',
          answer: 'The system automatically monitors ALL deadlines in your contracts and sends notifications at critical moments. For contracts: alert at work start date, 30/15/7 days before expiration, when performance guarantee period expires. For guarantees: notifies you 60/30/7 days before expiration for extension/release, alert if an additional act modifies contract value and guarantee becomes too small (below contractual percentage). For company authorizations: alerts 60/30/7 days before ISU, ISCIR, ISO, environmental, license expiration. You can fully customize: set alert periods, choose channels (email, in-app notification, SMS), define who receives which alerts (project manager, director, accountant). You can also set custom notifications for any specific deadline in the contract.'
        },
        q3: {
          question: 'Can I organize documents by projects and separate cost centers and how does the hierarchy work?',
          answer: 'Yes, the system offers two perfectly organized parallel archives. CONTRACT Archive by Cost Centers: each site/project has its complete folder with all related documents - initial contract, work start order, all additional acts (chronological), work progress reports (monthly), notifications to/from beneficiary, process verbals, performance guarantees, material quality certificates. COMPANY DOCUMENTS Archive: organized by categories - authorizations (ISU, ISCIR, environmental), certificates (ISO, ANRE attestation), licenses and permits, insurance (RCA, CAR, RCG), legal documents (statute, AGA decisions), recurring supplier contracts. You can have unlimited custom sub-folders, tags for quick search, multiple filtering by: document type, date, value, deadline, responsible, status. Granular access control - set who sees which projects/categories.'
        },
        q4: {
          question: 'How does the system manage the complete lifecycle of a contract from signing to completion?',
          answer: 'The system automatically tracks the entire lifecycle. START: Upload signed contract → AI extracts all data → active contract in system. START ORDER: Upload start order (or system generates from template) → actual start data updates → deadline alerts activate. ADDITIONAL ACTS: Upload each additional act → AI detects what changed (deadline, value, clauses) → contract automatically updates → if value increases, alert for guarantee adjustment. WORK PROGRESS: Upload monthly progress reports → automatically associates with contract → tracking worked value vs contractual value → alert at 80%/90%/100% of value. NOTIFICATIONS: Upload or generate notifications to/from beneficiary → archived chronologically → response status tracking. RECEPTION & GUARANTEE: Upload reception PV → performance guarantee period begins → alert before expiration for guarantee release. Each document has timestamp and complete tracking - you know exactly the project history.'
        },
        q5: {
          question: 'Can I quickly search documents by text content not just by name or date?',
          answer: 'Yes, the system has advanced full-text search in all documents. Search by: exact text from contract (search in scanned content via OCR), contracting party names, contract/invoice numbers, values (ranges or exact), dates (periods, before/after), specific clauses (search \'penalty\' and find all contracts with penalties), document types, statuses, cost centers/projects. You can combine multiple criteria for precise search. Results show preview with found text highlighted and context. Save frequent searches as quick filters. \'Similar document\' function automatically finds similar documents by structure and content (useful for recurring contracts with same supplier). Search speed under 1 second even for thousands of documents - automatic full-text indexing.'
        },
        q6: {
          question: 'How is document security and confidentiality ensured and who has access to what?',
          answer: 'Security is priority #1. ENCRYPTION: All documents are encrypted in transit (SSL/TLS) and at rest (AES-256). Automatic daily incremental backup and complete weekly backup in multiple geographic locations. ACCESS CONTROL: Set granular permissions by role, department, project: who can view, edit, delete, share documents. Secure authentication with optional 2FA. AUDIT TRAIL: Complete and immutable history - who accessed which document when, who made what changes when. COMPLIANCE: 100% GDPR compliant - we process and store data in Romania/EU, never share with third parties. Signed confidentiality agreements. Definitive deletion function (right to be forgotten). SECURE SHARING: When sending documents externally, temporary links with automatic expiration and password, watermark on shared documents, log of who accessed the link. Optional: on-premise hosting if you prefer data on your servers.'
        },
        q7: {
          question: 'Does the DMS system integrate with our current accounting software?',
          answer: 'Yes, we offer integrations with most popular accounting systems in Romania. For SAP Business One, Oracle NetSuite, Microsoft Dynamics, Saga, WizCount, SmartBill, we have native connectors - bidirectional automatic synchronization: invoices scanned and processed by AI are automatically sent to accounting system with all details (supplier, amounts, VAT, due date), contracts and work progress reports sync with project management modules, generated documents (waybills, reports) export in compatible formats. For custom or less common systems, we offer fully documented open REST API - your IT team can develop the integration, webhooks for real-time events (new document, expired deadline). Alternatives: automatic scheduled exports in Excel/CSV/PDF with customizable structure, or manual export on demand with formatting according to your requirements. Exported data is standardized and includes all metadata needed for error-free import.'
        },
        q8: {
          question: 'What are the costs and what is included in the subscription? Are there storage or user limits?',
          answer: 'Price is transparent and predictable: fixed monthly subscription based on number of active users and required storage volume (GB of documents). INCLUDED in price: unlimited AI OCR for document processing, complete contract and company document management, automated notification system all types, advanced full-text search, role-based access control, complete audit trail, automatic secure cloud backup, web and mobile application, permanent technical support, automatic updates all features. NO hidden costs or paid extra modules. NO artificial limitations on: number of projects/cost centers, document categories, monthly searches, alerts/notifications. Storage space: starts from 100GB included, extensions at transparent prices if exceeded. For large companies (50+ users, large document volumes), customized enterprise offers with substantial discounts. NO mandatory long-term contracts - we operate monthly flexible.'
        }
      },
      cta: {
        title: 'Ready To Never Forget A Deadline Again?',
        description: 'See how AI automatically extracts data from contracts and notifies you for every important deadline.',
        button: 'Free Presentation'
      }
    },
    calculator: {
      seo: {
        title: 'Construction Loss Calculator ROI | Calculate Costs of Lack of Control Fuel Theft Fake Timecards',
        description: 'Construction loss calculator: estimate in 30 seconds how much lack of control costs you - administrative time, fuel theft, fake timecards, idle equipment, material losses. Instant result + detailed PDF report. Calculate ROI of implementing management software.',
        keywords: 'construction loss calculator, loss calculator construction, roi software, roi management system, management savings, loss calculation, costs of lack of control, fuel theft, fake timecards, idle equipment, material losses, lost time, roi calculator construction, cost reduction, loss report, savings calculator, hidden costs construction, site losses, loss assessment, company cost calculator, pdf loss report, software savings estimate'
      },
      hero: {
        badge: 'ROI Calculator',
        title: 'Calculate Your Current Losses',
        subtitle: 'Fill in 4 fields and see in 30 seconds how much lack of control over your company costs you'
      },
      form: {
        aboutCompany: 'About Your Company',
        aboutCompanyDesc: 'Your data remains confidential and is used only for calculation',
        employeesLabel: 'How many employees do you have on sites?',
        employeesPlaceholder: 'e.g.: 25',
        vehiclesLabel: 'How many equipment/vehicles do you have?',
        vehiclesPlaceholder: 'e.g.: 8',
        fuelLabel: 'Monthly fuel consumption (liters)?',
        fuelPlaceholder: 'e.g.: 5000',
        sitesLabel: 'How many active sites?',
        sitesPlaceholder: 'e.g.: 4',
        calculateButton: 'Calculate Loss →',
        guarantee: 'Instant result • Zero obligations • Zero spam'
      },
      results: {
        title: 'Your Result',
        subtitle: 'Based on your data, your company loses an estimated:',
        perYear: 'per year',
        breakdownTitle: 'Loss Breakdown:',
        adminTime: {
          label: 'Administrative time',
          formula: 'employees × 0.3 hours/day × 20 days × 50 RON × 12 months'
        },
        fuelTheft: {
          label: 'Fuel theft (15%)',
          formula: 'liters × 15% × 7 RON × 12 months'
        },
        fakeTimeCards: {
          label: 'Fake timecards (5%)',
          formula: 'employees × 3000 RON/month × 5% × 12 months'
        },
        materialLoss: {
          label: 'Material shortages and urgent orders',
          formula: 'sites × 800 RON/month × 12 months'
        },
        unprofitableSites: {
          label: 'Unprofitable sites stopped too late',
          formula: 'sites × 700 RON/month × 12 months'
        }
      },
      withControlMax: {
        title: 'With ControlMax:',
        investmentYear1: 'Year 1 investment:',
        implementation: 'Implementation',
        subscription: 'Subscription',
        monthlySubscription: '/month × 12',
        totalYear1: 'Year 1 total:',
        estimatedSavings: 'Estimated savings year 1:',
        netProfit: 'Year 1 net profit:',
        roi: 'ROI:',
        breakEven: 'Investment recovery:',
        month: 'Month',
        years: 'years',
        followingYears: 'Following years:',
        followingYearsDesc: 'Investment only',
        followingYearsSavings: 'Annual savings of',
        smallCompanyWarning: 'For your company\'s current size, the system might take more than a year to recover. Let\'s discuss your specific needs and find the best solution.'
      },
      emailForm: {
        title: 'Receive Detailed Analysis',
        subtitle: 'Leave us your email and we\'ll contact you for a personalized consultation about your company\'s situation.',
        emailLabel: 'Email',
        emailPlaceholder: 'name@company.ro',
        submitButton: 'Send and Schedule Consultation →',
        submitting: 'Sending...',
        error: 'An error occurred. Please contact us directly.',
        features: {
          consultation: 'Personalized consultation',
          recommendations: 'Concrete recommendations',
          noSpam: 'Zero spam'
        }
      },
      success: {
        title: 'Thank you!',
        message: 'We received your data. We will contact you within 24 hours for a personalized consultation.',
        callPrompt: 'Meanwhile, you can call us directly to discuss sooner:',
        phone: '+40 787 683 304'
      },
      callDirect: {
        title: 'Or call directly for a consultation:',
        phone: '+40 787 683 304'
      }
    },
    blog: {
      meta: {
        title: 'Blog - Construction Management Guides, Operational Control, GPS Fleet, Time Tracking | ControlMax Romania',
        description: 'Expert articles about construction management, cost optimization, operational control, GPS fleet tracking, electronic time tracking. Practical guides, case studies and best practices for construction in Romania.',
        keywords: 'construction blog romania, site management guide, construction management articles, electronic time tracking guide, gps fleet tutorial, construction cost optimization, project management blog, construction software articles',
        blogName: 'ControlMax Blog',
        blogDescription: 'Guides and articles about construction management, operational control, GPS and time tracking'
      },
      listing: {
        badge: 'Expert Knowledge',
        title: 'ControlMax Blog',
        subtitle: 'Complete guides, proven strategies and practical insights to optimize your construction business.',
        readTime: 'read',
        readArticle: 'Read article',
        ctaTitle: 'Want to Apply These Strategies?',
        ctaDescription: 'All strategies from our articles are implemented in ControlMax. See how they work in practice with a personalized demonstration.',
        ctaButton: 'Request Free Demo'
      },
      post: {
        backToBlog: 'Back to Blog',
        backToAllArticles: 'Back to all articles',
        readTime: 'read',
        calculateNow: 'Calculate Now',
        ctaTitle: 'Implement the Strategies from This Article',
        ctaDescription: 'See how ControlMax helps you apply all the strategies presented. Schedule a personalized demonstration - 30 minutes, zero obligations.',
        ctaButton: 'Request Free Demo'
      }
    },
    newsletter: {
      meta: {
        title: 'Newsletter - ControlMax',
        description: 'Subscribe to the ControlMax newsletter for the latest articles, tips, and news about business management software.'
      },
      header: {
        title: 'Get the Newsletter',
        subtitle: 'Fresh articles, practical guides, and business optimization insights delivered to your inbox.'
      },
      benefits: {
        articles: {
          title: 'Articles & Guides',
          description: 'Quality content on efficiency, financial management, and automation'
        },
        trends: {
          title: 'Trends & Insights',
          description: 'What\'s new in business software and tech'
        },
        caseStudies: {
          title: 'Case Studies',
          description: 'Real stories from companies that streamlined their operations'
        },
        solutions: {
          title: 'Practical Tips',
          description: 'Actionable advice to improve your business'
        }
      },
      recentArticles: {
        title: 'Recent Articles',
        viewAll: 'See All Articles'
      }
    },
    unsubscribe: {
      meta: {
        title: 'Unsubscribe - ControlMax Newsletter',
        description: 'Unsubscribe from the ControlMax newsletter'
      },
      loading: {
        title: 'Processing...',
        message: 'Just a moment.'
      },
      success: {
        title: 'You\'re Unsubscribed',
        message: '{email} has been unsubscribed.',
        regret: 'Sorry to see you go. You won\'t hear from us anymore.',
        resubscribeInfo: 'Changed your mind? You can always resubscribe.',
        resubscribeButton: 'Resubscribe',
        homeButton: 'Back to Homepage',
        deleteButton: 'Delete my data permanently',
        deleteWarning: 'This will permanently delete all your data from our system',
        confirmDelete: 'Are you sure? This will permanently delete all your data. This can\'t be undone.'
      },
      already: {
        title: 'Already Unsubscribed',
        message: '{email} is already unsubscribed.',
        noEmails: 'You won\'t receive emails from us.',
        resubscribeInfo: 'Want back in? You can resubscribe anytime.',
        resubscribeButton: 'Resubscribe',
        homeButton: 'Back to Homepage',
        deleteButton: 'Delete my data permanently',
        deleteWarning: 'This will permanently delete all your data from our system'
      },
      deleted: {
        title: 'Data Deleted',
        message: 'All your data has been permanently removed from our system.',
        futureInfo: 'Want to come back later? You can subscribe anytime.',
        subscribeButton: 'Subscribe',
        homeButton: 'Back to Homepage'
      },
      error: {
        title: 'Oops',
        message: 'That unsubscribe link is invalid or expired.',
        help: 'Still having trouble? Get in touch.',
        contactButton: 'Contact Us',
        homeButton: 'Back to Homepage',
        deleteError: 'Couldn\'t delete data. Try again.'
      }
    },
    gdpr: {
      meta: {
        title: 'GDPR Compliance - ControlMax',
        description: 'ControlMax is fully compliant with the General Data Protection Regulation (GDPR)'
      },
      header: {
        title: 'GDPR Compliance',
        subtitle: 'ControlMax is fully compliant with the General Data Protection Regulation (GDPR)'
      },
      commitment: {
        title: 'Our GDPR Commitment',
        content: 'ControlMax takes the protection of personal data with the utmost seriousness. We have implemented all necessary technical and organizational measures to ensure full GDPR compliance and to protect the rights of data subjects.'
      },
      principles: {
        title: 'GDPR Principles We Follow',
        legality: {
          title: '1. Lawfulness, Fairness and Transparency',
          content: 'We process data lawfully, fairly and transparently. We always inform you about what data we collect and why.'
        },
        purposeLimitation: {
          title: '2. Purpose Limitation',
          content: 'We collect data only for specific, explicit and legitimate purposes. We do not use it later in ways incompatible with these purposes.'
        },
        dataMinimization: {
          title: '3. Data Minimization',
          content: 'We collect only data that is adequate, relevant and limited to what is necessary for processing purposes.'
        },
        accuracy: {
          title: '4. Accuracy',
          content: 'We keep data accurate and up-to-date. Inaccurate data is deleted or corrected without delay.'
        },
        storageLimitation: {
          title: '5. Storage Limitation',
          content: 'We keep data only as long as necessary for the purposes for which it is processed.'
        },
        integrity: {
          title: '6. Integrity and Confidentiality',
          content: 'We process data in a manner that ensures appropriate security, including protection against unauthorized or unlawful processing.'
        }
      },
      rights: {
        title: 'Your GDPR Rights',
        access: {
          title: 'Right of Access',
          description: 'You have the right to obtain a copy of the personal data we process about you.'
        },
        rectification: {
          title: 'Right to Rectification',
          description: 'You can request the correction of inaccurate data or completion of incomplete data.'
        },
        erasure: {
          title: 'Right to Erasure ("Right to be Forgotten")',
          description: 'In certain circumstances, you can request the deletion of your personal data.'
        },
        restriction: {
          title: 'Right to Restriction of Processing',
          description: 'You can request limitation of how we process your data in certain situations.'
        },
        portability: {
          title: 'Right to Data Portability',
          description: 'You can request your data in a structured, commonly used and machine-readable format.'
        },
        objection: {
          title: 'Right to Object',
          description: 'You can object to processing of data based on legitimate interest or for direct marketing.'
        },
        withdraw: {
          title: 'Right to Withdraw Consent',
          description: 'Where processing is based on consent, you can withdraw it at any time.'
        }
      },
      security: {
        title: 'Security Measures',
        intro: 'We have implemented robust technical and organizational measures to protect data:',
        measures: {
          encryption: 'End-to-end encryption for data in transit and at rest',
          mfa: 'Multi-factor authentication available',
          rbac: 'Role-based access control (RBAC) for granular control',
          monitoring: 'Continuous monitoring and intrusion detection',
          audit: 'Complete audit trails for all sensitive operations',
          backup: 'Encrypted and regularly tested backups',
          training: 'Mandatory GDPR training for all staff'
        }
      },
      transfers: {
        title: 'International Transfers',
        content: 'Data is stored and processed in the European Union. If we use third-party providers outside the EU, we ensure that appropriate safeguards (standard contractual clauses or Privacy Shield certifications) exist to protect your data.'
      },
      breaches: {
        title: 'Data Security Breaches',
        content: 'In the event of a data security breach that poses a risk to your rights and freedoms, we will notify you within 72 hours as required by GDPR. We will also notify the relevant supervisory authorities.'
      },
      impact: {
        title: 'Impact Assessments',
        content: 'We conduct periodic Data Protection Impact Assessments (DPIA) for new features that may present high risks to the rights of data subjects, such as GPS tracking or automated decision processing.'
      },
      exercise: {
        title: 'How to Exercise Your Rights',
        intro: 'To exercise any of your GDPR rights, please contact us:',
        dpoTitle: 'Data Protection Officer (DPO)',
        email: 'Email: dpo@controlmax.ro',
        phone: 'Phone: +40 790 827 957',
        response: 'We will respond to your request within 30 days.'
      },
      authority: {
        title: 'Supervisory Authority',
        intro: 'If you believe your GDPR rights have been violated, you have the right to file a complaint with the competent supervisory authority:',
        name: 'National Supervisory Authority for Personal Data Processing (ANSPDCP)',
        website: 'Website: www.dataprotection.ro',
        email: 'Email: anspdcp@dataprotection.ro',
        phone: 'Phone: +40 21 252 5599'
      }
    },
    terms: {
      meta: {
        title: 'Terms and Conditions - ControlMax',
        description: 'Terms and conditions for using the ControlMax platform'
      },
      header: {
        title: 'Terms and Conditions',
        lastUpdated: 'Last updated: January 2025'
      },
      acceptance: {
        title: '1. Acceptance of Terms',
        content: 'By accessing and using the ControlMax platform, you agree to comply with these terms and conditions. If you do not agree with these terms, please do not use our services.'
      },
      services: {
        title: '2. Description of Services',
        intro: 'ControlMax offers a management software platform for companies in the construction and services sector, including but not limited to:',
        items: {
          hr: 'Human resources management and time tracking',
          gps: 'GPS tracking and fleet management',
          procurement: 'Procurement and inventory management',
          documents: 'Document and contract management',
          reporting: 'Reporting and business intelligence'
        }
      },
      accounts: {
        title: '3. User Accounts',
        paragraph1: 'To use ControlMax services, you must create an account. You are responsible for maintaining the confidentiality of your authentication credentials and for all activities conducted under your account.',
        paragraph2: 'You agree to provide accurate, current and complete information about your company and users.'
      },
      fees: {
        title: '4. Fees and Payments',
        paragraph1: 'Use of the ControlMax platform is subject to subscription fees established in the selected plan. All fees are exclusive of VAT, unless otherwise specified.',
        paragraph2: 'Payments are processed monthly or annually, depending on the chosen plan. Failure to make timely payments may result in service suspension.'
      },
      intellectual: {
        title: '5. Intellectual Property',
        paragraph1: 'The ControlMax platform, including but not limited to software, design, content, trademarks and logos, are the exclusive property of ControlMax and are protected by intellectual property laws.',
        paragraph2: 'Data you enter into the platform remains your property. ControlMax does not claim any rights to this data.'
      },
      liability: {
        title: '6. Limitation of Liability',
        paragraph1: 'ControlMax provides the platform "as is" and does not offer express or implied warranties regarding uninterrupted or error-free operation of services.',
        paragraph2: 'In no event shall ControlMax be liable for indirect, incidental, special or consequential damages resulting from use or inability to use the services.'
      },
      termination: {
        title: '7. Termination',
        paragraph1: 'You may terminate your account at any time by notifying the ControlMax team. Upon termination, you will have access to your data for a period of 30 days for export.',
        paragraph2: 'ControlMax reserves the right to suspend or terminate accounts that violate these terms and conditions.'
      },
      changes: {
        title: '8. Changes to Terms',
        content: 'ControlMax reserves the right to modify these terms at any time. Changes will be communicated via email 30 days before taking effect. Continued use of services after these changes constitutes acceptance of the new terms.'
      },
      law: {
        title: '9. Applicable Law',
        content: 'These terms and conditions are governed by the laws of Romania. Any dispute will be resolved in the competent courts of Romania.'
      },
      contact: {
        title: '10. Contact',
        content: 'For questions regarding these terms, please contact us at contact@controlmax.ro or at +40 790 827 957.'
      }
    },
    privacy: {
      meta: {
        title: 'Privacy Policy - ControlMax',
        description: 'ControlMax privacy policy and personal data protection'
      },
      header: {
        title: 'Privacy Policy',
        lastUpdated: 'Last updated: January 2025'
      },
      introduction: {
        title: '1. Introduction',
        paragraph1: 'ControlMax respects the confidentiality of your personal data and is committed to protecting the information we collect and process in accordance with the General Data Protection Regulation (GDPR) and applicable Romanian legislation.',
        paragraph2: 'This policy describes what data we collect, how we use it, how we protect it and what your rights are.'
      },
      dataCollected: {
        title: '2. Data Collected',
        intro: 'We collect the following categories of personal data:',
        items: {
          identification: '<strong>Identification data:</strong> name, surname, email address, phone number',
          company: '<strong>Company data:</strong> name, tax ID, address, contact details',
          authentication: '<strong>Authentication data:</strong> username, encrypted password',
          usage: '<strong>Usage data:</strong> access logs, IP addresses, browser type, device',
          location: '<strong>Location data:</strong> GPS coordinates for vehicle tracking and time tracking (only with explicit consent)',
          financial: '<strong>Financial data:</strong> payment and billing information (processed through PCI DSS certified third-party processors)'
        }
      },
      purpose: {
        title: '3. Purpose of Processing',
        intro: 'We use collected data for the following purposes:',
        items: {
          services: 'Providing ControlMax platform services',
          account: 'Account management and user authentication',
          payments: 'Payment processing and invoice issuance',
          communication: 'Customer communication and technical support',
          improvement: 'Service improvement and optimization',
          legal: 'Compliance with legal obligations',
          security: 'Fraud prevention and security assurance'
        }
      },
      legalBasis: {
        title: '4. Legal Basis for Processing',
        intro: 'We process your data on the following legal bases:',
        items: {
          contract: '<strong>Contract execution:</strong> to provide requested services',
          consent: '<strong>Consent:</strong> for certain optional features (e.g., GPS tracking)',
          legal: '<strong>Legal obligation:</strong> to comply with tax and legal requirements',
          legitimate: '<strong>Legitimate interest:</strong> for service improvement and fraud prevention'
        }
      },
      sharing: {
        title: '5. Data Sharing',
        intro: 'We do not sell, rent or share your personal data with third parties for marketing purposes. We may share data only in the following circumstances:',
        items: {
          providers: '<strong>Service providers:</strong> payment processors, cloud hosting services, email services (all comply with GDPR)',
          legal: '<strong>Legal obligations:</strong> public authorities when required by law',
          consent: '<strong>Explicit consent:</strong> when you have given consent for sharing'
        }
      },
      security: {
        title: '6. Data Security',
        intro: 'We implement technical and organizational measures to protect data:',
        items: {
          ssl: 'SSL/TLS encryption for data transmission',
          database: 'Database encryption',
          twoFactor: 'Two-factor authentication (2FA) available',
          monitoring: 'Continuous monitoring and security logs',
          access: 'Restricted data access only for authorized personnel',
          backup: 'Regular backups and disaster recovery plan'
        }
      },
      retention: {
        title: '7. Data Retention',
        content: 'We retain your personal data only as long as necessary to fulfill the purposes for which it was collected or in accordance with legal obligations (e.g., 10 years for tax documents). After account termination, data is deleted within 90 days, except what is necessary to comply with legal obligations.'
      },
      rights: {
        title: '8. Your Rights',
        intro: 'Under GDPR, you have the following rights:',
        items: {
          access: '<strong>Right of access:</strong> to obtain a copy of processed data',
          rectification: '<strong>Right to rectification:</strong> to correct inaccurate or incomplete data',
          erasure: '<strong>Right to erasure:</strong> to request data deletion ("right to be forgotten")',
          restriction: '<strong>Right to restriction:</strong> to limit processing under certain conditions',
          portability: '<strong>Right to portability:</strong> to receive data in a structured format',
          objection: '<strong>Right to object:</strong> to object to processing based on legitimate interest',
          withdraw: '<strong>Right to withdraw consent:</strong> at any time for consent-based processing'
        },
        contact: 'To exercise these rights, contact us at contact@controlmax.ro.'
      },
      cookies: {
        title: '9. Cookies',
        content: 'We use essential cookies for platform operation (authentication, preferences). We do not use marketing cookies without your explicit consent.'
      },
      changes: {
        title: '10. Policy Changes',
        content: 'We reserve the right to update this policy. We will notify you via email of any significant changes 30 days before implementation.'
      },
      dpo: {
        title: '11. DPO Contact',
        intro: 'Data Protection Officer (DPO):',
        email: 'Email: dpo@controlmax.ro',
        phone: 'Phone: +40 790 827 957'
      }
    }
  }
};

export type TranslationKey = keyof typeof translations.ro;
